/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AuthedRouteImport } from "./routes/_authed"
import { Route as EnrollQrJitRouteImport } from "./routes/enroll-qr-jit"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AuthedIndexRouteImport } from "./routes/_authed/index"
import { Route as AuthedAccountHealthRouteImport } from "./routes/_authed/account-health"
import { Route as AuthedPrivateAccessRouteImport } from "./routes/_authed/private-access"
import { Route as EnrollTokenRouteImport } from "./routes/enroll/$token"
import { Route as AuthedAdminsIndexRouteImport } from "./routes/_authed/admins/index"
import { Route as AuthedAdminsInviteRouteImport } from "./routes/_authed/admins/invite"
import { Route as AuthedApiKeysIndexRouteImport } from "./routes/_authed/api-keys/index"
import { Route as AuthedApiKeysNewRouteImport } from "./routes/_authed/api-keys/new"
import { Route as AuthedAuditIndexRouteImport } from "./routes/_authed/audit/index"
import { Route as AuthedAutomationAccountsIndexRouteImport } from "./routes/_authed/automation-accounts/index"
import { Route as AuthedAutomationAccountsIdRouteImport } from "./routes/_authed/automation-accounts/$id"
import { Route as AuthedAutomationAccountsNewRouteImport } from "./routes/_authed/automation-accounts/new"
import { Route as AuthedManagedIndexRouteImport } from "./routes/_authed/managed/index"
import { Route as AuthedManagedTeamsRouteImport } from "./routes/_authed/managed/teams"
import { Route as AuthedTenantRecordsSlugRouteImport } from "./routes/_authed/tenant-records/$slug"
import { Route as AuthedTenantsIndexRouteImport } from "./routes/_authed/tenants/index"
import { Route as AuthedTenantsSlugRouteImport } from "./routes/_authed/tenants/$slug"
import { Route as AuthedTenantsNewRouteImport } from "./routes/_authed/tenants/new"
import { Route as TSlugLoginRouteImport } from "./routes/t/$slug/login"
import { Route as TSlugRecoveryRouteImport } from "./routes/t/$slug/recovery"
import { Route as AuthedManagedTenantsSlugRouteImport } from "./routes/_authed/managed/tenants/$slug"
import { Route as AuthedTenantRecordsSlugIndexRouteImport } from "./routes/_authed/tenant-records/$slug/index"
import { Route as AuthedTenantRecordsSlugAccessRouteImport } from "./routes/_authed/tenant-records/$slug/access"
import { Route as AuthedTenantRecordsSlugEnrollmentIssuersRouteImport } from "./routes/_authed/tenant-records/$slug/enrollment-issuers"
import { Route as AuthedTenantRecordsSlugSubscriptionRouteImport } from "./routes/_authed/tenant-records/$slug/subscription"
import { Route as AuthedTenantsSlugIndexRouteImport } from "./routes/_authed/tenants/$slug/index"
import { Route as AuthedTenantsSlugAccessRequestsRouteImport } from "./routes/_authed/tenants/$slug/access-requests"
import { Route as AuthedTenantsSlugAuthenticationRouteImport } from "./routes/_authed/tenants/$slug/authentication"
import { Route as AuthedTenantsSlugEntitlementRouteImport } from "./routes/_authed/tenants/$slug/entitlement"
import { Route as AuthedTenantsSlugOauthDynregRouteImport } from "./routes/_authed/tenants/$slug/oauth-dynreg"
import { Route as AuthedTenantsSlugSettingsRouteImport } from "./routes/_authed/tenants/$slug/settings"
import { Route as TSlugLoginHelpRouteImport } from "./routes/t/$slug/login.help"
import { Route as TSlugRecoveryRequestRouteImport } from "./routes/t/$slug/recovery.request"
import { Route as AuthedTenantRecordsSlugAdministratorsIndexRouteImport } from "./routes/_authed/tenant-records/$slug/administrators/index"
import { Route as AuthedTenantRecordsSlugAdministratorsInviteRouteImport } from "./routes/_authed/tenant-records/$slug/administrators/invite"
import { Route as AuthedTenantsSlugAccessGovernanceIndexRouteImport } from "./routes/_authed/tenants/$slug/access-governance/index"
import { Route as AuthedTenantsSlugAccessGovernanceApprovalPoliciesRouteImport } from "./routes/_authed/tenants/$slug/access-governance/approval-policies"
import { Route as AuthedTenantsSlugAccessGovernanceApproversRouteImport } from "./routes/_authed/tenants/$slug/access-governance/approvers"
import { Route as AuthedTenantsSlugAccessGovernanceHistoryRouteImport } from "./routes/_authed/tenants/$slug/access-governance/history"
import { Route as AuthedTenantsSlugAccessGovernanceMembershipRouteImport } from "./routes/_authed/tenants/$slug/access-governance/membership"
import { Route as AuthedTenantsSlugAccessGovernancePolicyRouteImport } from "./routes/_authed/tenants/$slug/access-governance/policy"
import { Route as AuthedTenantsSlugAccessGovernanceRecoveryRouteImport } from "./routes/_authed/tenants/$slug/access-governance/recovery"
import { Route as AuthedTenantsSlugAdminsIndexRouteImport } from "./routes/_authed/tenants/$slug/admins/index"
import { Route as AuthedTenantsSlugAdminsDelegatedRouteImport } from "./routes/_authed/tenants/$slug/admins/delegated"
import { Route as AuthedTenantsSlugAdminsInviteRouteImport } from "./routes/_authed/tenants/$slug/admins/invite"
import { Route as AuthedTenantsSlugAgentsIndexRouteImport } from "./routes/_authed/tenants/$slug/agents/index"
import { Route as AuthedTenantsSlugAgentsAgentIdRouteImport } from "./routes/_authed/tenants/$slug/agents/$agentId"
import { Route as AuthedTenantsSlugAgentsActivityRouteImport } from "./routes/_authed/tenants/$slug/agents/activity"
import { Route as AuthedTenantsSlugAgentsApprovalAnalyticsRouteImport } from "./routes/_authed/tenants/$slug/agents/approval-analytics"
import { Route as AuthedTenantsSlugAgentsApprovalHistoryRouteImport } from "./routes/_authed/tenants/$slug/agents/approval-history"
import { Route as AuthedTenantsSlugAgentsApprovalThresholdsRouteImport } from "./routes/_authed/tenants/$slug/agents/approval-thresholds"
import { Route as AuthedTenantsSlugAgentsBudgetRaisesRouteImport } from "./routes/_authed/tenants/$slug/agents/budget-raises"
import { Route as AuthedTenantsSlugAgentsBudgetResetAnomaliesRouteImport } from "./routes/_authed/tenants/$slug/agents/budget-reset-anomalies"
import { Route as AuthedTenantsSlugAgentsDecisionReportsRouteImport } from "./routes/_authed/tenants/$slug/agents/decision-reports"
import { Route as AuthedTenantsSlugAgentsDelegationGovernanceRouteImport } from "./routes/_authed/tenants/$slug/agents/delegation-governance"
import { Route as AuthedTenantsSlugAgentsEdgeRouteImport } from "./routes/_authed/tenants/$slug/agents/edge"
import { Route as AuthedTenantsSlugAgentsGrantsRouteImport } from "./routes/_authed/tenants/$slug/agents/grants"
import { Route as AuthedTenantsSlugAgentsGuideRouteImport } from "./routes/_authed/tenants/$slug/agents/guide"
import { Route as AuthedTenantsSlugAgentsIntegrateRouteImport } from "./routes/_authed/tenants/$slug/agents/integrate"
import { Route as AuthedTenantsSlugAgentsMultiAgentRouteImport } from "./routes/_authed/tenants/$slug/agents/multi-agent"
import { Route as AuthedTenantsSlugAgentsProtectedResourcesRouteImport } from "./routes/_authed/tenants/$slug/agents/protected-resources"
import { Route as AuthedTenantsSlugAgentsStandingDelegationsRouteImport } from "./routes/_authed/tenants/$slug/agents/standing-delegations"
import { Route as AuthedTenantsSlugAgentsVirtualKeysRouteImport } from "./routes/_authed/tenants/$slug/agents/virtual-keys"
import { Route as AuthedTenantsSlugApplicationsIndexRouteImport } from "./routes/_authed/tenants/$slug/applications/index"
import { Route as AuthedTenantsSlugApplicationsAppIdRouteImport } from "./routes/_authed/tenants/$slug/applications/$appId"
import { Route as AuthedTenantsSlugAuditIndexRouteImport } from "./routes/_authed/tenants/$slug/audit/index"
import { Route as AuthedTenantsSlugAuthenticationIndexRouteImport } from "./routes/_authed/tenants/$slug/authentication/index"
import { Route as AuthedTenantsSlugAuthenticationAuthenticatorsRouteImport } from "./routes/_authed/tenants/$slug/authentication/authenticators"
import { Route as AuthedTenantsSlugAuthenticationFederationRouteImport } from "./routes/_authed/tenants/$slug/authentication/federation"
import { Route as AuthedTenantsSlugAuthenticationSignInRouteImport } from "./routes/_authed/tenants/$slug/authentication/sign-in"
import { Route as AuthedTenantsSlugAutomationAccountsIndexRouteImport } from "./routes/_authed/tenants/$slug/automation-accounts/index"
import { Route as AuthedTenantsSlugAutomationAccountsIdRouteImport } from "./routes/_authed/tenants/$slug/automation-accounts/$id"
import { Route as AuthedTenantsSlugAutomationAccountsNewRouteImport } from "./routes/_authed/tenants/$slug/automation-accounts/new"
import { Route as AuthedTenantsSlugComplianceIndexRouteImport } from "./routes/_authed/tenants/$slug/compliance/index"
import { Route as AuthedTenantsSlugDevicesIndexRouteImport } from "./routes/_authed/tenants/$slug/devices/index"
import { Route as AuthedTenantsSlugDirectoryIndexRouteImport } from "./routes/_authed/tenants/$slug/directory/index"
import { Route as AuthedTenantsSlugDirectoryAttributesRouteImport } from "./routes/_authed/tenants/$slug/directory/attributes"
import { Route as AuthedTenantsSlugDirectoryAuthorityRouteImport } from "./routes/_authed/tenants/$slug/directory/authority"
import { Route as AuthedTenantsSlugDirectoryMatchingRouteImport } from "./routes/_authed/tenants/$slug/directory/matching"
import { Route as AuthedTenantsSlugDirectoryScimOperationsRouteImport } from "./routes/_authed/tenants/$slug/directory/scim-operations"
import { Route as AuthedTenantsSlugDirectoryScimTokensRouteImport } from "./routes/_authed/tenants/$slug/directory/scim-tokens"
import { Route as AuthedTenantsSlugGettingStartedIndexRouteImport } from "./routes/_authed/tenants/$slug/getting-started/index"
import { Route as AuthedTenantsSlugGroupsIndexRouteImport } from "./routes/_authed/tenants/$slug/groups/index"
import { Route as AuthedTenantsSlugGroupsGroupIdRouteImport } from "./routes/_authed/tenants/$slug/groups/$groupId"
import { Route as AuthedTenantsSlugGroupsRulesRouteImport } from "./routes/_authed/tenants/$slug/groups/rules"
import { Route as AuthedTenantsSlugIdentityHygieneIndexRouteImport } from "./routes/_authed/tenants/$slug/identity-hygiene/index"
import { Route as AuthedTenantsSlugLockedOutUsersIndexRouteImport } from "./routes/_authed/tenants/$slug/locked-out-users/index"
import { Route as AuthedTenantsSlugNonHumanIdentitiesIndexRouteImport } from "./routes/_authed/tenants/$slug/non-human-identities/index"
import { Route as AuthedTenantsSlugNonHumanIdentitiesOverviewRouteImport } from "./routes/_authed/tenants/$slug/non-human-identities/overview"
import { Route as AuthedTenantsSlugOnboardingAutotuneIndexRouteImport } from "./routes/_authed/tenants/$slug/onboarding-autotune/index"
import { Route as AuthedTenantsSlugOnboardingHealthIndexRouteImport } from "./routes/_authed/tenants/$slug/onboarding-health/index"
import { Route as AuthedTenantsSlugOrganizationsIndexRouteImport } from "./routes/_authed/tenants/$slug/organizations/index"
import { Route as AuthedTenantsSlugOrganizationsOrgIdRouteImport } from "./routes/_authed/tenants/$slug/organizations/$orgId"
import { Route as AuthedTenantsSlugOrganizationsNewRouteImport } from "./routes/_authed/tenants/$slug/organizations/new"
import { Route as AuthedTenantsSlugPasskeyIntelligenceIndexRouteImport } from "./routes/_authed/tenants/$slug/passkey-intelligence/index"
import { Route as AuthedTenantsSlugPasskeysIndexRouteImport } from "./routes/_authed/tenants/$slug/passkeys/index"
import { Route as AuthedTenantsSlugProvisioningIndexRouteImport } from "./routes/_authed/tenants/$slug/provisioning/index"
import { Route as AuthedTenantsSlugProvisioningConnectionIdRouteImport } from "./routes/_authed/tenants/$slug/provisioning/$connectionId"
import { Route as AuthedTenantsSlugProvisioningNewRouteImport } from "./routes/_authed/tenants/$slug/provisioning/new"
import { Route as AuthedTenantsSlugSecurityWorkstationsRouteImport } from "./routes/_authed/tenants/$slug/security/workstations"
import { Route as AuthedTenantsSlugSettingsIndexRouteImport } from "./routes/_authed/tenants/$slug/settings/index"
import { Route as AuthedTenantsSlugSettingsAutomatedOnboardingRouteImport } from "./routes/_authed/tenants/$slug/settings/automated-onboarding"
import { Route as AuthedTenantsSlugSettingsBrandingRouteImport } from "./routes/_authed/tenants/$slug/settings/branding"
import { Route as AuthedTenantsSlugSettingsDangerZoneRouteImport } from "./routes/_authed/tenants/$slug/settings/danger-zone"
import { Route as AuthedTenantsSlugSettingsDelegationRouteImport } from "./routes/_authed/tenants/$slug/settings/delegation"
import { Route as AuthedTenantsSlugSettingsIdentityMatchingRouteImport } from "./routes/_authed/tenants/$slug/settings/identity-matching"
import { Route as AuthedTenantsSlugSettingsNotificationsRouteImport } from "./routes/_authed/tenants/$slug/settings/notifications"
import { Route as AuthedTenantsSlugSettingsProductAreasRouteImport } from "./routes/_authed/tenants/$slug/settings/product-areas"
import { Route as AuthedTenantsSlugSettingsProvisioningRouteImport } from "./routes/_authed/tenants/$slug/settings/provisioning"
import { Route as AuthedTenantsSlugSettingsRpRouteImport } from "./routes/_authed/tenants/$slug/settings/rp"
import { Route as AuthedTenantsSlugUsersIndexRouteImport } from "./routes/_authed/tenants/$slug/users/index"
import { Route as AuthedTenantsSlugUsersUserIdRouteImport } from "./routes/_authed/tenants/$slug/users/$userId"
import { Route as AuthedTenantsSlugUsersImportsRouteImport } from "./routes/_authed/tenants/$slug/users/imports"
import { Route as AuthedTenantsSlugWebhooksIndexRouteImport } from "./routes/_authed/tenants/$slug/webhooks/index"
import { Route as AuthedTenantsSlugWebhooksWebhookIdRouteImport } from "./routes/_authed/tenants/$slug/webhooks/$webhookId"
import { Route as AuthedTenantsSlugWebhooksNewRouteImport } from "./routes/_authed/tenants/$slug/webhooks/new"
import { Route as AuthedTenantsSlugWorkloadIssuersIndexRouteImport } from "./routes/_authed/tenants/$slug/workload-issuers/index"
import { Route as TSlugRecoveriesAttestRequestIdRouteImport } from "./routes/t/$slug/recoveries.attest.$requestId"
import { Route as AuthedTenantsSlugAccessGovernanceCredentialRecoveryIndexRouteImport } from "./routes/_authed/tenants/$slug/access-governance/credential-recovery/index"
import { Route as AuthedTenantsSlugAccessGovernanceCredentialRecoveryRequestIdRouteImport } from "./routes/_authed/tenants/$slug/access-governance/credential-recovery/$requestId"
import { Route as AuthedTenantsSlugAgentsAgentIdPolicyRouteImport } from "./routes/_authed/tenants/$slug/agents/$agentId.policy"
import { Route as AuthedTenantsSlugAgentsGuideTypeRouteImport } from "./routes/_authed/tenants/$slug/agents/guide.$type"
import { Route as AuthedTenantsSlugAgentsIntegrateIndexRouteImport } from "./routes/_authed/tenants/$slug/agents/integrate/index"
import { Route as AuthedTenantsSlugAgentsIntegrateApiRouteImport } from "./routes/_authed/tenants/$slug/agents/integrate/api"
import { Route as AuthedTenantsSlugAgentsIntegrateGoSdkRouteImport } from "./routes/_authed/tenants/$slug/agents/integrate/go-sdk"
import { Route as AuthedTenantsSlugAgentsIntegrateProtectRouteImport } from "./routes/_authed/tenants/$slug/agents/integrate/protect"
import { Route as AuthedTenantsSlugApplicationsDynamicRegistrationIndexRouteImport } from "./routes/_authed/tenants/$slug/applications/dynamic-registration/index"
import { Route as AuthedTenantsSlugAuthenticationAuthenticatorsIndexRouteImport } from "./routes/_authed/tenants/$slug/authentication/authenticators/index"
import { Route as AuthedTenantsSlugAuthenticationAuthenticatorsIdentityChecksRouteImport } from "./routes/_authed/tenants/$slug/authentication/authenticators/identity-checks"
import { Route as AuthedTenantsSlugAuthenticationAuthenticatorsNewRouteImport } from "./routes/_authed/tenants/$slug/authentication/authenticators/new"
import { Route as AuthedTenantsSlugAuthenticationConditionalAccessIndexRouteImport } from "./routes/_authed/tenants/$slug/authentication/conditional-access/index"
import { Route as AuthedTenantsSlugAuthenticationConditionalAccessPolicyIdRouteImport } from "./routes/_authed/tenants/$slug/authentication/conditional-access/$policyId"
import { Route as AuthedTenantsSlugAuthenticationConditionalAccessNewRouteImport } from "./routes/_authed/tenants/$slug/authentication/conditional-access/new"
import { Route as AuthedTenantsSlugAuthenticationLocationsNewRouteImport } from "./routes/_authed/tenants/$slug/authentication/locations/new"
import { Route as AuthedTenantsSlugAuthenticationSignInIndexRouteImport } from "./routes/_authed/tenants/$slug/authentication/sign-in/index"
import { Route as AuthedTenantsSlugAuthenticationSignInMethodsRouteImport } from "./routes/_authed/tenants/$slug/authentication/sign-in/methods"
import { Route as AuthedTenantsSlugAuthenticationSignInPasskeysRouteImport } from "./routes/_authed/tenants/$slug/authentication/sign-in/passkeys"
import { Route as AuthedTenantsSlugAuthenticationSignInPhoneRouteImport } from "./routes/_authed/tenants/$slug/authentication/sign-in/phone"
import { Route as AuthedTenantsSlugAuthenticationSignInRecoveryRouteImport } from "./routes/_authed/tenants/$slug/authentication/sign-in/recovery"
import { Route as AuthedTenantsSlugAuthenticationSignInSessionsRouteImport } from "./routes/_authed/tenants/$slug/authentication/sign-in/sessions"
import { Route as AuthedTenantsSlugComplianceControlsCatalogIdRouteImport } from "./routes/_authed/tenants/$slug/compliance/controls/$catalogId"
import { Route as AuthedTenantsSlugDirectoryAdInboundIndexRouteImport } from "./routes/_authed/tenants/$slug/directory/ad-inbound/index"
import { Route as AuthedTenantsSlugDirectoryAdInboundDirectoryIdRouteImport } from "./routes/_authed/tenants/$slug/directory/ad-inbound/$directoryId"
import { Route as AuthedTenantsSlugDirectoryAdInboundNewRouteImport } from "./routes/_authed/tenants/$slug/directory/ad-inbound/new"
import { Route as AuthedTenantsSlugDirectoryAdInboundNewWorkdayRouteImport } from "./routes/_authed/tenants/$slug/directory/ad-inbound/new-workday"
import { Route as AuthedTenantsSlugPostureComplianceIndexRouteImport } from "./routes/_authed/tenants/$slug/posture/compliance/index"
import { Route as AuthedTenantsSlugSecurityFrontlineIndexRouteImport } from "./routes/_authed/tenants/$slug/security/frontline/index"
import { Route as AuthedTenantsSlugSecurityFrontlineBadgeSigninRouteImport } from "./routes/_authed/tenants/$slug/security/frontline/badge-signin"
import { Route as AuthedTenantsSlugSecurityFrontlineKioskPassRouteImport } from "./routes/_authed/tenants/$slug/security/frontline/kiosk-pass"
import { Route as AuthedTenantsSlugSecurityLogonCertificatesIndexRouteImport } from "./routes/_authed/tenants/$slug/security/logon-certificates/index"
import { Route as AuthedTenantsSlugSettingsProductAreasIndexRouteImport } from "./routes/_authed/tenants/$slug/settings/product-areas/index"
import { Route as AuthedTenantsSlugSettingsProductAreasReconciliationRouteImport } from "./routes/_authed/tenants/$slug/settings/product-areas/reconciliation"
import { Route as AuthedTenantsSlugWebhooksWebhookIdEditRouteImport } from "./routes/_authed/tenants/$slug/webhooks/$webhookId.edit"
import { Route as AuthedTenantsSlugAgentsProtectedResourcesResourceCustodyRouteImport } from "./routes/_authed/tenants/$slug/agents/protected-resources.$resource.custody"
import { Route as AuthedTenantsSlugAuthenticationConditionalAccessAppAccessAppIdRouteImport } from "./routes/_authed/tenants/$slug/authentication/conditional-access/app-access.$appId"
import { Route as AuthedTenantsSlugAuthenticationLocationsIdEditRouteImport } from "./routes/_authed/tenants/$slug/authentication/locations/$id.edit"
import { Route as AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteImport } from "./routes/_authed/tenants/$slug/compliance/frameworks/$frameworkId.$frameworkVersion"
import { Route as AuthedTenantsSlugPostureComplianceControlsCatalogIdRouteImport } from "./routes/_authed/tenants/$slug/posture/compliance/controls/$catalogId"
import { Route as AuthedTenantsSlugPostureComplianceReportsKindRouteImport } from "./routes/_authed/tenants/$slug/posture/compliance/reports/$kind"
import { Route as AuthedTenantsSlugSecurityLogonCertificatesForestTrustRouteImport } from "./routes/_authed/tenants/$slug/security/logon-certificates/$forest.trust"
import { Route as AuthedTenantsSlugSettingsProductAreasAreaSetupRouteImport } from "./routes/_authed/tenants/$slug/settings/product-areas/$area.setup"
import { Route as AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionReadinessRouteImport } from "./routes/_authed/tenants/$slug/compliance/frameworks/$frameworkId.$frameworkVersion.readiness"
import { Route as AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteImport } from "./routes/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId.$frameworkVersion"
import { Route as AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionReadinessRouteImport } from "./routes/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId.$frameworkVersion.readiness"

const AuthedRoute = AuthedRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any)
const EnrollQrJitRoute = EnrollQrJitRouteImport.update({
  id: "/enroll-qr-jit",
  path: "/enroll-qr-jit",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountHealthRoute = AuthedAccountHealthRouteImport.update({
  id: "/account-health",
  path: "/account-health",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPrivateAccessRoute = AuthedPrivateAccessRouteImport.update({
  id: "/private-access",
  path: "/private-access",
  getParentRoute: () => AuthedRoute,
} as any)
const EnrollTokenRoute = EnrollTokenRouteImport.update({
  id: "/enroll/$token",
  path: "/enroll/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAdminsIndexRoute = AuthedAdminsIndexRouteImport.update({
  id: "/admins/",
  path: "/admins/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminsInviteRoute = AuthedAdminsInviteRouteImport.update({
  id: "/admins/invite",
  path: "/admins/invite",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedApiKeysIndexRoute = AuthedApiKeysIndexRouteImport.update({
  id: "/api-keys/",
  path: "/api-keys/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedApiKeysNewRoute = AuthedApiKeysNewRouteImport.update({
  id: "/api-keys/new",
  path: "/api-keys/new",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditIndexRoute = AuthedAuditIndexRouteImport.update({
  id: "/audit/",
  path: "/audit/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAutomationAccountsIndexRoute =
  AuthedAutomationAccountsIndexRouteImport.update({
    id: "/automation-accounts/",
    path: "/automation-accounts/",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAutomationAccountsIdRoute =
  AuthedAutomationAccountsIdRouteImport.update({
    id: "/automation-accounts/$id",
    path: "/automation-accounts/$id",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAutomationAccountsNewRoute =
  AuthedAutomationAccountsNewRouteImport.update({
    id: "/automation-accounts/new",
    path: "/automation-accounts/new",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedManagedIndexRoute = AuthedManagedIndexRouteImport.update({
  id: "/managed/",
  path: "/managed/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedManagedTeamsRoute = AuthedManagedTeamsRouteImport.update({
  id: "/managed/teams",
  path: "/managed/teams",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTenantRecordsSlugRoute = AuthedTenantRecordsSlugRouteImport.update({
  id: "/tenant-records/$slug",
  path: "/tenant-records/$slug",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTenantsIndexRoute = AuthedTenantsIndexRouteImport.update({
  id: "/tenants/",
  path: "/tenants/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTenantsSlugRoute = AuthedTenantsSlugRouteImport.update({
  id: "/tenants/$slug",
  path: "/tenants/$slug",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTenantsNewRoute = AuthedTenantsNewRouteImport.update({
  id: "/tenants/new",
  path: "/tenants/new",
  getParentRoute: () => AuthedRoute,
} as any)
const TSlugLoginRoute = TSlugLoginRouteImport.update({
  id: "/t/$slug/login",
  path: "/t/$slug/login",
  getParentRoute: () => rootRouteImport,
} as any)
const TSlugRecoveryRoute = TSlugRecoveryRouteImport.update({
  id: "/t/$slug/recovery",
  path: "/t/$slug/recovery",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedManagedTenantsSlugRoute =
  AuthedManagedTenantsSlugRouteImport.update({
    id: "/managed/tenants/$slug",
    path: "/managed/tenants/$slug",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTenantRecordsSlugIndexRoute =
  AuthedTenantRecordsSlugIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedTenantRecordsSlugRoute,
  } as any)
const AuthedTenantRecordsSlugAccessRoute =
  AuthedTenantRecordsSlugAccessRouteImport.update({
    id: "/access",
    path: "/access",
    getParentRoute: () => AuthedTenantRecordsSlugRoute,
  } as any)
const AuthedTenantRecordsSlugEnrollmentIssuersRoute =
  AuthedTenantRecordsSlugEnrollmentIssuersRouteImport.update({
    id: "/enrollment-issuers",
    path: "/enrollment-issuers",
    getParentRoute: () => AuthedTenantRecordsSlugRoute,
  } as any)
const AuthedTenantRecordsSlugSubscriptionRoute =
  AuthedTenantRecordsSlugSubscriptionRouteImport.update({
    id: "/subscription",
    path: "/subscription",
    getParentRoute: () => AuthedTenantRecordsSlugRoute,
  } as any)
const AuthedTenantsSlugIndexRoute = AuthedTenantsSlugIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedTenantsSlugRoute,
} as any)
const AuthedTenantsSlugAccessRequestsRoute =
  AuthedTenantsSlugAccessRequestsRouteImport.update({
    id: "/access-requests",
    path: "/access-requests",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAuthenticationRoute =
  AuthedTenantsSlugAuthenticationRouteImport.update({
    id: "/authentication",
    path: "/authentication",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugEntitlementRoute =
  AuthedTenantsSlugEntitlementRouteImport.update({
    id: "/entitlement",
    path: "/entitlement",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugOauthDynregRoute =
  AuthedTenantsSlugOauthDynregRouteImport.update({
    id: "/oauth-dynreg",
    path: "/oauth-dynreg",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugSettingsRoute =
  AuthedTenantsSlugSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const TSlugLoginHelpRoute = TSlugLoginHelpRouteImport.update({
  id: "/help",
  path: "/help",
  getParentRoute: () => TSlugLoginRoute,
} as any)
const TSlugRecoveryRequestRoute = TSlugRecoveryRequestRouteImport.update({
  id: "/request",
  path: "/request",
  getParentRoute: () => TSlugRecoveryRoute,
} as any)
const AuthedTenantRecordsSlugAdministratorsIndexRoute =
  AuthedTenantRecordsSlugAdministratorsIndexRouteImport.update({
    id: "/administrators/",
    path: "/administrators/",
    getParentRoute: () => AuthedTenantRecordsSlugRoute,
  } as any)
const AuthedTenantRecordsSlugAdministratorsInviteRoute =
  AuthedTenantRecordsSlugAdministratorsInviteRouteImport.update({
    id: "/administrators/invite",
    path: "/administrators/invite",
    getParentRoute: () => AuthedTenantRecordsSlugRoute,
  } as any)
const AuthedTenantsSlugAccessGovernanceIndexRoute =
  AuthedTenantsSlugAccessGovernanceIndexRouteImport.update({
    id: "/access-governance/",
    path: "/access-governance/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAccessGovernanceApprovalPoliciesRoute =
  AuthedTenantsSlugAccessGovernanceApprovalPoliciesRouteImport.update({
    id: "/access-governance/approval-policies",
    path: "/access-governance/approval-policies",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAccessGovernanceApproversRoute =
  AuthedTenantsSlugAccessGovernanceApproversRouteImport.update({
    id: "/access-governance/approvers",
    path: "/access-governance/approvers",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAccessGovernanceHistoryRoute =
  AuthedTenantsSlugAccessGovernanceHistoryRouteImport.update({
    id: "/access-governance/history",
    path: "/access-governance/history",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAccessGovernanceMembershipRoute =
  AuthedTenantsSlugAccessGovernanceMembershipRouteImport.update({
    id: "/access-governance/membership",
    path: "/access-governance/membership",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAccessGovernancePolicyRoute =
  AuthedTenantsSlugAccessGovernancePolicyRouteImport.update({
    id: "/access-governance/policy",
    path: "/access-governance/policy",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAccessGovernanceRecoveryRoute =
  AuthedTenantsSlugAccessGovernanceRecoveryRouteImport.update({
    id: "/access-governance/recovery",
    path: "/access-governance/recovery",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAdminsIndexRoute =
  AuthedTenantsSlugAdminsIndexRouteImport.update({
    id: "/admins/",
    path: "/admins/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAdminsDelegatedRoute =
  AuthedTenantsSlugAdminsDelegatedRouteImport.update({
    id: "/admins/delegated",
    path: "/admins/delegated",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAdminsInviteRoute =
  AuthedTenantsSlugAdminsInviteRouteImport.update({
    id: "/admins/invite",
    path: "/admins/invite",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsIndexRoute =
  AuthedTenantsSlugAgentsIndexRouteImport.update({
    id: "/agents/",
    path: "/agents/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsAgentIdRoute =
  AuthedTenantsSlugAgentsAgentIdRouteImport.update({
    id: "/agents/$agentId",
    path: "/agents/$agentId",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsActivityRoute =
  AuthedTenantsSlugAgentsActivityRouteImport.update({
    id: "/agents/activity",
    path: "/agents/activity",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsApprovalAnalyticsRoute =
  AuthedTenantsSlugAgentsApprovalAnalyticsRouteImport.update({
    id: "/agents/approval-analytics",
    path: "/agents/approval-analytics",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsApprovalHistoryRoute =
  AuthedTenantsSlugAgentsApprovalHistoryRouteImport.update({
    id: "/agents/approval-history",
    path: "/agents/approval-history",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsApprovalThresholdsRoute =
  AuthedTenantsSlugAgentsApprovalThresholdsRouteImport.update({
    id: "/agents/approval-thresholds",
    path: "/agents/approval-thresholds",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsBudgetRaisesRoute =
  AuthedTenantsSlugAgentsBudgetRaisesRouteImport.update({
    id: "/agents/budget-raises",
    path: "/agents/budget-raises",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsBudgetResetAnomaliesRoute =
  AuthedTenantsSlugAgentsBudgetResetAnomaliesRouteImport.update({
    id: "/agents/budget-reset-anomalies",
    path: "/agents/budget-reset-anomalies",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsDecisionReportsRoute =
  AuthedTenantsSlugAgentsDecisionReportsRouteImport.update({
    id: "/agents/decision-reports",
    path: "/agents/decision-reports",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsDelegationGovernanceRoute =
  AuthedTenantsSlugAgentsDelegationGovernanceRouteImport.update({
    id: "/agents/delegation-governance",
    path: "/agents/delegation-governance",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsEdgeRoute =
  AuthedTenantsSlugAgentsEdgeRouteImport.update({
    id: "/agents/edge",
    path: "/agents/edge",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsGrantsRoute =
  AuthedTenantsSlugAgentsGrantsRouteImport.update({
    id: "/agents/grants",
    path: "/agents/grants",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsGuideRoute =
  AuthedTenantsSlugAgentsGuideRouteImport.update({
    id: "/agents/guide",
    path: "/agents/guide",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsIntegrateRoute =
  AuthedTenantsSlugAgentsIntegrateRouteImport.update({
    id: "/agents/integrate",
    path: "/agents/integrate",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsMultiAgentRoute =
  AuthedTenantsSlugAgentsMultiAgentRouteImport.update({
    id: "/agents/multi-agent",
    path: "/agents/multi-agent",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsProtectedResourcesRoute =
  AuthedTenantsSlugAgentsProtectedResourcesRouteImport.update({
    id: "/agents/protected-resources",
    path: "/agents/protected-resources",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsStandingDelegationsRoute =
  AuthedTenantsSlugAgentsStandingDelegationsRouteImport.update({
    id: "/agents/standing-delegations",
    path: "/agents/standing-delegations",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAgentsVirtualKeysRoute =
  AuthedTenantsSlugAgentsVirtualKeysRouteImport.update({
    id: "/agents/virtual-keys",
    path: "/agents/virtual-keys",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugApplicationsIndexRoute =
  AuthedTenantsSlugApplicationsIndexRouteImport.update({
    id: "/applications/",
    path: "/applications/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugApplicationsAppIdRoute =
  AuthedTenantsSlugApplicationsAppIdRouteImport.update({
    id: "/applications/$appId",
    path: "/applications/$appId",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAuditIndexRoute =
  AuthedTenantsSlugAuditIndexRouteImport.update({
    id: "/audit/",
    path: "/audit/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAuthenticationIndexRoute =
  AuthedTenantsSlugAuthenticationIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedTenantsSlugAuthenticationRoute,
  } as any)
const AuthedTenantsSlugAuthenticationAuthenticatorsRoute =
  AuthedTenantsSlugAuthenticationAuthenticatorsRouteImport.update({
    id: "/authenticators",
    path: "/authenticators",
    getParentRoute: () => AuthedTenantsSlugAuthenticationRoute,
  } as any)
const AuthedTenantsSlugAuthenticationFederationRoute =
  AuthedTenantsSlugAuthenticationFederationRouteImport.update({
    id: "/federation",
    path: "/federation",
    getParentRoute: () => AuthedTenantsSlugAuthenticationRoute,
  } as any)
const AuthedTenantsSlugAuthenticationSignInRoute =
  AuthedTenantsSlugAuthenticationSignInRouteImport.update({
    id: "/sign-in",
    path: "/sign-in",
    getParentRoute: () => AuthedTenantsSlugAuthenticationRoute,
  } as any)
const AuthedTenantsSlugAutomationAccountsIndexRoute =
  AuthedTenantsSlugAutomationAccountsIndexRouteImport.update({
    id: "/automation-accounts/",
    path: "/automation-accounts/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAutomationAccountsIdRoute =
  AuthedTenantsSlugAutomationAccountsIdRouteImport.update({
    id: "/automation-accounts/$id",
    path: "/automation-accounts/$id",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAutomationAccountsNewRoute =
  AuthedTenantsSlugAutomationAccountsNewRouteImport.update({
    id: "/automation-accounts/new",
    path: "/automation-accounts/new",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugComplianceIndexRoute =
  AuthedTenantsSlugComplianceIndexRouteImport.update({
    id: "/compliance/",
    path: "/compliance/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugDevicesIndexRoute =
  AuthedTenantsSlugDevicesIndexRouteImport.update({
    id: "/devices/",
    path: "/devices/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugDirectoryIndexRoute =
  AuthedTenantsSlugDirectoryIndexRouteImport.update({
    id: "/directory/",
    path: "/directory/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugDirectoryAttributesRoute =
  AuthedTenantsSlugDirectoryAttributesRouteImport.update({
    id: "/directory/attributes",
    path: "/directory/attributes",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugDirectoryAuthorityRoute =
  AuthedTenantsSlugDirectoryAuthorityRouteImport.update({
    id: "/directory/authority",
    path: "/directory/authority",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugDirectoryMatchingRoute =
  AuthedTenantsSlugDirectoryMatchingRouteImport.update({
    id: "/directory/matching",
    path: "/directory/matching",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugDirectoryScimOperationsRoute =
  AuthedTenantsSlugDirectoryScimOperationsRouteImport.update({
    id: "/directory/scim-operations",
    path: "/directory/scim-operations",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugDirectoryScimTokensRoute =
  AuthedTenantsSlugDirectoryScimTokensRouteImport.update({
    id: "/directory/scim-tokens",
    path: "/directory/scim-tokens",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugGettingStartedIndexRoute =
  AuthedTenantsSlugGettingStartedIndexRouteImport.update({
    id: "/getting-started/",
    path: "/getting-started/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugGroupsIndexRoute =
  AuthedTenantsSlugGroupsIndexRouteImport.update({
    id: "/groups/",
    path: "/groups/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugGroupsGroupIdRoute =
  AuthedTenantsSlugGroupsGroupIdRouteImport.update({
    id: "/groups/$groupId",
    path: "/groups/$groupId",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugGroupsRulesRoute =
  AuthedTenantsSlugGroupsRulesRouteImport.update({
    id: "/groups/rules",
    path: "/groups/rules",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugIdentityHygieneIndexRoute =
  AuthedTenantsSlugIdentityHygieneIndexRouteImport.update({
    id: "/identity-hygiene/",
    path: "/identity-hygiene/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugLockedOutUsersIndexRoute =
  AuthedTenantsSlugLockedOutUsersIndexRouteImport.update({
    id: "/locked-out-users/",
    path: "/locked-out-users/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugNonHumanIdentitiesIndexRoute =
  AuthedTenantsSlugNonHumanIdentitiesIndexRouteImport.update({
    id: "/non-human-identities/",
    path: "/non-human-identities/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugNonHumanIdentitiesOverviewRoute =
  AuthedTenantsSlugNonHumanIdentitiesOverviewRouteImport.update({
    id: "/non-human-identities/overview",
    path: "/non-human-identities/overview",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugOnboardingAutotuneIndexRoute =
  AuthedTenantsSlugOnboardingAutotuneIndexRouteImport.update({
    id: "/onboarding-autotune/",
    path: "/onboarding-autotune/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugOnboardingHealthIndexRoute =
  AuthedTenantsSlugOnboardingHealthIndexRouteImport.update({
    id: "/onboarding-health/",
    path: "/onboarding-health/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugOrganizationsIndexRoute =
  AuthedTenantsSlugOrganizationsIndexRouteImport.update({
    id: "/organizations/",
    path: "/organizations/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugOrganizationsOrgIdRoute =
  AuthedTenantsSlugOrganizationsOrgIdRouteImport.update({
    id: "/organizations/$orgId",
    path: "/organizations/$orgId",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugOrganizationsNewRoute =
  AuthedTenantsSlugOrganizationsNewRouteImport.update({
    id: "/organizations/new",
    path: "/organizations/new",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugPasskeyIntelligenceIndexRoute =
  AuthedTenantsSlugPasskeyIntelligenceIndexRouteImport.update({
    id: "/passkey-intelligence/",
    path: "/passkey-intelligence/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugPasskeysIndexRoute =
  AuthedTenantsSlugPasskeysIndexRouteImport.update({
    id: "/passkeys/",
    path: "/passkeys/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugProvisioningIndexRoute =
  AuthedTenantsSlugProvisioningIndexRouteImport.update({
    id: "/provisioning/",
    path: "/provisioning/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugProvisioningConnectionIdRoute =
  AuthedTenantsSlugProvisioningConnectionIdRouteImport.update({
    id: "/provisioning/$connectionId",
    path: "/provisioning/$connectionId",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugProvisioningNewRoute =
  AuthedTenantsSlugProvisioningNewRouteImport.update({
    id: "/provisioning/new",
    path: "/provisioning/new",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugSecurityWorkstationsRoute =
  AuthedTenantsSlugSecurityWorkstationsRouteImport.update({
    id: "/security/workstations",
    path: "/security/workstations",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugSettingsIndexRoute =
  AuthedTenantsSlugSettingsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedTenantsSlugSettingsRoute,
  } as any)
const AuthedTenantsSlugSettingsAutomatedOnboardingRoute =
  AuthedTenantsSlugSettingsAutomatedOnboardingRouteImport.update({
    id: "/automated-onboarding",
    path: "/automated-onboarding",
    getParentRoute: () => AuthedTenantsSlugSettingsRoute,
  } as any)
const AuthedTenantsSlugSettingsBrandingRoute =
  AuthedTenantsSlugSettingsBrandingRouteImport.update({
    id: "/branding",
    path: "/branding",
    getParentRoute: () => AuthedTenantsSlugSettingsRoute,
  } as any)
const AuthedTenantsSlugSettingsDangerZoneRoute =
  AuthedTenantsSlugSettingsDangerZoneRouteImport.update({
    id: "/danger-zone",
    path: "/danger-zone",
    getParentRoute: () => AuthedTenantsSlugSettingsRoute,
  } as any)
const AuthedTenantsSlugSettingsDelegationRoute =
  AuthedTenantsSlugSettingsDelegationRouteImport.update({
    id: "/delegation",
    path: "/delegation",
    getParentRoute: () => AuthedTenantsSlugSettingsRoute,
  } as any)
const AuthedTenantsSlugSettingsIdentityMatchingRoute =
  AuthedTenantsSlugSettingsIdentityMatchingRouteImport.update({
    id: "/identity-matching",
    path: "/identity-matching",
    getParentRoute: () => AuthedTenantsSlugSettingsRoute,
  } as any)
const AuthedTenantsSlugSettingsNotificationsRoute =
  AuthedTenantsSlugSettingsNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AuthedTenantsSlugSettingsRoute,
  } as any)
const AuthedTenantsSlugSettingsProductAreasRoute =
  AuthedTenantsSlugSettingsProductAreasRouteImport.update({
    id: "/product-areas",
    path: "/product-areas",
    getParentRoute: () => AuthedTenantsSlugSettingsRoute,
  } as any)
const AuthedTenantsSlugSettingsProvisioningRoute =
  AuthedTenantsSlugSettingsProvisioningRouteImport.update({
    id: "/provisioning",
    path: "/provisioning",
    getParentRoute: () => AuthedTenantsSlugSettingsRoute,
  } as any)
const AuthedTenantsSlugSettingsRpRoute =
  AuthedTenantsSlugSettingsRpRouteImport.update({
    id: "/rp",
    path: "/rp",
    getParentRoute: () => AuthedTenantsSlugSettingsRoute,
  } as any)
const AuthedTenantsSlugUsersIndexRoute =
  AuthedTenantsSlugUsersIndexRouteImport.update({
    id: "/users/",
    path: "/users/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugUsersUserIdRoute =
  AuthedTenantsSlugUsersUserIdRouteImport.update({
    id: "/users/$userId",
    path: "/users/$userId",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugUsersImportsRoute =
  AuthedTenantsSlugUsersImportsRouteImport.update({
    id: "/users/imports",
    path: "/users/imports",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugWebhooksIndexRoute =
  AuthedTenantsSlugWebhooksIndexRouteImport.update({
    id: "/webhooks/",
    path: "/webhooks/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugWebhooksWebhookIdRoute =
  AuthedTenantsSlugWebhooksWebhookIdRouteImport.update({
    id: "/webhooks/$webhookId",
    path: "/webhooks/$webhookId",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugWebhooksNewRoute =
  AuthedTenantsSlugWebhooksNewRouteImport.update({
    id: "/webhooks/new",
    path: "/webhooks/new",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugWorkloadIssuersIndexRoute =
  AuthedTenantsSlugWorkloadIssuersIndexRouteImport.update({
    id: "/workload-issuers/",
    path: "/workload-issuers/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const TSlugRecoveriesAttestRequestIdRoute =
  TSlugRecoveriesAttestRequestIdRouteImport.update({
    id: "/t/$slug/recoveries/attest/$requestId",
    path: "/t/$slug/recoveries/attest/$requestId",
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedTenantsSlugAccessGovernanceCredentialRecoveryIndexRoute =
  AuthedTenantsSlugAccessGovernanceCredentialRecoveryIndexRouteImport.update({
    id: "/access-governance/credential-recovery/",
    path: "/access-governance/credential-recovery/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAccessGovernanceCredentialRecoveryRequestIdRoute =
  AuthedTenantsSlugAccessGovernanceCredentialRecoveryRequestIdRouteImport.update(
    {
      id: "/access-governance/credential-recovery/$requestId",
      path: "/access-governance/credential-recovery/$requestId",
      getParentRoute: () => AuthedTenantsSlugRoute,
    } as any,
  )
const AuthedTenantsSlugAgentsAgentIdPolicyRoute =
  AuthedTenantsSlugAgentsAgentIdPolicyRouteImport.update({
    id: "/policy",
    path: "/policy",
    getParentRoute: () => AuthedTenantsSlugAgentsAgentIdRoute,
  } as any)
const AuthedTenantsSlugAgentsGuideTypeRoute =
  AuthedTenantsSlugAgentsGuideTypeRouteImport.update({
    id: "/$type",
    path: "/$type",
    getParentRoute: () => AuthedTenantsSlugAgentsGuideRoute,
  } as any)
const AuthedTenantsSlugAgentsIntegrateIndexRoute =
  AuthedTenantsSlugAgentsIntegrateIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedTenantsSlugAgentsIntegrateRoute,
  } as any)
const AuthedTenantsSlugAgentsIntegrateApiRoute =
  AuthedTenantsSlugAgentsIntegrateApiRouteImport.update({
    id: "/api",
    path: "/api",
    getParentRoute: () => AuthedTenantsSlugAgentsIntegrateRoute,
  } as any)
const AuthedTenantsSlugAgentsIntegrateGoSdkRoute =
  AuthedTenantsSlugAgentsIntegrateGoSdkRouteImport.update({
    id: "/go-sdk",
    path: "/go-sdk",
    getParentRoute: () => AuthedTenantsSlugAgentsIntegrateRoute,
  } as any)
const AuthedTenantsSlugAgentsIntegrateProtectRoute =
  AuthedTenantsSlugAgentsIntegrateProtectRouteImport.update({
    id: "/protect",
    path: "/protect",
    getParentRoute: () => AuthedTenantsSlugAgentsIntegrateRoute,
  } as any)
const AuthedTenantsSlugApplicationsDynamicRegistrationIndexRoute =
  AuthedTenantsSlugApplicationsDynamicRegistrationIndexRouteImport.update({
    id: "/applications/dynamic-registration/",
    path: "/applications/dynamic-registration/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugAuthenticationAuthenticatorsIndexRoute =
  AuthedTenantsSlugAuthenticationAuthenticatorsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedTenantsSlugAuthenticationAuthenticatorsRoute,
  } as any)
const AuthedTenantsSlugAuthenticationAuthenticatorsIdentityChecksRoute =
  AuthedTenantsSlugAuthenticationAuthenticatorsIdentityChecksRouteImport.update(
    {
      id: "/identity-checks",
      path: "/identity-checks",
      getParentRoute: () => AuthedTenantsSlugAuthenticationAuthenticatorsRoute,
    } as any,
  )
const AuthedTenantsSlugAuthenticationAuthenticatorsNewRoute =
  AuthedTenantsSlugAuthenticationAuthenticatorsNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => AuthedTenantsSlugAuthenticationAuthenticatorsRoute,
  } as any)
const AuthedTenantsSlugAuthenticationConditionalAccessIndexRoute =
  AuthedTenantsSlugAuthenticationConditionalAccessIndexRouteImport.update({
    id: "/conditional-access/",
    path: "/conditional-access/",
    getParentRoute: () => AuthedTenantsSlugAuthenticationRoute,
  } as any)
const AuthedTenantsSlugAuthenticationConditionalAccessPolicyIdRoute =
  AuthedTenantsSlugAuthenticationConditionalAccessPolicyIdRouteImport.update({
    id: "/conditional-access/$policyId",
    path: "/conditional-access/$policyId",
    getParentRoute: () => AuthedTenantsSlugAuthenticationRoute,
  } as any)
const AuthedTenantsSlugAuthenticationConditionalAccessNewRoute =
  AuthedTenantsSlugAuthenticationConditionalAccessNewRouteImport.update({
    id: "/conditional-access/new",
    path: "/conditional-access/new",
    getParentRoute: () => AuthedTenantsSlugAuthenticationRoute,
  } as any)
const AuthedTenantsSlugAuthenticationLocationsNewRoute =
  AuthedTenantsSlugAuthenticationLocationsNewRouteImport.update({
    id: "/locations/new",
    path: "/locations/new",
    getParentRoute: () => AuthedTenantsSlugAuthenticationRoute,
  } as any)
const AuthedTenantsSlugAuthenticationSignInIndexRoute =
  AuthedTenantsSlugAuthenticationSignInIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedTenantsSlugAuthenticationSignInRoute,
  } as any)
const AuthedTenantsSlugAuthenticationSignInMethodsRoute =
  AuthedTenantsSlugAuthenticationSignInMethodsRouteImport.update({
    id: "/methods",
    path: "/methods",
    getParentRoute: () => AuthedTenantsSlugAuthenticationSignInRoute,
  } as any)
const AuthedTenantsSlugAuthenticationSignInPasskeysRoute =
  AuthedTenantsSlugAuthenticationSignInPasskeysRouteImport.update({
    id: "/passkeys",
    path: "/passkeys",
    getParentRoute: () => AuthedTenantsSlugAuthenticationSignInRoute,
  } as any)
const AuthedTenantsSlugAuthenticationSignInPhoneRoute =
  AuthedTenantsSlugAuthenticationSignInPhoneRouteImport.update({
    id: "/phone",
    path: "/phone",
    getParentRoute: () => AuthedTenantsSlugAuthenticationSignInRoute,
  } as any)
const AuthedTenantsSlugAuthenticationSignInRecoveryRoute =
  AuthedTenantsSlugAuthenticationSignInRecoveryRouteImport.update({
    id: "/recovery",
    path: "/recovery",
    getParentRoute: () => AuthedTenantsSlugAuthenticationSignInRoute,
  } as any)
const AuthedTenantsSlugAuthenticationSignInSessionsRoute =
  AuthedTenantsSlugAuthenticationSignInSessionsRouteImport.update({
    id: "/sessions",
    path: "/sessions",
    getParentRoute: () => AuthedTenantsSlugAuthenticationSignInRoute,
  } as any)
const AuthedTenantsSlugComplianceControlsCatalogIdRoute =
  AuthedTenantsSlugComplianceControlsCatalogIdRouteImport.update({
    id: "/compliance/controls/$catalogId",
    path: "/compliance/controls/$catalogId",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugDirectoryAdInboundIndexRoute =
  AuthedTenantsSlugDirectoryAdInboundIndexRouteImport.update({
    id: "/directory/ad-inbound/",
    path: "/directory/ad-inbound/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugDirectoryAdInboundDirectoryIdRoute =
  AuthedTenantsSlugDirectoryAdInboundDirectoryIdRouteImport.update({
    id: "/directory/ad-inbound/$directoryId",
    path: "/directory/ad-inbound/$directoryId",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugDirectoryAdInboundNewRoute =
  AuthedTenantsSlugDirectoryAdInboundNewRouteImport.update({
    id: "/directory/ad-inbound/new",
    path: "/directory/ad-inbound/new",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugDirectoryAdInboundNewWorkdayRoute =
  AuthedTenantsSlugDirectoryAdInboundNewWorkdayRouteImport.update({
    id: "/directory/ad-inbound/new-workday",
    path: "/directory/ad-inbound/new-workday",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugPostureComplianceIndexRoute =
  AuthedTenantsSlugPostureComplianceIndexRouteImport.update({
    id: "/posture/compliance/",
    path: "/posture/compliance/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugSecurityFrontlineIndexRoute =
  AuthedTenantsSlugSecurityFrontlineIndexRouteImport.update({
    id: "/security/frontline/",
    path: "/security/frontline/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugSecurityFrontlineBadgeSigninRoute =
  AuthedTenantsSlugSecurityFrontlineBadgeSigninRouteImport.update({
    id: "/security/frontline/badge-signin",
    path: "/security/frontline/badge-signin",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugSecurityFrontlineKioskPassRoute =
  AuthedTenantsSlugSecurityFrontlineKioskPassRouteImport.update({
    id: "/security/frontline/kiosk-pass",
    path: "/security/frontline/kiosk-pass",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugSecurityLogonCertificatesIndexRoute =
  AuthedTenantsSlugSecurityLogonCertificatesIndexRouteImport.update({
    id: "/security/logon-certificates/",
    path: "/security/logon-certificates/",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugSettingsProductAreasIndexRoute =
  AuthedTenantsSlugSettingsProductAreasIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedTenantsSlugSettingsProductAreasRoute,
  } as any)
const AuthedTenantsSlugSettingsProductAreasReconciliationRoute =
  AuthedTenantsSlugSettingsProductAreasReconciliationRouteImport.update({
    id: "/reconciliation",
    path: "/reconciliation",
    getParentRoute: () => AuthedTenantsSlugSettingsProductAreasRoute,
  } as any)
const AuthedTenantsSlugWebhooksWebhookIdEditRoute =
  AuthedTenantsSlugWebhooksWebhookIdEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => AuthedTenantsSlugWebhooksWebhookIdRoute,
  } as any)
const AuthedTenantsSlugAgentsProtectedResourcesResourceCustodyRoute =
  AuthedTenantsSlugAgentsProtectedResourcesResourceCustodyRouteImport.update({
    id: "/$resource/custody",
    path: "/$resource/custody",
    getParentRoute: () => AuthedTenantsSlugAgentsProtectedResourcesRoute,
  } as any)
const AuthedTenantsSlugAuthenticationConditionalAccessAppAccessAppIdRoute =
  AuthedTenantsSlugAuthenticationConditionalAccessAppAccessAppIdRouteImport.update(
    {
      id: "/conditional-access/app-access/$appId",
      path: "/conditional-access/app-access/$appId",
      getParentRoute: () => AuthedTenantsSlugAuthenticationRoute,
    } as any,
  )
const AuthedTenantsSlugAuthenticationLocationsIdEditRoute =
  AuthedTenantsSlugAuthenticationLocationsIdEditRouteImport.update({
    id: "/locations/$id/edit",
    path: "/locations/$id/edit",
    getParentRoute: () => AuthedTenantsSlugAuthenticationRoute,
  } as any)
const AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRoute =
  AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteImport.update(
    {
      id: "/compliance/frameworks/$frameworkId/$frameworkVersion",
      path: "/compliance/frameworks/$frameworkId/$frameworkVersion",
      getParentRoute: () => AuthedTenantsSlugRoute,
    } as any,
  )
const AuthedTenantsSlugPostureComplianceControlsCatalogIdRoute =
  AuthedTenantsSlugPostureComplianceControlsCatalogIdRouteImport.update({
    id: "/posture/compliance/controls/$catalogId",
    path: "/posture/compliance/controls/$catalogId",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugPostureComplianceReportsKindRoute =
  AuthedTenantsSlugPostureComplianceReportsKindRouteImport.update({
    id: "/posture/compliance/reports/$kind",
    path: "/posture/compliance/reports/$kind",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugSecurityLogonCertificatesForestTrustRoute =
  AuthedTenantsSlugSecurityLogonCertificatesForestTrustRouteImport.update({
    id: "/security/logon-certificates/$forest/trust",
    path: "/security/logon-certificates/$forest/trust",
    getParentRoute: () => AuthedTenantsSlugRoute,
  } as any)
const AuthedTenantsSlugSettingsProductAreasAreaSetupRoute =
  AuthedTenantsSlugSettingsProductAreasAreaSetupRouteImport.update({
    id: "/$area/setup",
    path: "/$area/setup",
    getParentRoute: () => AuthedTenantsSlugSettingsProductAreasRoute,
  } as any)
const AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute =
  AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionReadinessRouteImport.update(
    {
      id: "/readiness",
      path: "/readiness",
      getParentRoute: () =>
        AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRoute,
    } as any,
  )
const AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRoute =
  AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteImport.update(
    {
      id: "/posture/compliance/frameworks/$frameworkId/$frameworkVersion",
      path: "/posture/compliance/frameworks/$frameworkId/$frameworkVersion",
      getParentRoute: () => AuthedTenantsSlugRoute,
    } as any,
  )
const AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute =
  AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionReadinessRouteImport.update(
    {
      id: "/readiness",
      path: "/readiness",
      getParentRoute: () =>
        AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  "/": typeof AuthedIndexRoute
  "/enroll-qr-jit": typeof EnrollQrJitRoute
  "/login": typeof LoginRoute
  "/account-health": typeof AuthedAccountHealthRoute
  "/private-access": typeof AuthedPrivateAccessRoute
  "/enroll/$token": typeof EnrollTokenRoute
  "/admins/invite": typeof AuthedAdminsInviteRoute
  "/api-keys/new": typeof AuthedApiKeysNewRoute
  "/automation-accounts/$id": typeof AuthedAutomationAccountsIdRoute
  "/automation-accounts/new": typeof AuthedAutomationAccountsNewRoute
  "/managed/teams": typeof AuthedManagedTeamsRoute
  "/tenant-records/$slug": typeof AuthedTenantRecordsSlugRouteWithChildren
  "/tenants/$slug": typeof AuthedTenantsSlugRouteWithChildren
  "/tenants/new": typeof AuthedTenantsNewRoute
  "/t/$slug/login": typeof TSlugLoginRouteWithChildren
  "/t/$slug/recovery": typeof TSlugRecoveryRouteWithChildren
  "/admins/": typeof AuthedAdminsIndexRoute
  "/api-keys/": typeof AuthedApiKeysIndexRoute
  "/audit/": typeof AuthedAuditIndexRoute
  "/automation-accounts/": typeof AuthedAutomationAccountsIndexRoute
  "/managed/": typeof AuthedManagedIndexRoute
  "/tenants/": typeof AuthedTenantsIndexRoute
  "/managed/tenants/$slug": typeof AuthedManagedTenantsSlugRoute
  "/tenant-records/$slug/access": typeof AuthedTenantRecordsSlugAccessRoute
  "/tenant-records/$slug/enrollment-issuers": typeof AuthedTenantRecordsSlugEnrollmentIssuersRoute
  "/tenant-records/$slug/subscription": typeof AuthedTenantRecordsSlugSubscriptionRoute
  "/tenants/$slug/access-requests": typeof AuthedTenantsSlugAccessRequestsRoute
  "/tenants/$slug/authentication": typeof AuthedTenantsSlugAuthenticationRouteWithChildren
  "/tenants/$slug/entitlement": typeof AuthedTenantsSlugEntitlementRoute
  "/tenants/$slug/oauth-dynreg": typeof AuthedTenantsSlugOauthDynregRoute
  "/tenants/$slug/settings": typeof AuthedTenantsSlugSettingsRouteWithChildren
  "/t/$slug/login/help": typeof TSlugLoginHelpRoute
  "/t/$slug/recovery/request": typeof TSlugRecoveryRequestRoute
  "/tenant-records/$slug/": typeof AuthedTenantRecordsSlugIndexRoute
  "/tenants/$slug/": typeof AuthedTenantsSlugIndexRoute
  "/tenant-records/$slug/administrators/invite": typeof AuthedTenantRecordsSlugAdministratorsInviteRoute
  "/tenants/$slug/access-governance/approval-policies": typeof AuthedTenantsSlugAccessGovernanceApprovalPoliciesRoute
  "/tenants/$slug/access-governance/approvers": typeof AuthedTenantsSlugAccessGovernanceApproversRoute
  "/tenants/$slug/access-governance/history": typeof AuthedTenantsSlugAccessGovernanceHistoryRoute
  "/tenants/$slug/access-governance/membership": typeof AuthedTenantsSlugAccessGovernanceMembershipRoute
  "/tenants/$slug/access-governance/policy": typeof AuthedTenantsSlugAccessGovernancePolicyRoute
  "/tenants/$slug/access-governance/recovery": typeof AuthedTenantsSlugAccessGovernanceRecoveryRoute
  "/tenants/$slug/admins/delegated": typeof AuthedTenantsSlugAdminsDelegatedRoute
  "/tenants/$slug/admins/invite": typeof AuthedTenantsSlugAdminsInviteRoute
  "/tenants/$slug/agents/$agentId": typeof AuthedTenantsSlugAgentsAgentIdRouteWithChildren
  "/tenants/$slug/agents/activity": typeof AuthedTenantsSlugAgentsActivityRoute
  "/tenants/$slug/agents/approval-analytics": typeof AuthedTenantsSlugAgentsApprovalAnalyticsRoute
  "/tenants/$slug/agents/approval-history": typeof AuthedTenantsSlugAgentsApprovalHistoryRoute
  "/tenants/$slug/agents/approval-thresholds": typeof AuthedTenantsSlugAgentsApprovalThresholdsRoute
  "/tenants/$slug/agents/budget-raises": typeof AuthedTenantsSlugAgentsBudgetRaisesRoute
  "/tenants/$slug/agents/budget-reset-anomalies": typeof AuthedTenantsSlugAgentsBudgetResetAnomaliesRoute
  "/tenants/$slug/agents/decision-reports": typeof AuthedTenantsSlugAgentsDecisionReportsRoute
  "/tenants/$slug/agents/delegation-governance": typeof AuthedTenantsSlugAgentsDelegationGovernanceRoute
  "/tenants/$slug/agents/edge": typeof AuthedTenantsSlugAgentsEdgeRoute
  "/tenants/$slug/agents/grants": typeof AuthedTenantsSlugAgentsGrantsRoute
  "/tenants/$slug/agents/guide": typeof AuthedTenantsSlugAgentsGuideRouteWithChildren
  "/tenants/$slug/agents/integrate": typeof AuthedTenantsSlugAgentsIntegrateRouteWithChildren
  "/tenants/$slug/agents/multi-agent": typeof AuthedTenantsSlugAgentsMultiAgentRoute
  "/tenants/$slug/agents/protected-resources": typeof AuthedTenantsSlugAgentsProtectedResourcesRouteWithChildren
  "/tenants/$slug/agents/standing-delegations": typeof AuthedTenantsSlugAgentsStandingDelegationsRoute
  "/tenants/$slug/agents/virtual-keys": typeof AuthedTenantsSlugAgentsVirtualKeysRoute
  "/tenants/$slug/applications/$appId": typeof AuthedTenantsSlugApplicationsAppIdRoute
  "/tenants/$slug/authentication/authenticators": typeof AuthedTenantsSlugAuthenticationAuthenticatorsRouteWithChildren
  "/tenants/$slug/authentication/federation": typeof AuthedTenantsSlugAuthenticationFederationRoute
  "/tenants/$slug/authentication/sign-in": typeof AuthedTenantsSlugAuthenticationSignInRouteWithChildren
  "/tenants/$slug/automation-accounts/$id": typeof AuthedTenantsSlugAutomationAccountsIdRoute
  "/tenants/$slug/automation-accounts/new": typeof AuthedTenantsSlugAutomationAccountsNewRoute
  "/tenants/$slug/directory/attributes": typeof AuthedTenantsSlugDirectoryAttributesRoute
  "/tenants/$slug/directory/authority": typeof AuthedTenantsSlugDirectoryAuthorityRoute
  "/tenants/$slug/directory/matching": typeof AuthedTenantsSlugDirectoryMatchingRoute
  "/tenants/$slug/directory/scim-operations": typeof AuthedTenantsSlugDirectoryScimOperationsRoute
  "/tenants/$slug/directory/scim-tokens": typeof AuthedTenantsSlugDirectoryScimTokensRoute
  "/tenants/$slug/groups/$groupId": typeof AuthedTenantsSlugGroupsGroupIdRoute
  "/tenants/$slug/groups/rules": typeof AuthedTenantsSlugGroupsRulesRoute
  "/tenants/$slug/non-human-identities/overview": typeof AuthedTenantsSlugNonHumanIdentitiesOverviewRoute
  "/tenants/$slug/organizations/$orgId": typeof AuthedTenantsSlugOrganizationsOrgIdRoute
  "/tenants/$slug/organizations/new": typeof AuthedTenantsSlugOrganizationsNewRoute
  "/tenants/$slug/provisioning/$connectionId": typeof AuthedTenantsSlugProvisioningConnectionIdRoute
  "/tenants/$slug/provisioning/new": typeof AuthedTenantsSlugProvisioningNewRoute
  "/tenants/$slug/security/workstations": typeof AuthedTenantsSlugSecurityWorkstationsRoute
  "/tenants/$slug/settings/automated-onboarding": typeof AuthedTenantsSlugSettingsAutomatedOnboardingRoute
  "/tenants/$slug/settings/branding": typeof AuthedTenantsSlugSettingsBrandingRoute
  "/tenants/$slug/settings/danger-zone": typeof AuthedTenantsSlugSettingsDangerZoneRoute
  "/tenants/$slug/settings/delegation": typeof AuthedTenantsSlugSettingsDelegationRoute
  "/tenants/$slug/settings/identity-matching": typeof AuthedTenantsSlugSettingsIdentityMatchingRoute
  "/tenants/$slug/settings/notifications": typeof AuthedTenantsSlugSettingsNotificationsRoute
  "/tenants/$slug/settings/product-areas": typeof AuthedTenantsSlugSettingsProductAreasRouteWithChildren
  "/tenants/$slug/settings/provisioning": typeof AuthedTenantsSlugSettingsProvisioningRoute
  "/tenants/$slug/settings/rp": typeof AuthedTenantsSlugSettingsRpRoute
  "/tenants/$slug/users/$userId": typeof AuthedTenantsSlugUsersUserIdRoute
  "/tenants/$slug/users/imports": typeof AuthedTenantsSlugUsersImportsRoute
  "/tenants/$slug/webhooks/$webhookId": typeof AuthedTenantsSlugWebhooksWebhookIdRouteWithChildren
  "/tenants/$slug/webhooks/new": typeof AuthedTenantsSlugWebhooksNewRoute
  "/t/$slug/recoveries/attest/$requestId": typeof TSlugRecoveriesAttestRequestIdRoute
  "/tenant-records/$slug/administrators/": typeof AuthedTenantRecordsSlugAdministratorsIndexRoute
  "/tenants/$slug/access-governance/": typeof AuthedTenantsSlugAccessGovernanceIndexRoute
  "/tenants/$slug/admins/": typeof AuthedTenantsSlugAdminsIndexRoute
  "/tenants/$slug/agents/": typeof AuthedTenantsSlugAgentsIndexRoute
  "/tenants/$slug/applications/": typeof AuthedTenantsSlugApplicationsIndexRoute
  "/tenants/$slug/audit/": typeof AuthedTenantsSlugAuditIndexRoute
  "/tenants/$slug/authentication/": typeof AuthedTenantsSlugAuthenticationIndexRoute
  "/tenants/$slug/automation-accounts/": typeof AuthedTenantsSlugAutomationAccountsIndexRoute
  "/tenants/$slug/compliance/": typeof AuthedTenantsSlugComplianceIndexRoute
  "/tenants/$slug/devices/": typeof AuthedTenantsSlugDevicesIndexRoute
  "/tenants/$slug/directory/": typeof AuthedTenantsSlugDirectoryIndexRoute
  "/tenants/$slug/getting-started/": typeof AuthedTenantsSlugGettingStartedIndexRoute
  "/tenants/$slug/groups/": typeof AuthedTenantsSlugGroupsIndexRoute
  "/tenants/$slug/identity-hygiene/": typeof AuthedTenantsSlugIdentityHygieneIndexRoute
  "/tenants/$slug/locked-out-users/": typeof AuthedTenantsSlugLockedOutUsersIndexRoute
  "/tenants/$slug/non-human-identities/": typeof AuthedTenantsSlugNonHumanIdentitiesIndexRoute
  "/tenants/$slug/onboarding-autotune/": typeof AuthedTenantsSlugOnboardingAutotuneIndexRoute
  "/tenants/$slug/onboarding-health/": typeof AuthedTenantsSlugOnboardingHealthIndexRoute
  "/tenants/$slug/organizations/": typeof AuthedTenantsSlugOrganizationsIndexRoute
  "/tenants/$slug/passkey-intelligence/": typeof AuthedTenantsSlugPasskeyIntelligenceIndexRoute
  "/tenants/$slug/passkeys/": typeof AuthedTenantsSlugPasskeysIndexRoute
  "/tenants/$slug/provisioning/": typeof AuthedTenantsSlugProvisioningIndexRoute
  "/tenants/$slug/settings/": typeof AuthedTenantsSlugSettingsIndexRoute
  "/tenants/$slug/users/": typeof AuthedTenantsSlugUsersIndexRoute
  "/tenants/$slug/webhooks/": typeof AuthedTenantsSlugWebhooksIndexRoute
  "/tenants/$slug/workload-issuers/": typeof AuthedTenantsSlugWorkloadIssuersIndexRoute
  "/tenants/$slug/access-governance/credential-recovery/$requestId": typeof AuthedTenantsSlugAccessGovernanceCredentialRecoveryRequestIdRoute
  "/tenants/$slug/agents/$agentId/policy": typeof AuthedTenantsSlugAgentsAgentIdPolicyRoute
  "/tenants/$slug/agents/guide/$type": typeof AuthedTenantsSlugAgentsGuideTypeRoute
  "/tenants/$slug/agents/integrate/api": typeof AuthedTenantsSlugAgentsIntegrateApiRoute
  "/tenants/$slug/agents/integrate/go-sdk": typeof AuthedTenantsSlugAgentsIntegrateGoSdkRoute
  "/tenants/$slug/agents/integrate/protect": typeof AuthedTenantsSlugAgentsIntegrateProtectRoute
  "/tenants/$slug/authentication/authenticators/identity-checks": typeof AuthedTenantsSlugAuthenticationAuthenticatorsIdentityChecksRoute
  "/tenants/$slug/authentication/authenticators/new": typeof AuthedTenantsSlugAuthenticationAuthenticatorsNewRoute
  "/tenants/$slug/authentication/conditional-access/$policyId": typeof AuthedTenantsSlugAuthenticationConditionalAccessPolicyIdRoute
  "/tenants/$slug/authentication/conditional-access/new": typeof AuthedTenantsSlugAuthenticationConditionalAccessNewRoute
  "/tenants/$slug/authentication/locations/new": typeof AuthedTenantsSlugAuthenticationLocationsNewRoute
  "/tenants/$slug/authentication/sign-in/methods": typeof AuthedTenantsSlugAuthenticationSignInMethodsRoute
  "/tenants/$slug/authentication/sign-in/passkeys": typeof AuthedTenantsSlugAuthenticationSignInPasskeysRoute
  "/tenants/$slug/authentication/sign-in/phone": typeof AuthedTenantsSlugAuthenticationSignInPhoneRoute
  "/tenants/$slug/authentication/sign-in/recovery": typeof AuthedTenantsSlugAuthenticationSignInRecoveryRoute
  "/tenants/$slug/authentication/sign-in/sessions": typeof AuthedTenantsSlugAuthenticationSignInSessionsRoute
  "/tenants/$slug/compliance/controls/$catalogId": typeof AuthedTenantsSlugComplianceControlsCatalogIdRoute
  "/tenants/$slug/directory/ad-inbound/$directoryId": typeof AuthedTenantsSlugDirectoryAdInboundDirectoryIdRoute
  "/tenants/$slug/directory/ad-inbound/new": typeof AuthedTenantsSlugDirectoryAdInboundNewRoute
  "/tenants/$slug/directory/ad-inbound/new-workday": typeof AuthedTenantsSlugDirectoryAdInboundNewWorkdayRoute
  "/tenants/$slug/security/frontline/badge-signin": typeof AuthedTenantsSlugSecurityFrontlineBadgeSigninRoute
  "/tenants/$slug/security/frontline/kiosk-pass": typeof AuthedTenantsSlugSecurityFrontlineKioskPassRoute
  "/tenants/$slug/settings/product-areas/reconciliation": typeof AuthedTenantsSlugSettingsProductAreasReconciliationRoute
  "/tenants/$slug/webhooks/$webhookId/edit": typeof AuthedTenantsSlugWebhooksWebhookIdEditRoute
  "/tenants/$slug/access-governance/credential-recovery/": typeof AuthedTenantsSlugAccessGovernanceCredentialRecoveryIndexRoute
  "/tenants/$slug/agents/integrate/": typeof AuthedTenantsSlugAgentsIntegrateIndexRoute
  "/tenants/$slug/applications/dynamic-registration/": typeof AuthedTenantsSlugApplicationsDynamicRegistrationIndexRoute
  "/tenants/$slug/authentication/authenticators/": typeof AuthedTenantsSlugAuthenticationAuthenticatorsIndexRoute
  "/tenants/$slug/authentication/conditional-access/": typeof AuthedTenantsSlugAuthenticationConditionalAccessIndexRoute
  "/tenants/$slug/authentication/sign-in/": typeof AuthedTenantsSlugAuthenticationSignInIndexRoute
  "/tenants/$slug/directory/ad-inbound/": typeof AuthedTenantsSlugDirectoryAdInboundIndexRoute
  "/tenants/$slug/posture/compliance/": typeof AuthedTenantsSlugPostureComplianceIndexRoute
  "/tenants/$slug/security/frontline/": typeof AuthedTenantsSlugSecurityFrontlineIndexRoute
  "/tenants/$slug/security/logon-certificates/": typeof AuthedTenantsSlugSecurityLogonCertificatesIndexRoute
  "/tenants/$slug/settings/product-areas/": typeof AuthedTenantsSlugSettingsProductAreasIndexRoute
  "/tenants/$slug/agents/protected-resources/$resource/custody": typeof AuthedTenantsSlugAgentsProtectedResourcesResourceCustodyRoute
  "/tenants/$slug/authentication/conditional-access/app-access/$appId": typeof AuthedTenantsSlugAuthenticationConditionalAccessAppAccessAppIdRoute
  "/tenants/$slug/authentication/locations/$id/edit": typeof AuthedTenantsSlugAuthenticationLocationsIdEditRoute
  "/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion": typeof AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren
  "/tenants/$slug/posture/compliance/controls/$catalogId": typeof AuthedTenantsSlugPostureComplianceControlsCatalogIdRoute
  "/tenants/$slug/posture/compliance/reports/$kind": typeof AuthedTenantsSlugPostureComplianceReportsKindRoute
  "/tenants/$slug/security/logon-certificates/$forest/trust": typeof AuthedTenantsSlugSecurityLogonCertificatesForestTrustRoute
  "/tenants/$slug/settings/product-areas/$area/setup": typeof AuthedTenantsSlugSettingsProductAreasAreaSetupRoute
  "/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion/readiness": typeof AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute
  "/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion": typeof AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren
  "/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion/readiness": typeof AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute
}
export interface FileRoutesByTo {
  "/enroll-qr-jit": typeof EnrollQrJitRoute
  "/login": typeof LoginRoute
  "/account-health": typeof AuthedAccountHealthRoute
  "/private-access": typeof AuthedPrivateAccessRoute
  "/enroll/$token": typeof EnrollTokenRoute
  "/": typeof AuthedIndexRoute
  "/admins/invite": typeof AuthedAdminsInviteRoute
  "/api-keys/new": typeof AuthedApiKeysNewRoute
  "/automation-accounts/$id": typeof AuthedAutomationAccountsIdRoute
  "/automation-accounts/new": typeof AuthedAutomationAccountsNewRoute
  "/managed/teams": typeof AuthedManagedTeamsRoute
  "/tenants/new": typeof AuthedTenantsNewRoute
  "/t/$slug/login": typeof TSlugLoginRouteWithChildren
  "/t/$slug/recovery": typeof TSlugRecoveryRouteWithChildren
  "/admins": typeof AuthedAdminsIndexRoute
  "/api-keys": typeof AuthedApiKeysIndexRoute
  "/audit": typeof AuthedAuditIndexRoute
  "/automation-accounts": typeof AuthedAutomationAccountsIndexRoute
  "/managed": typeof AuthedManagedIndexRoute
  "/tenants": typeof AuthedTenantsIndexRoute
  "/managed/tenants/$slug": typeof AuthedManagedTenantsSlugRoute
  "/tenant-records/$slug/access": typeof AuthedTenantRecordsSlugAccessRoute
  "/tenant-records/$slug/enrollment-issuers": typeof AuthedTenantRecordsSlugEnrollmentIssuersRoute
  "/tenant-records/$slug/subscription": typeof AuthedTenantRecordsSlugSubscriptionRoute
  "/tenants/$slug/access-requests": typeof AuthedTenantsSlugAccessRequestsRoute
  "/tenants/$slug/entitlement": typeof AuthedTenantsSlugEntitlementRoute
  "/tenants/$slug/oauth-dynreg": typeof AuthedTenantsSlugOauthDynregRoute
  "/t/$slug/login/help": typeof TSlugLoginHelpRoute
  "/t/$slug/recovery/request": typeof TSlugRecoveryRequestRoute
  "/tenant-records/$slug": typeof AuthedTenantRecordsSlugIndexRoute
  "/tenants/$slug": typeof AuthedTenantsSlugIndexRoute
  "/tenant-records/$slug/administrators/invite": typeof AuthedTenantRecordsSlugAdministratorsInviteRoute
  "/tenants/$slug/access-governance/approval-policies": typeof AuthedTenantsSlugAccessGovernanceApprovalPoliciesRoute
  "/tenants/$slug/access-governance/approvers": typeof AuthedTenantsSlugAccessGovernanceApproversRoute
  "/tenants/$slug/access-governance/history": typeof AuthedTenantsSlugAccessGovernanceHistoryRoute
  "/tenants/$slug/access-governance/membership": typeof AuthedTenantsSlugAccessGovernanceMembershipRoute
  "/tenants/$slug/access-governance/policy": typeof AuthedTenantsSlugAccessGovernancePolicyRoute
  "/tenants/$slug/access-governance/recovery": typeof AuthedTenantsSlugAccessGovernanceRecoveryRoute
  "/tenants/$slug/admins/delegated": typeof AuthedTenantsSlugAdminsDelegatedRoute
  "/tenants/$slug/admins/invite": typeof AuthedTenantsSlugAdminsInviteRoute
  "/tenants/$slug/agents/$agentId": typeof AuthedTenantsSlugAgentsAgentIdRouteWithChildren
  "/tenants/$slug/agents/activity": typeof AuthedTenantsSlugAgentsActivityRoute
  "/tenants/$slug/agents/approval-analytics": typeof AuthedTenantsSlugAgentsApprovalAnalyticsRoute
  "/tenants/$slug/agents/approval-history": typeof AuthedTenantsSlugAgentsApprovalHistoryRoute
  "/tenants/$slug/agents/approval-thresholds": typeof AuthedTenantsSlugAgentsApprovalThresholdsRoute
  "/tenants/$slug/agents/budget-raises": typeof AuthedTenantsSlugAgentsBudgetRaisesRoute
  "/tenants/$slug/agents/budget-reset-anomalies": typeof AuthedTenantsSlugAgentsBudgetResetAnomaliesRoute
  "/tenants/$slug/agents/decision-reports": typeof AuthedTenantsSlugAgentsDecisionReportsRoute
  "/tenants/$slug/agents/delegation-governance": typeof AuthedTenantsSlugAgentsDelegationGovernanceRoute
  "/tenants/$slug/agents/edge": typeof AuthedTenantsSlugAgentsEdgeRoute
  "/tenants/$slug/agents/grants": typeof AuthedTenantsSlugAgentsGrantsRoute
  "/tenants/$slug/agents/guide": typeof AuthedTenantsSlugAgentsGuideRouteWithChildren
  "/tenants/$slug/agents/multi-agent": typeof AuthedTenantsSlugAgentsMultiAgentRoute
  "/tenants/$slug/agents/protected-resources": typeof AuthedTenantsSlugAgentsProtectedResourcesRouteWithChildren
  "/tenants/$slug/agents/standing-delegations": typeof AuthedTenantsSlugAgentsStandingDelegationsRoute
  "/tenants/$slug/agents/virtual-keys": typeof AuthedTenantsSlugAgentsVirtualKeysRoute
  "/tenants/$slug/applications/$appId": typeof AuthedTenantsSlugApplicationsAppIdRoute
  "/tenants/$slug/authentication/federation": typeof AuthedTenantsSlugAuthenticationFederationRoute
  "/tenants/$slug/automation-accounts/$id": typeof AuthedTenantsSlugAutomationAccountsIdRoute
  "/tenants/$slug/automation-accounts/new": typeof AuthedTenantsSlugAutomationAccountsNewRoute
  "/tenants/$slug/directory/attributes": typeof AuthedTenantsSlugDirectoryAttributesRoute
  "/tenants/$slug/directory/authority": typeof AuthedTenantsSlugDirectoryAuthorityRoute
  "/tenants/$slug/directory/matching": typeof AuthedTenantsSlugDirectoryMatchingRoute
  "/tenants/$slug/directory/scim-operations": typeof AuthedTenantsSlugDirectoryScimOperationsRoute
  "/tenants/$slug/directory/scim-tokens": typeof AuthedTenantsSlugDirectoryScimTokensRoute
  "/tenants/$slug/groups/$groupId": typeof AuthedTenantsSlugGroupsGroupIdRoute
  "/tenants/$slug/groups/rules": typeof AuthedTenantsSlugGroupsRulesRoute
  "/tenants/$slug/non-human-identities/overview": typeof AuthedTenantsSlugNonHumanIdentitiesOverviewRoute
  "/tenants/$slug/organizations/$orgId": typeof AuthedTenantsSlugOrganizationsOrgIdRoute
  "/tenants/$slug/organizations/new": typeof AuthedTenantsSlugOrganizationsNewRoute
  "/tenants/$slug/provisioning/$connectionId": typeof AuthedTenantsSlugProvisioningConnectionIdRoute
  "/tenants/$slug/provisioning/new": typeof AuthedTenantsSlugProvisioningNewRoute
  "/tenants/$slug/security/workstations": typeof AuthedTenantsSlugSecurityWorkstationsRoute
  "/tenants/$slug/settings/automated-onboarding": typeof AuthedTenantsSlugSettingsAutomatedOnboardingRoute
  "/tenants/$slug/settings/branding": typeof AuthedTenantsSlugSettingsBrandingRoute
  "/tenants/$slug/settings/danger-zone": typeof AuthedTenantsSlugSettingsDangerZoneRoute
  "/tenants/$slug/settings/delegation": typeof AuthedTenantsSlugSettingsDelegationRoute
  "/tenants/$slug/settings/identity-matching": typeof AuthedTenantsSlugSettingsIdentityMatchingRoute
  "/tenants/$slug/settings/notifications": typeof AuthedTenantsSlugSettingsNotificationsRoute
  "/tenants/$slug/settings/provisioning": typeof AuthedTenantsSlugSettingsProvisioningRoute
  "/tenants/$slug/settings/rp": typeof AuthedTenantsSlugSettingsRpRoute
  "/tenants/$slug/users/$userId": typeof AuthedTenantsSlugUsersUserIdRoute
  "/tenants/$slug/users/imports": typeof AuthedTenantsSlugUsersImportsRoute
  "/tenants/$slug/webhooks/$webhookId": typeof AuthedTenantsSlugWebhooksWebhookIdRouteWithChildren
  "/tenants/$slug/webhooks/new": typeof AuthedTenantsSlugWebhooksNewRoute
  "/t/$slug/recoveries/attest/$requestId": typeof TSlugRecoveriesAttestRequestIdRoute
  "/tenant-records/$slug/administrators": typeof AuthedTenantRecordsSlugAdministratorsIndexRoute
  "/tenants/$slug/access-governance": typeof AuthedTenantsSlugAccessGovernanceIndexRoute
  "/tenants/$slug/admins": typeof AuthedTenantsSlugAdminsIndexRoute
  "/tenants/$slug/agents": typeof AuthedTenantsSlugAgentsIndexRoute
  "/tenants/$slug/applications": typeof AuthedTenantsSlugApplicationsIndexRoute
  "/tenants/$slug/audit": typeof AuthedTenantsSlugAuditIndexRoute
  "/tenants/$slug/authentication": typeof AuthedTenantsSlugAuthenticationIndexRoute
  "/tenants/$slug/automation-accounts": typeof AuthedTenantsSlugAutomationAccountsIndexRoute
  "/tenants/$slug/compliance": typeof AuthedTenantsSlugComplianceIndexRoute
  "/tenants/$slug/devices": typeof AuthedTenantsSlugDevicesIndexRoute
  "/tenants/$slug/directory": typeof AuthedTenantsSlugDirectoryIndexRoute
  "/tenants/$slug/getting-started": typeof AuthedTenantsSlugGettingStartedIndexRoute
  "/tenants/$slug/groups": typeof AuthedTenantsSlugGroupsIndexRoute
  "/tenants/$slug/identity-hygiene": typeof AuthedTenantsSlugIdentityHygieneIndexRoute
  "/tenants/$slug/locked-out-users": typeof AuthedTenantsSlugLockedOutUsersIndexRoute
  "/tenants/$slug/non-human-identities": typeof AuthedTenantsSlugNonHumanIdentitiesIndexRoute
  "/tenants/$slug/onboarding-autotune": typeof AuthedTenantsSlugOnboardingAutotuneIndexRoute
  "/tenants/$slug/onboarding-health": typeof AuthedTenantsSlugOnboardingHealthIndexRoute
  "/tenants/$slug/organizations": typeof AuthedTenantsSlugOrganizationsIndexRoute
  "/tenants/$slug/passkey-intelligence": typeof AuthedTenantsSlugPasskeyIntelligenceIndexRoute
  "/tenants/$slug/passkeys": typeof AuthedTenantsSlugPasskeysIndexRoute
  "/tenants/$slug/provisioning": typeof AuthedTenantsSlugProvisioningIndexRoute
  "/tenants/$slug/settings": typeof AuthedTenantsSlugSettingsIndexRoute
  "/tenants/$slug/users": typeof AuthedTenantsSlugUsersIndexRoute
  "/tenants/$slug/webhooks": typeof AuthedTenantsSlugWebhooksIndexRoute
  "/tenants/$slug/workload-issuers": typeof AuthedTenantsSlugWorkloadIssuersIndexRoute
  "/tenants/$slug/access-governance/credential-recovery/$requestId": typeof AuthedTenantsSlugAccessGovernanceCredentialRecoveryRequestIdRoute
  "/tenants/$slug/agents/$agentId/policy": typeof AuthedTenantsSlugAgentsAgentIdPolicyRoute
  "/tenants/$slug/agents/guide/$type": typeof AuthedTenantsSlugAgentsGuideTypeRoute
  "/tenants/$slug/agents/integrate/api": typeof AuthedTenantsSlugAgentsIntegrateApiRoute
  "/tenants/$slug/agents/integrate/go-sdk": typeof AuthedTenantsSlugAgentsIntegrateGoSdkRoute
  "/tenants/$slug/agents/integrate/protect": typeof AuthedTenantsSlugAgentsIntegrateProtectRoute
  "/tenants/$slug/authentication/authenticators/identity-checks": typeof AuthedTenantsSlugAuthenticationAuthenticatorsIdentityChecksRoute
  "/tenants/$slug/authentication/authenticators/new": typeof AuthedTenantsSlugAuthenticationAuthenticatorsNewRoute
  "/tenants/$slug/authentication/conditional-access/$policyId": typeof AuthedTenantsSlugAuthenticationConditionalAccessPolicyIdRoute
  "/tenants/$slug/authentication/conditional-access/new": typeof AuthedTenantsSlugAuthenticationConditionalAccessNewRoute
  "/tenants/$slug/authentication/locations/new": typeof AuthedTenantsSlugAuthenticationLocationsNewRoute
  "/tenants/$slug/authentication/sign-in/methods": typeof AuthedTenantsSlugAuthenticationSignInMethodsRoute
  "/tenants/$slug/authentication/sign-in/passkeys": typeof AuthedTenantsSlugAuthenticationSignInPasskeysRoute
  "/tenants/$slug/authentication/sign-in/phone": typeof AuthedTenantsSlugAuthenticationSignInPhoneRoute
  "/tenants/$slug/authentication/sign-in/recovery": typeof AuthedTenantsSlugAuthenticationSignInRecoveryRoute
  "/tenants/$slug/authentication/sign-in/sessions": typeof AuthedTenantsSlugAuthenticationSignInSessionsRoute
  "/tenants/$slug/compliance/controls/$catalogId": typeof AuthedTenantsSlugComplianceControlsCatalogIdRoute
  "/tenants/$slug/directory/ad-inbound/$directoryId": typeof AuthedTenantsSlugDirectoryAdInboundDirectoryIdRoute
  "/tenants/$slug/directory/ad-inbound/new": typeof AuthedTenantsSlugDirectoryAdInboundNewRoute
  "/tenants/$slug/directory/ad-inbound/new-workday": typeof AuthedTenantsSlugDirectoryAdInboundNewWorkdayRoute
  "/tenants/$slug/security/frontline/badge-signin": typeof AuthedTenantsSlugSecurityFrontlineBadgeSigninRoute
  "/tenants/$slug/security/frontline/kiosk-pass": typeof AuthedTenantsSlugSecurityFrontlineKioskPassRoute
  "/tenants/$slug/settings/product-areas/reconciliation": typeof AuthedTenantsSlugSettingsProductAreasReconciliationRoute
  "/tenants/$slug/webhooks/$webhookId/edit": typeof AuthedTenantsSlugWebhooksWebhookIdEditRoute
  "/tenants/$slug/access-governance/credential-recovery": typeof AuthedTenantsSlugAccessGovernanceCredentialRecoveryIndexRoute
  "/tenants/$slug/agents/integrate": typeof AuthedTenantsSlugAgentsIntegrateIndexRoute
  "/tenants/$slug/applications/dynamic-registration": typeof AuthedTenantsSlugApplicationsDynamicRegistrationIndexRoute
  "/tenants/$slug/authentication/authenticators": typeof AuthedTenantsSlugAuthenticationAuthenticatorsIndexRoute
  "/tenants/$slug/authentication/conditional-access": typeof AuthedTenantsSlugAuthenticationConditionalAccessIndexRoute
  "/tenants/$slug/authentication/sign-in": typeof AuthedTenantsSlugAuthenticationSignInIndexRoute
  "/tenants/$slug/directory/ad-inbound": typeof AuthedTenantsSlugDirectoryAdInboundIndexRoute
  "/tenants/$slug/posture/compliance": typeof AuthedTenantsSlugPostureComplianceIndexRoute
  "/tenants/$slug/security/frontline": typeof AuthedTenantsSlugSecurityFrontlineIndexRoute
  "/tenants/$slug/security/logon-certificates": typeof AuthedTenantsSlugSecurityLogonCertificatesIndexRoute
  "/tenants/$slug/settings/product-areas": typeof AuthedTenantsSlugSettingsProductAreasIndexRoute
  "/tenants/$slug/agents/protected-resources/$resource/custody": typeof AuthedTenantsSlugAgentsProtectedResourcesResourceCustodyRoute
  "/tenants/$slug/authentication/conditional-access/app-access/$appId": typeof AuthedTenantsSlugAuthenticationConditionalAccessAppAccessAppIdRoute
  "/tenants/$slug/authentication/locations/$id/edit": typeof AuthedTenantsSlugAuthenticationLocationsIdEditRoute
  "/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion": typeof AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren
  "/tenants/$slug/posture/compliance/controls/$catalogId": typeof AuthedTenantsSlugPostureComplianceControlsCatalogIdRoute
  "/tenants/$slug/posture/compliance/reports/$kind": typeof AuthedTenantsSlugPostureComplianceReportsKindRoute
  "/tenants/$slug/security/logon-certificates/$forest/trust": typeof AuthedTenantsSlugSecurityLogonCertificatesForestTrustRoute
  "/tenants/$slug/settings/product-areas/$area/setup": typeof AuthedTenantsSlugSettingsProductAreasAreaSetupRoute
  "/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion/readiness": typeof AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute
  "/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion": typeof AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren
  "/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion/readiness": typeof AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authed": typeof AuthedRouteWithChildren
  "/enroll-qr-jit": typeof EnrollQrJitRoute
  "/login": typeof LoginRoute
  "/_authed/account-health": typeof AuthedAccountHealthRoute
  "/_authed/private-access": typeof AuthedPrivateAccessRoute
  "/enroll/$token": typeof EnrollTokenRoute
  "/_authed/": typeof AuthedIndexRoute
  "/_authed/admins/invite": typeof AuthedAdminsInviteRoute
  "/_authed/api-keys/new": typeof AuthedApiKeysNewRoute
  "/_authed/automation-accounts/$id": typeof AuthedAutomationAccountsIdRoute
  "/_authed/automation-accounts/new": typeof AuthedAutomationAccountsNewRoute
  "/_authed/managed/teams": typeof AuthedManagedTeamsRoute
  "/_authed/tenant-records/$slug": typeof AuthedTenantRecordsSlugRouteWithChildren
  "/_authed/tenants/$slug": typeof AuthedTenantsSlugRouteWithChildren
  "/_authed/tenants/new": typeof AuthedTenantsNewRoute
  "/t/$slug/login": typeof TSlugLoginRouteWithChildren
  "/t/$slug/recovery": typeof TSlugRecoveryRouteWithChildren
  "/_authed/admins/": typeof AuthedAdminsIndexRoute
  "/_authed/api-keys/": typeof AuthedApiKeysIndexRoute
  "/_authed/audit/": typeof AuthedAuditIndexRoute
  "/_authed/automation-accounts/": typeof AuthedAutomationAccountsIndexRoute
  "/_authed/managed/": typeof AuthedManagedIndexRoute
  "/_authed/tenants/": typeof AuthedTenantsIndexRoute
  "/_authed/managed/tenants/$slug": typeof AuthedManagedTenantsSlugRoute
  "/_authed/tenant-records/$slug/access": typeof AuthedTenantRecordsSlugAccessRoute
  "/_authed/tenant-records/$slug/enrollment-issuers": typeof AuthedTenantRecordsSlugEnrollmentIssuersRoute
  "/_authed/tenant-records/$slug/subscription": typeof AuthedTenantRecordsSlugSubscriptionRoute
  "/_authed/tenants/$slug/access-requests": typeof AuthedTenantsSlugAccessRequestsRoute
  "/_authed/tenants/$slug/authentication": typeof AuthedTenantsSlugAuthenticationRouteWithChildren
  "/_authed/tenants/$slug/entitlement": typeof AuthedTenantsSlugEntitlementRoute
  "/_authed/tenants/$slug/oauth-dynreg": typeof AuthedTenantsSlugOauthDynregRoute
  "/_authed/tenants/$slug/settings": typeof AuthedTenantsSlugSettingsRouteWithChildren
  "/t/$slug/login/help": typeof TSlugLoginHelpRoute
  "/t/$slug/recovery/request": typeof TSlugRecoveryRequestRoute
  "/_authed/tenant-records/$slug/": typeof AuthedTenantRecordsSlugIndexRoute
  "/_authed/tenants/$slug/": typeof AuthedTenantsSlugIndexRoute
  "/_authed/tenant-records/$slug/administrators/invite": typeof AuthedTenantRecordsSlugAdministratorsInviteRoute
  "/_authed/tenants/$slug/access-governance/approval-policies": typeof AuthedTenantsSlugAccessGovernanceApprovalPoliciesRoute
  "/_authed/tenants/$slug/access-governance/approvers": typeof AuthedTenantsSlugAccessGovernanceApproversRoute
  "/_authed/tenants/$slug/access-governance/history": typeof AuthedTenantsSlugAccessGovernanceHistoryRoute
  "/_authed/tenants/$slug/access-governance/membership": typeof AuthedTenantsSlugAccessGovernanceMembershipRoute
  "/_authed/tenants/$slug/access-governance/policy": typeof AuthedTenantsSlugAccessGovernancePolicyRoute
  "/_authed/tenants/$slug/access-governance/recovery": typeof AuthedTenantsSlugAccessGovernanceRecoveryRoute
  "/_authed/tenants/$slug/admins/delegated": typeof AuthedTenantsSlugAdminsDelegatedRoute
  "/_authed/tenants/$slug/admins/invite": typeof AuthedTenantsSlugAdminsInviteRoute
  "/_authed/tenants/$slug/agents/$agentId": typeof AuthedTenantsSlugAgentsAgentIdRouteWithChildren
  "/_authed/tenants/$slug/agents/activity": typeof AuthedTenantsSlugAgentsActivityRoute
  "/_authed/tenants/$slug/agents/approval-analytics": typeof AuthedTenantsSlugAgentsApprovalAnalyticsRoute
  "/_authed/tenants/$slug/agents/approval-history": typeof AuthedTenantsSlugAgentsApprovalHistoryRoute
  "/_authed/tenants/$slug/agents/approval-thresholds": typeof AuthedTenantsSlugAgentsApprovalThresholdsRoute
  "/_authed/tenants/$slug/agents/budget-raises": typeof AuthedTenantsSlugAgentsBudgetRaisesRoute
  "/_authed/tenants/$slug/agents/budget-reset-anomalies": typeof AuthedTenantsSlugAgentsBudgetResetAnomaliesRoute
  "/_authed/tenants/$slug/agents/decision-reports": typeof AuthedTenantsSlugAgentsDecisionReportsRoute
  "/_authed/tenants/$slug/agents/delegation-governance": typeof AuthedTenantsSlugAgentsDelegationGovernanceRoute
  "/_authed/tenants/$slug/agents/edge": typeof AuthedTenantsSlugAgentsEdgeRoute
  "/_authed/tenants/$slug/agents/grants": typeof AuthedTenantsSlugAgentsGrantsRoute
  "/_authed/tenants/$slug/agents/guide": typeof AuthedTenantsSlugAgentsGuideRouteWithChildren
  "/_authed/tenants/$slug/agents/integrate": typeof AuthedTenantsSlugAgentsIntegrateRouteWithChildren
  "/_authed/tenants/$slug/agents/multi-agent": typeof AuthedTenantsSlugAgentsMultiAgentRoute
  "/_authed/tenants/$slug/agents/protected-resources": typeof AuthedTenantsSlugAgentsProtectedResourcesRouteWithChildren
  "/_authed/tenants/$slug/agents/standing-delegations": typeof AuthedTenantsSlugAgentsStandingDelegationsRoute
  "/_authed/tenants/$slug/agents/virtual-keys": typeof AuthedTenantsSlugAgentsVirtualKeysRoute
  "/_authed/tenants/$slug/applications/$appId": typeof AuthedTenantsSlugApplicationsAppIdRoute
  "/_authed/tenants/$slug/authentication/authenticators": typeof AuthedTenantsSlugAuthenticationAuthenticatorsRouteWithChildren
  "/_authed/tenants/$slug/authentication/federation": typeof AuthedTenantsSlugAuthenticationFederationRoute
  "/_authed/tenants/$slug/authentication/sign-in": typeof AuthedTenantsSlugAuthenticationSignInRouteWithChildren
  "/_authed/tenants/$slug/automation-accounts/$id": typeof AuthedTenantsSlugAutomationAccountsIdRoute
  "/_authed/tenants/$slug/automation-accounts/new": typeof AuthedTenantsSlugAutomationAccountsNewRoute
  "/_authed/tenants/$slug/directory/attributes": typeof AuthedTenantsSlugDirectoryAttributesRoute
  "/_authed/tenants/$slug/directory/authority": typeof AuthedTenantsSlugDirectoryAuthorityRoute
  "/_authed/tenants/$slug/directory/matching": typeof AuthedTenantsSlugDirectoryMatchingRoute
  "/_authed/tenants/$slug/directory/scim-operations": typeof AuthedTenantsSlugDirectoryScimOperationsRoute
  "/_authed/tenants/$slug/directory/scim-tokens": typeof AuthedTenantsSlugDirectoryScimTokensRoute
  "/_authed/tenants/$slug/groups/$groupId": typeof AuthedTenantsSlugGroupsGroupIdRoute
  "/_authed/tenants/$slug/groups/rules": typeof AuthedTenantsSlugGroupsRulesRoute
  "/_authed/tenants/$slug/non-human-identities/overview": typeof AuthedTenantsSlugNonHumanIdentitiesOverviewRoute
  "/_authed/tenants/$slug/organizations/$orgId": typeof AuthedTenantsSlugOrganizationsOrgIdRoute
  "/_authed/tenants/$slug/organizations/new": typeof AuthedTenantsSlugOrganizationsNewRoute
  "/_authed/tenants/$slug/provisioning/$connectionId": typeof AuthedTenantsSlugProvisioningConnectionIdRoute
  "/_authed/tenants/$slug/provisioning/new": typeof AuthedTenantsSlugProvisioningNewRoute
  "/_authed/tenants/$slug/security/workstations": typeof AuthedTenantsSlugSecurityWorkstationsRoute
  "/_authed/tenants/$slug/settings/automated-onboarding": typeof AuthedTenantsSlugSettingsAutomatedOnboardingRoute
  "/_authed/tenants/$slug/settings/branding": typeof AuthedTenantsSlugSettingsBrandingRoute
  "/_authed/tenants/$slug/settings/danger-zone": typeof AuthedTenantsSlugSettingsDangerZoneRoute
  "/_authed/tenants/$slug/settings/delegation": typeof AuthedTenantsSlugSettingsDelegationRoute
  "/_authed/tenants/$slug/settings/identity-matching": typeof AuthedTenantsSlugSettingsIdentityMatchingRoute
  "/_authed/tenants/$slug/settings/notifications": typeof AuthedTenantsSlugSettingsNotificationsRoute
  "/_authed/tenants/$slug/settings/product-areas": typeof AuthedTenantsSlugSettingsProductAreasRouteWithChildren
  "/_authed/tenants/$slug/settings/provisioning": typeof AuthedTenantsSlugSettingsProvisioningRoute
  "/_authed/tenants/$slug/settings/rp": typeof AuthedTenantsSlugSettingsRpRoute
  "/_authed/tenants/$slug/users/$userId": typeof AuthedTenantsSlugUsersUserIdRoute
  "/_authed/tenants/$slug/users/imports": typeof AuthedTenantsSlugUsersImportsRoute
  "/_authed/tenants/$slug/webhooks/$webhookId": typeof AuthedTenantsSlugWebhooksWebhookIdRouteWithChildren
  "/_authed/tenants/$slug/webhooks/new": typeof AuthedTenantsSlugWebhooksNewRoute
  "/t/$slug/recoveries/attest/$requestId": typeof TSlugRecoveriesAttestRequestIdRoute
  "/_authed/tenant-records/$slug/administrators/": typeof AuthedTenantRecordsSlugAdministratorsIndexRoute
  "/_authed/tenants/$slug/access-governance/": typeof AuthedTenantsSlugAccessGovernanceIndexRoute
  "/_authed/tenants/$slug/admins/": typeof AuthedTenantsSlugAdminsIndexRoute
  "/_authed/tenants/$slug/agents/": typeof AuthedTenantsSlugAgentsIndexRoute
  "/_authed/tenants/$slug/applications/": typeof AuthedTenantsSlugApplicationsIndexRoute
  "/_authed/tenants/$slug/audit/": typeof AuthedTenantsSlugAuditIndexRoute
  "/_authed/tenants/$slug/authentication/": typeof AuthedTenantsSlugAuthenticationIndexRoute
  "/_authed/tenants/$slug/automation-accounts/": typeof AuthedTenantsSlugAutomationAccountsIndexRoute
  "/_authed/tenants/$slug/compliance/": typeof AuthedTenantsSlugComplianceIndexRoute
  "/_authed/tenants/$slug/devices/": typeof AuthedTenantsSlugDevicesIndexRoute
  "/_authed/tenants/$slug/directory/": typeof AuthedTenantsSlugDirectoryIndexRoute
  "/_authed/tenants/$slug/getting-started/": typeof AuthedTenantsSlugGettingStartedIndexRoute
  "/_authed/tenants/$slug/groups/": typeof AuthedTenantsSlugGroupsIndexRoute
  "/_authed/tenants/$slug/identity-hygiene/": typeof AuthedTenantsSlugIdentityHygieneIndexRoute
  "/_authed/tenants/$slug/locked-out-users/": typeof AuthedTenantsSlugLockedOutUsersIndexRoute
  "/_authed/tenants/$slug/non-human-identities/": typeof AuthedTenantsSlugNonHumanIdentitiesIndexRoute
  "/_authed/tenants/$slug/onboarding-autotune/": typeof AuthedTenantsSlugOnboardingAutotuneIndexRoute
  "/_authed/tenants/$slug/onboarding-health/": typeof AuthedTenantsSlugOnboardingHealthIndexRoute
  "/_authed/tenants/$slug/organizations/": typeof AuthedTenantsSlugOrganizationsIndexRoute
  "/_authed/tenants/$slug/passkey-intelligence/": typeof AuthedTenantsSlugPasskeyIntelligenceIndexRoute
  "/_authed/tenants/$slug/passkeys/": typeof AuthedTenantsSlugPasskeysIndexRoute
  "/_authed/tenants/$slug/provisioning/": typeof AuthedTenantsSlugProvisioningIndexRoute
  "/_authed/tenants/$slug/settings/": typeof AuthedTenantsSlugSettingsIndexRoute
  "/_authed/tenants/$slug/users/": typeof AuthedTenantsSlugUsersIndexRoute
  "/_authed/tenants/$slug/webhooks/": typeof AuthedTenantsSlugWebhooksIndexRoute
  "/_authed/tenants/$slug/workload-issuers/": typeof AuthedTenantsSlugWorkloadIssuersIndexRoute
  "/_authed/tenants/$slug/access-governance/credential-recovery/$requestId": typeof AuthedTenantsSlugAccessGovernanceCredentialRecoveryRequestIdRoute
  "/_authed/tenants/$slug/agents/$agentId/policy": typeof AuthedTenantsSlugAgentsAgentIdPolicyRoute
  "/_authed/tenants/$slug/agents/guide/$type": typeof AuthedTenantsSlugAgentsGuideTypeRoute
  "/_authed/tenants/$slug/agents/integrate/api": typeof AuthedTenantsSlugAgentsIntegrateApiRoute
  "/_authed/tenants/$slug/agents/integrate/go-sdk": typeof AuthedTenantsSlugAgentsIntegrateGoSdkRoute
  "/_authed/tenants/$slug/agents/integrate/protect": typeof AuthedTenantsSlugAgentsIntegrateProtectRoute
  "/_authed/tenants/$slug/authentication/authenticators/identity-checks": typeof AuthedTenantsSlugAuthenticationAuthenticatorsIdentityChecksRoute
  "/_authed/tenants/$slug/authentication/authenticators/new": typeof AuthedTenantsSlugAuthenticationAuthenticatorsNewRoute
  "/_authed/tenants/$slug/authentication/conditional-access/$policyId": typeof AuthedTenantsSlugAuthenticationConditionalAccessPolicyIdRoute
  "/_authed/tenants/$slug/authentication/conditional-access/new": typeof AuthedTenantsSlugAuthenticationConditionalAccessNewRoute
  "/_authed/tenants/$slug/authentication/locations/new": typeof AuthedTenantsSlugAuthenticationLocationsNewRoute
  "/_authed/tenants/$slug/authentication/sign-in/methods": typeof AuthedTenantsSlugAuthenticationSignInMethodsRoute
  "/_authed/tenants/$slug/authentication/sign-in/passkeys": typeof AuthedTenantsSlugAuthenticationSignInPasskeysRoute
  "/_authed/tenants/$slug/authentication/sign-in/phone": typeof AuthedTenantsSlugAuthenticationSignInPhoneRoute
  "/_authed/tenants/$slug/authentication/sign-in/recovery": typeof AuthedTenantsSlugAuthenticationSignInRecoveryRoute
  "/_authed/tenants/$slug/authentication/sign-in/sessions": typeof AuthedTenantsSlugAuthenticationSignInSessionsRoute
  "/_authed/tenants/$slug/compliance/controls/$catalogId": typeof AuthedTenantsSlugComplianceControlsCatalogIdRoute
  "/_authed/tenants/$slug/directory/ad-inbound/$directoryId": typeof AuthedTenantsSlugDirectoryAdInboundDirectoryIdRoute
  "/_authed/tenants/$slug/directory/ad-inbound/new": typeof AuthedTenantsSlugDirectoryAdInboundNewRoute
  "/_authed/tenants/$slug/directory/ad-inbound/new-workday": typeof AuthedTenantsSlugDirectoryAdInboundNewWorkdayRoute
  "/_authed/tenants/$slug/security/frontline/badge-signin": typeof AuthedTenantsSlugSecurityFrontlineBadgeSigninRoute
  "/_authed/tenants/$slug/security/frontline/kiosk-pass": typeof AuthedTenantsSlugSecurityFrontlineKioskPassRoute
  "/_authed/tenants/$slug/settings/product-areas/reconciliation": typeof AuthedTenantsSlugSettingsProductAreasReconciliationRoute
  "/_authed/tenants/$slug/webhooks/$webhookId/edit": typeof AuthedTenantsSlugWebhooksWebhookIdEditRoute
  "/_authed/tenants/$slug/access-governance/credential-recovery/": typeof AuthedTenantsSlugAccessGovernanceCredentialRecoveryIndexRoute
  "/_authed/tenants/$slug/agents/integrate/": typeof AuthedTenantsSlugAgentsIntegrateIndexRoute
  "/_authed/tenants/$slug/applications/dynamic-registration/": typeof AuthedTenantsSlugApplicationsDynamicRegistrationIndexRoute
  "/_authed/tenants/$slug/authentication/authenticators/": typeof AuthedTenantsSlugAuthenticationAuthenticatorsIndexRoute
  "/_authed/tenants/$slug/authentication/conditional-access/": typeof AuthedTenantsSlugAuthenticationConditionalAccessIndexRoute
  "/_authed/tenants/$slug/authentication/sign-in/": typeof AuthedTenantsSlugAuthenticationSignInIndexRoute
  "/_authed/tenants/$slug/directory/ad-inbound/": typeof AuthedTenantsSlugDirectoryAdInboundIndexRoute
  "/_authed/tenants/$slug/posture/compliance/": typeof AuthedTenantsSlugPostureComplianceIndexRoute
  "/_authed/tenants/$slug/security/frontline/": typeof AuthedTenantsSlugSecurityFrontlineIndexRoute
  "/_authed/tenants/$slug/security/logon-certificates/": typeof AuthedTenantsSlugSecurityLogonCertificatesIndexRoute
  "/_authed/tenants/$slug/settings/product-areas/": typeof AuthedTenantsSlugSettingsProductAreasIndexRoute
  "/_authed/tenants/$slug/agents/protected-resources/$resource/custody": typeof AuthedTenantsSlugAgentsProtectedResourcesResourceCustodyRoute
  "/_authed/tenants/$slug/authentication/conditional-access/app-access/$appId": typeof AuthedTenantsSlugAuthenticationConditionalAccessAppAccessAppIdRoute
  "/_authed/tenants/$slug/authentication/locations/$id/edit": typeof AuthedTenantsSlugAuthenticationLocationsIdEditRoute
  "/_authed/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion": typeof AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren
  "/_authed/tenants/$slug/posture/compliance/controls/$catalogId": typeof AuthedTenantsSlugPostureComplianceControlsCatalogIdRoute
  "/_authed/tenants/$slug/posture/compliance/reports/$kind": typeof AuthedTenantsSlugPostureComplianceReportsKindRoute
  "/_authed/tenants/$slug/security/logon-certificates/$forest/trust": typeof AuthedTenantsSlugSecurityLogonCertificatesForestTrustRoute
  "/_authed/tenants/$slug/settings/product-areas/$area/setup": typeof AuthedTenantsSlugSettingsProductAreasAreaSetupRoute
  "/_authed/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion/readiness": typeof AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute
  "/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion": typeof AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren
  "/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion/readiness": typeof AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/enroll-qr-jit"
    | "/login"
    | "/account-health"
    | "/private-access"
    | "/enroll/$token"
    | "/admins/invite"
    | "/api-keys/new"
    | "/automation-accounts/$id"
    | "/automation-accounts/new"
    | "/managed/teams"
    | "/tenant-records/$slug"
    | "/tenants/$slug"
    | "/tenants/new"
    | "/t/$slug/login"
    | "/t/$slug/recovery"
    | "/admins/"
    | "/api-keys/"
    | "/audit/"
    | "/automation-accounts/"
    | "/managed/"
    | "/tenants/"
    | "/managed/tenants/$slug"
    | "/tenant-records/$slug/access"
    | "/tenant-records/$slug/enrollment-issuers"
    | "/tenant-records/$slug/subscription"
    | "/tenants/$slug/access-requests"
    | "/tenants/$slug/authentication"
    | "/tenants/$slug/entitlement"
    | "/tenants/$slug/oauth-dynreg"
    | "/tenants/$slug/settings"
    | "/t/$slug/login/help"
    | "/t/$slug/recovery/request"
    | "/tenant-records/$slug/"
    | "/tenants/$slug/"
    | "/tenant-records/$slug/administrators/invite"
    | "/tenants/$slug/access-governance/approval-policies"
    | "/tenants/$slug/access-governance/approvers"
    | "/tenants/$slug/access-governance/history"
    | "/tenants/$slug/access-governance/membership"
    | "/tenants/$slug/access-governance/policy"
    | "/tenants/$slug/access-governance/recovery"
    | "/tenants/$slug/admins/delegated"
    | "/tenants/$slug/admins/invite"
    | "/tenants/$slug/agents/$agentId"
    | "/tenants/$slug/agents/activity"
    | "/tenants/$slug/agents/approval-analytics"
    | "/tenants/$slug/agents/approval-history"
    | "/tenants/$slug/agents/approval-thresholds"
    | "/tenants/$slug/agents/budget-raises"
    | "/tenants/$slug/agents/budget-reset-anomalies"
    | "/tenants/$slug/agents/decision-reports"
    | "/tenants/$slug/agents/delegation-governance"
    | "/tenants/$slug/agents/edge"
    | "/tenants/$slug/agents/grants"
    | "/tenants/$slug/agents/guide"
    | "/tenants/$slug/agents/integrate"
    | "/tenants/$slug/agents/multi-agent"
    | "/tenants/$slug/agents/protected-resources"
    | "/tenants/$slug/agents/standing-delegations"
    | "/tenants/$slug/agents/virtual-keys"
    | "/tenants/$slug/applications/$appId"
    | "/tenants/$slug/authentication/authenticators"
    | "/tenants/$slug/authentication/federation"
    | "/tenants/$slug/authentication/sign-in"
    | "/tenants/$slug/automation-accounts/$id"
    | "/tenants/$slug/automation-accounts/new"
    | "/tenants/$slug/directory/attributes"
    | "/tenants/$slug/directory/authority"
    | "/tenants/$slug/directory/matching"
    | "/tenants/$slug/directory/scim-operations"
    | "/tenants/$slug/directory/scim-tokens"
    | "/tenants/$slug/groups/$groupId"
    | "/tenants/$slug/groups/rules"
    | "/tenants/$slug/non-human-identities/overview"
    | "/tenants/$slug/organizations/$orgId"
    | "/tenants/$slug/organizations/new"
    | "/tenants/$slug/provisioning/$connectionId"
    | "/tenants/$slug/provisioning/new"
    | "/tenants/$slug/security/workstations"
    | "/tenants/$slug/settings/automated-onboarding"
    | "/tenants/$slug/settings/branding"
    | "/tenants/$slug/settings/danger-zone"
    | "/tenants/$slug/settings/delegation"
    | "/tenants/$slug/settings/identity-matching"
    | "/tenants/$slug/settings/notifications"
    | "/tenants/$slug/settings/product-areas"
    | "/tenants/$slug/settings/provisioning"
    | "/tenants/$slug/settings/rp"
    | "/tenants/$slug/users/$userId"
    | "/tenants/$slug/users/imports"
    | "/tenants/$slug/webhooks/$webhookId"
    | "/tenants/$slug/webhooks/new"
    | "/t/$slug/recoveries/attest/$requestId"
    | "/tenant-records/$slug/administrators/"
    | "/tenants/$slug/access-governance/"
    | "/tenants/$slug/admins/"
    | "/tenants/$slug/agents/"
    | "/tenants/$slug/applications/"
    | "/tenants/$slug/audit/"
    | "/tenants/$slug/authentication/"
    | "/tenants/$slug/automation-accounts/"
    | "/tenants/$slug/compliance/"
    | "/tenants/$slug/devices/"
    | "/tenants/$slug/directory/"
    | "/tenants/$slug/getting-started/"
    | "/tenants/$slug/groups/"
    | "/tenants/$slug/identity-hygiene/"
    | "/tenants/$slug/locked-out-users/"
    | "/tenants/$slug/non-human-identities/"
    | "/tenants/$slug/onboarding-autotune/"
    | "/tenants/$slug/onboarding-health/"
    | "/tenants/$slug/organizations/"
    | "/tenants/$slug/passkey-intelligence/"
    | "/tenants/$slug/passkeys/"
    | "/tenants/$slug/provisioning/"
    | "/tenants/$slug/settings/"
    | "/tenants/$slug/users/"
    | "/tenants/$slug/webhooks/"
    | "/tenants/$slug/workload-issuers/"
    | "/tenants/$slug/access-governance/credential-recovery/$requestId"
    | "/tenants/$slug/agents/$agentId/policy"
    | "/tenants/$slug/agents/guide/$type"
    | "/tenants/$slug/agents/integrate/api"
    | "/tenants/$slug/agents/integrate/go-sdk"
    | "/tenants/$slug/agents/integrate/protect"
    | "/tenants/$slug/authentication/authenticators/identity-checks"
    | "/tenants/$slug/authentication/authenticators/new"
    | "/tenants/$slug/authentication/conditional-access/$policyId"
    | "/tenants/$slug/authentication/conditional-access/new"
    | "/tenants/$slug/authentication/locations/new"
    | "/tenants/$slug/authentication/sign-in/methods"
    | "/tenants/$slug/authentication/sign-in/passkeys"
    | "/tenants/$slug/authentication/sign-in/phone"
    | "/tenants/$slug/authentication/sign-in/recovery"
    | "/tenants/$slug/authentication/sign-in/sessions"
    | "/tenants/$slug/compliance/controls/$catalogId"
    | "/tenants/$slug/directory/ad-inbound/$directoryId"
    | "/tenants/$slug/directory/ad-inbound/new"
    | "/tenants/$slug/directory/ad-inbound/new-workday"
    | "/tenants/$slug/security/frontline/badge-signin"
    | "/tenants/$slug/security/frontline/kiosk-pass"
    | "/tenants/$slug/settings/product-areas/reconciliation"
    | "/tenants/$slug/webhooks/$webhookId/edit"
    | "/tenants/$slug/access-governance/credential-recovery/"
    | "/tenants/$slug/agents/integrate/"
    | "/tenants/$slug/applications/dynamic-registration/"
    | "/tenants/$slug/authentication/authenticators/"
    | "/tenants/$slug/authentication/conditional-access/"
    | "/tenants/$slug/authentication/sign-in/"
    | "/tenants/$slug/directory/ad-inbound/"
    | "/tenants/$slug/posture/compliance/"
    | "/tenants/$slug/security/frontline/"
    | "/tenants/$slug/security/logon-certificates/"
    | "/tenants/$slug/settings/product-areas/"
    | "/tenants/$slug/agents/protected-resources/$resource/custody"
    | "/tenants/$slug/authentication/conditional-access/app-access/$appId"
    | "/tenants/$slug/authentication/locations/$id/edit"
    | "/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion"
    | "/tenants/$slug/posture/compliance/controls/$catalogId"
    | "/tenants/$slug/posture/compliance/reports/$kind"
    | "/tenants/$slug/security/logon-certificates/$forest/trust"
    | "/tenants/$slug/settings/product-areas/$area/setup"
    | "/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion/readiness"
    | "/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion"
    | "/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion/readiness"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/enroll-qr-jit"
    | "/login"
    | "/account-health"
    | "/private-access"
    | "/enroll/$token"
    | "/"
    | "/admins/invite"
    | "/api-keys/new"
    | "/automation-accounts/$id"
    | "/automation-accounts/new"
    | "/managed/teams"
    | "/tenants/new"
    | "/t/$slug/login"
    | "/t/$slug/recovery"
    | "/admins"
    | "/api-keys"
    | "/audit"
    | "/automation-accounts"
    | "/managed"
    | "/tenants"
    | "/managed/tenants/$slug"
    | "/tenant-records/$slug/access"
    | "/tenant-records/$slug/enrollment-issuers"
    | "/tenant-records/$slug/subscription"
    | "/tenants/$slug/access-requests"
    | "/tenants/$slug/entitlement"
    | "/tenants/$slug/oauth-dynreg"
    | "/t/$slug/login/help"
    | "/t/$slug/recovery/request"
    | "/tenant-records/$slug"
    | "/tenants/$slug"
    | "/tenant-records/$slug/administrators/invite"
    | "/tenants/$slug/access-governance/approval-policies"
    | "/tenants/$slug/access-governance/approvers"
    | "/tenants/$slug/access-governance/history"
    | "/tenants/$slug/access-governance/membership"
    | "/tenants/$slug/access-governance/policy"
    | "/tenants/$slug/access-governance/recovery"
    | "/tenants/$slug/admins/delegated"
    | "/tenants/$slug/admins/invite"
    | "/tenants/$slug/agents/$agentId"
    | "/tenants/$slug/agents/activity"
    | "/tenants/$slug/agents/approval-analytics"
    | "/tenants/$slug/agents/approval-history"
    | "/tenants/$slug/agents/approval-thresholds"
    | "/tenants/$slug/agents/budget-raises"
    | "/tenants/$slug/agents/budget-reset-anomalies"
    | "/tenants/$slug/agents/decision-reports"
    | "/tenants/$slug/agents/delegation-governance"
    | "/tenants/$slug/agents/edge"
    | "/tenants/$slug/agents/grants"
    | "/tenants/$slug/agents/guide"
    | "/tenants/$slug/agents/multi-agent"
    | "/tenants/$slug/agents/protected-resources"
    | "/tenants/$slug/agents/standing-delegations"
    | "/tenants/$slug/agents/virtual-keys"
    | "/tenants/$slug/applications/$appId"
    | "/tenants/$slug/authentication/federation"
    | "/tenants/$slug/automation-accounts/$id"
    | "/tenants/$slug/automation-accounts/new"
    | "/tenants/$slug/directory/attributes"
    | "/tenants/$slug/directory/authority"
    | "/tenants/$slug/directory/matching"
    | "/tenants/$slug/directory/scim-operations"
    | "/tenants/$slug/directory/scim-tokens"
    | "/tenants/$slug/groups/$groupId"
    | "/tenants/$slug/groups/rules"
    | "/tenants/$slug/non-human-identities/overview"
    | "/tenants/$slug/organizations/$orgId"
    | "/tenants/$slug/organizations/new"
    | "/tenants/$slug/provisioning/$connectionId"
    | "/tenants/$slug/provisioning/new"
    | "/tenants/$slug/security/workstations"
    | "/tenants/$slug/settings/automated-onboarding"
    | "/tenants/$slug/settings/branding"
    | "/tenants/$slug/settings/danger-zone"
    | "/tenants/$slug/settings/delegation"
    | "/tenants/$slug/settings/identity-matching"
    | "/tenants/$slug/settings/notifications"
    | "/tenants/$slug/settings/provisioning"
    | "/tenants/$slug/settings/rp"
    | "/tenants/$slug/users/$userId"
    | "/tenants/$slug/users/imports"
    | "/tenants/$slug/webhooks/$webhookId"
    | "/tenants/$slug/webhooks/new"
    | "/t/$slug/recoveries/attest/$requestId"
    | "/tenant-records/$slug/administrators"
    | "/tenants/$slug/access-governance"
    | "/tenants/$slug/admins"
    | "/tenants/$slug/agents"
    | "/tenants/$slug/applications"
    | "/tenants/$slug/audit"
    | "/tenants/$slug/authentication"
    | "/tenants/$slug/automation-accounts"
    | "/tenants/$slug/compliance"
    | "/tenants/$slug/devices"
    | "/tenants/$slug/directory"
    | "/tenants/$slug/getting-started"
    | "/tenants/$slug/groups"
    | "/tenants/$slug/identity-hygiene"
    | "/tenants/$slug/locked-out-users"
    | "/tenants/$slug/non-human-identities"
    | "/tenants/$slug/onboarding-autotune"
    | "/tenants/$slug/onboarding-health"
    | "/tenants/$slug/organizations"
    | "/tenants/$slug/passkey-intelligence"
    | "/tenants/$slug/passkeys"
    | "/tenants/$slug/provisioning"
    | "/tenants/$slug/settings"
    | "/tenants/$slug/users"
    | "/tenants/$slug/webhooks"
    | "/tenants/$slug/workload-issuers"
    | "/tenants/$slug/access-governance/credential-recovery/$requestId"
    | "/tenants/$slug/agents/$agentId/policy"
    | "/tenants/$slug/agents/guide/$type"
    | "/tenants/$slug/agents/integrate/api"
    | "/tenants/$slug/agents/integrate/go-sdk"
    | "/tenants/$slug/agents/integrate/protect"
    | "/tenants/$slug/authentication/authenticators/identity-checks"
    | "/tenants/$slug/authentication/authenticators/new"
    | "/tenants/$slug/authentication/conditional-access/$policyId"
    | "/tenants/$slug/authentication/conditional-access/new"
    | "/tenants/$slug/authentication/locations/new"
    | "/tenants/$slug/authentication/sign-in/methods"
    | "/tenants/$slug/authentication/sign-in/passkeys"
    | "/tenants/$slug/authentication/sign-in/phone"
    | "/tenants/$slug/authentication/sign-in/recovery"
    | "/tenants/$slug/authentication/sign-in/sessions"
    | "/tenants/$slug/compliance/controls/$catalogId"
    | "/tenants/$slug/directory/ad-inbound/$directoryId"
    | "/tenants/$slug/directory/ad-inbound/new"
    | "/tenants/$slug/directory/ad-inbound/new-workday"
    | "/tenants/$slug/security/frontline/badge-signin"
    | "/tenants/$slug/security/frontline/kiosk-pass"
    | "/tenants/$slug/settings/product-areas/reconciliation"
    | "/tenants/$slug/webhooks/$webhookId/edit"
    | "/tenants/$slug/access-governance/credential-recovery"
    | "/tenants/$slug/agents/integrate"
    | "/tenants/$slug/applications/dynamic-registration"
    | "/tenants/$slug/authentication/authenticators"
    | "/tenants/$slug/authentication/conditional-access"
    | "/tenants/$slug/authentication/sign-in"
    | "/tenants/$slug/directory/ad-inbound"
    | "/tenants/$slug/posture/compliance"
    | "/tenants/$slug/security/frontline"
    | "/tenants/$slug/security/logon-certificates"
    | "/tenants/$slug/settings/product-areas"
    | "/tenants/$slug/agents/protected-resources/$resource/custody"
    | "/tenants/$slug/authentication/conditional-access/app-access/$appId"
    | "/tenants/$slug/authentication/locations/$id/edit"
    | "/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion"
    | "/tenants/$slug/posture/compliance/controls/$catalogId"
    | "/tenants/$slug/posture/compliance/reports/$kind"
    | "/tenants/$slug/security/logon-certificates/$forest/trust"
    | "/tenants/$slug/settings/product-areas/$area/setup"
    | "/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion/readiness"
    | "/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion"
    | "/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion/readiness"
  id:
    | "__root__"
    | "/_authed"
    | "/enroll-qr-jit"
    | "/login"
    | "/_authed/account-health"
    | "/_authed/private-access"
    | "/enroll/$token"
    | "/_authed/"
    | "/_authed/admins/invite"
    | "/_authed/api-keys/new"
    | "/_authed/automation-accounts/$id"
    | "/_authed/automation-accounts/new"
    | "/_authed/managed/teams"
    | "/_authed/tenant-records/$slug"
    | "/_authed/tenants/$slug"
    | "/_authed/tenants/new"
    | "/t/$slug/login"
    | "/t/$slug/recovery"
    | "/_authed/admins/"
    | "/_authed/api-keys/"
    | "/_authed/audit/"
    | "/_authed/automation-accounts/"
    | "/_authed/managed/"
    | "/_authed/tenants/"
    | "/_authed/managed/tenants/$slug"
    | "/_authed/tenant-records/$slug/access"
    | "/_authed/tenant-records/$slug/enrollment-issuers"
    | "/_authed/tenant-records/$slug/subscription"
    | "/_authed/tenants/$slug/access-requests"
    | "/_authed/tenants/$slug/authentication"
    | "/_authed/tenants/$slug/entitlement"
    | "/_authed/tenants/$slug/oauth-dynreg"
    | "/_authed/tenants/$slug/settings"
    | "/t/$slug/login/help"
    | "/t/$slug/recovery/request"
    | "/_authed/tenant-records/$slug/"
    | "/_authed/tenants/$slug/"
    | "/_authed/tenant-records/$slug/administrators/invite"
    | "/_authed/tenants/$slug/access-governance/approval-policies"
    | "/_authed/tenants/$slug/access-governance/approvers"
    | "/_authed/tenants/$slug/access-governance/history"
    | "/_authed/tenants/$slug/access-governance/membership"
    | "/_authed/tenants/$slug/access-governance/policy"
    | "/_authed/tenants/$slug/access-governance/recovery"
    | "/_authed/tenants/$slug/admins/delegated"
    | "/_authed/tenants/$slug/admins/invite"
    | "/_authed/tenants/$slug/agents/$agentId"
    | "/_authed/tenants/$slug/agents/activity"
    | "/_authed/tenants/$slug/agents/approval-analytics"
    | "/_authed/tenants/$slug/agents/approval-history"
    | "/_authed/tenants/$slug/agents/approval-thresholds"
    | "/_authed/tenants/$slug/agents/budget-raises"
    | "/_authed/tenants/$slug/agents/budget-reset-anomalies"
    | "/_authed/tenants/$slug/agents/decision-reports"
    | "/_authed/tenants/$slug/agents/delegation-governance"
    | "/_authed/tenants/$slug/agents/edge"
    | "/_authed/tenants/$slug/agents/grants"
    | "/_authed/tenants/$slug/agents/guide"
    | "/_authed/tenants/$slug/agents/integrate"
    | "/_authed/tenants/$slug/agents/multi-agent"
    | "/_authed/tenants/$slug/agents/protected-resources"
    | "/_authed/tenants/$slug/agents/standing-delegations"
    | "/_authed/tenants/$slug/agents/virtual-keys"
    | "/_authed/tenants/$slug/applications/$appId"
    | "/_authed/tenants/$slug/authentication/authenticators"
    | "/_authed/tenants/$slug/authentication/federation"
    | "/_authed/tenants/$slug/authentication/sign-in"
    | "/_authed/tenants/$slug/automation-accounts/$id"
    | "/_authed/tenants/$slug/automation-accounts/new"
    | "/_authed/tenants/$slug/directory/attributes"
    | "/_authed/tenants/$slug/directory/authority"
    | "/_authed/tenants/$slug/directory/matching"
    | "/_authed/tenants/$slug/directory/scim-operations"
    | "/_authed/tenants/$slug/directory/scim-tokens"
    | "/_authed/tenants/$slug/groups/$groupId"
    | "/_authed/tenants/$slug/groups/rules"
    | "/_authed/tenants/$slug/non-human-identities/overview"
    | "/_authed/tenants/$slug/organizations/$orgId"
    | "/_authed/tenants/$slug/organizations/new"
    | "/_authed/tenants/$slug/provisioning/$connectionId"
    | "/_authed/tenants/$slug/provisioning/new"
    | "/_authed/tenants/$slug/security/workstations"
    | "/_authed/tenants/$slug/settings/automated-onboarding"
    | "/_authed/tenants/$slug/settings/branding"
    | "/_authed/tenants/$slug/settings/danger-zone"
    | "/_authed/tenants/$slug/settings/delegation"
    | "/_authed/tenants/$slug/settings/identity-matching"
    | "/_authed/tenants/$slug/settings/notifications"
    | "/_authed/tenants/$slug/settings/product-areas"
    | "/_authed/tenants/$slug/settings/provisioning"
    | "/_authed/tenants/$slug/settings/rp"
    | "/_authed/tenants/$slug/users/$userId"
    | "/_authed/tenants/$slug/users/imports"
    | "/_authed/tenants/$slug/webhooks/$webhookId"
    | "/_authed/tenants/$slug/webhooks/new"
    | "/t/$slug/recoveries/attest/$requestId"
    | "/_authed/tenant-records/$slug/administrators/"
    | "/_authed/tenants/$slug/access-governance/"
    | "/_authed/tenants/$slug/admins/"
    | "/_authed/tenants/$slug/agents/"
    | "/_authed/tenants/$slug/applications/"
    | "/_authed/tenants/$slug/audit/"
    | "/_authed/tenants/$slug/authentication/"
    | "/_authed/tenants/$slug/automation-accounts/"
    | "/_authed/tenants/$slug/compliance/"
    | "/_authed/tenants/$slug/devices/"
    | "/_authed/tenants/$slug/directory/"
    | "/_authed/tenants/$slug/getting-started/"
    | "/_authed/tenants/$slug/groups/"
    | "/_authed/tenants/$slug/identity-hygiene/"
    | "/_authed/tenants/$slug/locked-out-users/"
    | "/_authed/tenants/$slug/non-human-identities/"
    | "/_authed/tenants/$slug/onboarding-autotune/"
    | "/_authed/tenants/$slug/onboarding-health/"
    | "/_authed/tenants/$slug/organizations/"
    | "/_authed/tenants/$slug/passkey-intelligence/"
    | "/_authed/tenants/$slug/passkeys/"
    | "/_authed/tenants/$slug/provisioning/"
    | "/_authed/tenants/$slug/settings/"
    | "/_authed/tenants/$slug/users/"
    | "/_authed/tenants/$slug/webhooks/"
    | "/_authed/tenants/$slug/workload-issuers/"
    | "/_authed/tenants/$slug/access-governance/credential-recovery/$requestId"
    | "/_authed/tenants/$slug/agents/$agentId/policy"
    | "/_authed/tenants/$slug/agents/guide/$type"
    | "/_authed/tenants/$slug/agents/integrate/api"
    | "/_authed/tenants/$slug/agents/integrate/go-sdk"
    | "/_authed/tenants/$slug/agents/integrate/protect"
    | "/_authed/tenants/$slug/authentication/authenticators/identity-checks"
    | "/_authed/tenants/$slug/authentication/authenticators/new"
    | "/_authed/tenants/$slug/authentication/conditional-access/$policyId"
    | "/_authed/tenants/$slug/authentication/conditional-access/new"
    | "/_authed/tenants/$slug/authentication/locations/new"
    | "/_authed/tenants/$slug/authentication/sign-in/methods"
    | "/_authed/tenants/$slug/authentication/sign-in/passkeys"
    | "/_authed/tenants/$slug/authentication/sign-in/phone"
    | "/_authed/tenants/$slug/authentication/sign-in/recovery"
    | "/_authed/tenants/$slug/authentication/sign-in/sessions"
    | "/_authed/tenants/$slug/compliance/controls/$catalogId"
    | "/_authed/tenants/$slug/directory/ad-inbound/$directoryId"
    | "/_authed/tenants/$slug/directory/ad-inbound/new"
    | "/_authed/tenants/$slug/directory/ad-inbound/new-workday"
    | "/_authed/tenants/$slug/security/frontline/badge-signin"
    | "/_authed/tenants/$slug/security/frontline/kiosk-pass"
    | "/_authed/tenants/$slug/settings/product-areas/reconciliation"
    | "/_authed/tenants/$slug/webhooks/$webhookId/edit"
    | "/_authed/tenants/$slug/access-governance/credential-recovery/"
    | "/_authed/tenants/$slug/agents/integrate/"
    | "/_authed/tenants/$slug/applications/dynamic-registration/"
    | "/_authed/tenants/$slug/authentication/authenticators/"
    | "/_authed/tenants/$slug/authentication/conditional-access/"
    | "/_authed/tenants/$slug/authentication/sign-in/"
    | "/_authed/tenants/$slug/directory/ad-inbound/"
    | "/_authed/tenants/$slug/posture/compliance/"
    | "/_authed/tenants/$slug/security/frontline/"
    | "/_authed/tenants/$slug/security/logon-certificates/"
    | "/_authed/tenants/$slug/settings/product-areas/"
    | "/_authed/tenants/$slug/agents/protected-resources/$resource/custody"
    | "/_authed/tenants/$slug/authentication/conditional-access/app-access/$appId"
    | "/_authed/tenants/$slug/authentication/locations/$id/edit"
    | "/_authed/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion"
    | "/_authed/tenants/$slug/posture/compliance/controls/$catalogId"
    | "/_authed/tenants/$slug/posture/compliance/reports/$kind"
    | "/_authed/tenants/$slug/security/logon-certificates/$forest/trust"
    | "/_authed/tenants/$slug/settings/product-areas/$area/setup"
    | "/_authed/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion/readiness"
    | "/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion"
    | "/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion/readiness"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  EnrollQrJitRoute: typeof EnrollQrJitRoute
  LoginRoute: typeof LoginRoute
  EnrollTokenRoute: typeof EnrollTokenRoute
  TSlugLoginRoute: typeof TSlugLoginRouteWithChildren
  TSlugRecoveryRoute: typeof TSlugRecoveryRouteWithChildren
  TSlugRecoveriesAttestRequestIdRoute: typeof TSlugRecoveriesAttestRequestIdRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authed": {
      id: "/_authed"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/enroll-qr-jit": {
      id: "/enroll-qr-jit"
      path: "/enroll-qr-jit"
      fullPath: "/enroll-qr-jit"
      preLoaderRoute: typeof EnrollQrJitRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/": {
      id: "/_authed/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/account-health": {
      id: "/_authed/account-health"
      path: "/account-health"
      fullPath: "/account-health"
      preLoaderRoute: typeof AuthedAccountHealthRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/private-access": {
      id: "/_authed/private-access"
      path: "/private-access"
      fullPath: "/private-access"
      preLoaderRoute: typeof AuthedPrivateAccessRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/enroll/$token": {
      id: "/enroll/$token"
      path: "/enroll/$token"
      fullPath: "/enroll/$token"
      preLoaderRoute: typeof EnrollTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/admins/": {
      id: "/_authed/admins/"
      path: "/admins"
      fullPath: "/admins/"
      preLoaderRoute: typeof AuthedAdminsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/admins/invite": {
      id: "/_authed/admins/invite"
      path: "/admins/invite"
      fullPath: "/admins/invite"
      preLoaderRoute: typeof AuthedAdminsInviteRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/api-keys/": {
      id: "/_authed/api-keys/"
      path: "/api-keys"
      fullPath: "/api-keys/"
      preLoaderRoute: typeof AuthedApiKeysIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/api-keys/new": {
      id: "/_authed/api-keys/new"
      path: "/api-keys/new"
      fullPath: "/api-keys/new"
      preLoaderRoute: typeof AuthedApiKeysNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/audit/": {
      id: "/_authed/audit/"
      path: "/audit"
      fullPath: "/audit/"
      preLoaderRoute: typeof AuthedAuditIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/automation-accounts/": {
      id: "/_authed/automation-accounts/"
      path: "/automation-accounts"
      fullPath: "/automation-accounts/"
      preLoaderRoute: typeof AuthedAutomationAccountsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/automation-accounts/$id": {
      id: "/_authed/automation-accounts/$id"
      path: "/automation-accounts/$id"
      fullPath: "/automation-accounts/$id"
      preLoaderRoute: typeof AuthedAutomationAccountsIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/automation-accounts/new": {
      id: "/_authed/automation-accounts/new"
      path: "/automation-accounts/new"
      fullPath: "/automation-accounts/new"
      preLoaderRoute: typeof AuthedAutomationAccountsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/managed/": {
      id: "/_authed/managed/"
      path: "/managed"
      fullPath: "/managed/"
      preLoaderRoute: typeof AuthedManagedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/managed/teams": {
      id: "/_authed/managed/teams"
      path: "/managed/teams"
      fullPath: "/managed/teams"
      preLoaderRoute: typeof AuthedManagedTeamsRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/tenant-records/$slug": {
      id: "/_authed/tenant-records/$slug"
      path: "/tenant-records/$slug"
      fullPath: "/tenant-records/$slug"
      preLoaderRoute: typeof AuthedTenantRecordsSlugRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/tenants/": {
      id: "/_authed/tenants/"
      path: "/tenants"
      fullPath: "/tenants/"
      preLoaderRoute: typeof AuthedTenantsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/tenants/$slug": {
      id: "/_authed/tenants/$slug"
      path: "/tenants/$slug"
      fullPath: "/tenants/$slug"
      preLoaderRoute: typeof AuthedTenantsSlugRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/tenants/new": {
      id: "/_authed/tenants/new"
      path: "/tenants/new"
      fullPath: "/tenants/new"
      preLoaderRoute: typeof AuthedTenantsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/t/$slug/login": {
      id: "/t/$slug/login"
      path: "/t/$slug/login"
      fullPath: "/t/$slug/login"
      preLoaderRoute: typeof TSlugLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/t/$slug/recovery": {
      id: "/t/$slug/recovery"
      path: "/t/$slug/recovery"
      fullPath: "/t/$slug/recovery"
      preLoaderRoute: typeof TSlugRecoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/managed/tenants/$slug": {
      id: "/_authed/managed/tenants/$slug"
      path: "/managed/tenants/$slug"
      fullPath: "/managed/tenants/$slug"
      preLoaderRoute: typeof AuthedManagedTenantsSlugRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/tenant-records/$slug/": {
      id: "/_authed/tenant-records/$slug/"
      path: "/"
      fullPath: "/tenant-records/$slug/"
      preLoaderRoute: typeof AuthedTenantRecordsSlugIndexRouteImport
      parentRoute: typeof AuthedTenantRecordsSlugRoute
    }
    "/_authed/tenant-records/$slug/access": {
      id: "/_authed/tenant-records/$slug/access"
      path: "/access"
      fullPath: "/tenant-records/$slug/access"
      preLoaderRoute: typeof AuthedTenantRecordsSlugAccessRouteImport
      parentRoute: typeof AuthedTenantRecordsSlugRoute
    }
    "/_authed/tenant-records/$slug/enrollment-issuers": {
      id: "/_authed/tenant-records/$slug/enrollment-issuers"
      path: "/enrollment-issuers"
      fullPath: "/tenant-records/$slug/enrollment-issuers"
      preLoaderRoute: typeof AuthedTenantRecordsSlugEnrollmentIssuersRouteImport
      parentRoute: typeof AuthedTenantRecordsSlugRoute
    }
    "/_authed/tenant-records/$slug/subscription": {
      id: "/_authed/tenant-records/$slug/subscription"
      path: "/subscription"
      fullPath: "/tenant-records/$slug/subscription"
      preLoaderRoute: typeof AuthedTenantRecordsSlugSubscriptionRouteImport
      parentRoute: typeof AuthedTenantRecordsSlugRoute
    }
    "/_authed/tenants/$slug/": {
      id: "/_authed/tenants/$slug/"
      path: "/"
      fullPath: "/tenants/$slug/"
      preLoaderRoute: typeof AuthedTenantsSlugIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/access-requests": {
      id: "/_authed/tenants/$slug/access-requests"
      path: "/access-requests"
      fullPath: "/tenants/$slug/access-requests"
      preLoaderRoute: typeof AuthedTenantsSlugAccessRequestsRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/authentication": {
      id: "/_authed/tenants/$slug/authentication"
      path: "/authentication"
      fullPath: "/tenants/$slug/authentication"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/entitlement": {
      id: "/_authed/tenants/$slug/entitlement"
      path: "/entitlement"
      fullPath: "/tenants/$slug/entitlement"
      preLoaderRoute: typeof AuthedTenantsSlugEntitlementRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/oauth-dynreg": {
      id: "/_authed/tenants/$slug/oauth-dynreg"
      path: "/oauth-dynreg"
      fullPath: "/tenants/$slug/oauth-dynreg"
      preLoaderRoute: typeof AuthedTenantsSlugOauthDynregRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/settings": {
      id: "/_authed/tenants/$slug/settings"
      path: "/settings"
      fullPath: "/tenants/$slug/settings"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/t/$slug/login/help": {
      id: "/t/$slug/login/help"
      path: "/help"
      fullPath: "/t/$slug/login/help"
      preLoaderRoute: typeof TSlugLoginHelpRouteImport
      parentRoute: typeof TSlugLoginRoute
    }
    "/t/$slug/recovery/request": {
      id: "/t/$slug/recovery/request"
      path: "/request"
      fullPath: "/t/$slug/recovery/request"
      preLoaderRoute: typeof TSlugRecoveryRequestRouteImport
      parentRoute: typeof TSlugRecoveryRoute
    }
    "/_authed/tenant-records/$slug/administrators/": {
      id: "/_authed/tenant-records/$slug/administrators/"
      path: "/administrators"
      fullPath: "/tenant-records/$slug/administrators/"
      preLoaderRoute: typeof AuthedTenantRecordsSlugAdministratorsIndexRouteImport
      parentRoute: typeof AuthedTenantRecordsSlugRoute
    }
    "/_authed/tenant-records/$slug/administrators/invite": {
      id: "/_authed/tenant-records/$slug/administrators/invite"
      path: "/administrators/invite"
      fullPath: "/tenant-records/$slug/administrators/invite"
      preLoaderRoute: typeof AuthedTenantRecordsSlugAdministratorsInviteRouteImport
      parentRoute: typeof AuthedTenantRecordsSlugRoute
    }
    "/_authed/tenants/$slug/access-governance/": {
      id: "/_authed/tenants/$slug/access-governance/"
      path: "/access-governance"
      fullPath: "/tenants/$slug/access-governance/"
      preLoaderRoute: typeof AuthedTenantsSlugAccessGovernanceIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/access-governance/approval-policies": {
      id: "/_authed/tenants/$slug/access-governance/approval-policies"
      path: "/access-governance/approval-policies"
      fullPath: "/tenants/$slug/access-governance/approval-policies"
      preLoaderRoute: typeof AuthedTenantsSlugAccessGovernanceApprovalPoliciesRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/access-governance/approvers": {
      id: "/_authed/tenants/$slug/access-governance/approvers"
      path: "/access-governance/approvers"
      fullPath: "/tenants/$slug/access-governance/approvers"
      preLoaderRoute: typeof AuthedTenantsSlugAccessGovernanceApproversRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/access-governance/history": {
      id: "/_authed/tenants/$slug/access-governance/history"
      path: "/access-governance/history"
      fullPath: "/tenants/$slug/access-governance/history"
      preLoaderRoute: typeof AuthedTenantsSlugAccessGovernanceHistoryRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/access-governance/membership": {
      id: "/_authed/tenants/$slug/access-governance/membership"
      path: "/access-governance/membership"
      fullPath: "/tenants/$slug/access-governance/membership"
      preLoaderRoute: typeof AuthedTenantsSlugAccessGovernanceMembershipRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/access-governance/policy": {
      id: "/_authed/tenants/$slug/access-governance/policy"
      path: "/access-governance/policy"
      fullPath: "/tenants/$slug/access-governance/policy"
      preLoaderRoute: typeof AuthedTenantsSlugAccessGovernancePolicyRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/access-governance/recovery": {
      id: "/_authed/tenants/$slug/access-governance/recovery"
      path: "/access-governance/recovery"
      fullPath: "/tenants/$slug/access-governance/recovery"
      preLoaderRoute: typeof AuthedTenantsSlugAccessGovernanceRecoveryRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/admins/": {
      id: "/_authed/tenants/$slug/admins/"
      path: "/admins"
      fullPath: "/tenants/$slug/admins/"
      preLoaderRoute: typeof AuthedTenantsSlugAdminsIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/admins/delegated": {
      id: "/_authed/tenants/$slug/admins/delegated"
      path: "/admins/delegated"
      fullPath: "/tenants/$slug/admins/delegated"
      preLoaderRoute: typeof AuthedTenantsSlugAdminsDelegatedRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/admins/invite": {
      id: "/_authed/tenants/$slug/admins/invite"
      path: "/admins/invite"
      fullPath: "/tenants/$slug/admins/invite"
      preLoaderRoute: typeof AuthedTenantsSlugAdminsInviteRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/": {
      id: "/_authed/tenants/$slug/agents/"
      path: "/agents"
      fullPath: "/tenants/$slug/agents/"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/$agentId": {
      id: "/_authed/tenants/$slug/agents/$agentId"
      path: "/agents/$agentId"
      fullPath: "/tenants/$slug/agents/$agentId"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsAgentIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/activity": {
      id: "/_authed/tenants/$slug/agents/activity"
      path: "/agents/activity"
      fullPath: "/tenants/$slug/agents/activity"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsActivityRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/approval-analytics": {
      id: "/_authed/tenants/$slug/agents/approval-analytics"
      path: "/agents/approval-analytics"
      fullPath: "/tenants/$slug/agents/approval-analytics"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsApprovalAnalyticsRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/approval-history": {
      id: "/_authed/tenants/$slug/agents/approval-history"
      path: "/agents/approval-history"
      fullPath: "/tenants/$slug/agents/approval-history"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsApprovalHistoryRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/approval-thresholds": {
      id: "/_authed/tenants/$slug/agents/approval-thresholds"
      path: "/agents/approval-thresholds"
      fullPath: "/tenants/$slug/agents/approval-thresholds"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsApprovalThresholdsRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/budget-raises": {
      id: "/_authed/tenants/$slug/agents/budget-raises"
      path: "/agents/budget-raises"
      fullPath: "/tenants/$slug/agents/budget-raises"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsBudgetRaisesRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/budget-reset-anomalies": {
      id: "/_authed/tenants/$slug/agents/budget-reset-anomalies"
      path: "/agents/budget-reset-anomalies"
      fullPath: "/tenants/$slug/agents/budget-reset-anomalies"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsBudgetResetAnomaliesRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/decision-reports": {
      id: "/_authed/tenants/$slug/agents/decision-reports"
      path: "/agents/decision-reports"
      fullPath: "/tenants/$slug/agents/decision-reports"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsDecisionReportsRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/delegation-governance": {
      id: "/_authed/tenants/$slug/agents/delegation-governance"
      path: "/agents/delegation-governance"
      fullPath: "/tenants/$slug/agents/delegation-governance"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsDelegationGovernanceRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/edge": {
      id: "/_authed/tenants/$slug/agents/edge"
      path: "/agents/edge"
      fullPath: "/tenants/$slug/agents/edge"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsEdgeRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/grants": {
      id: "/_authed/tenants/$slug/agents/grants"
      path: "/agents/grants"
      fullPath: "/tenants/$slug/agents/grants"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsGrantsRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/guide": {
      id: "/_authed/tenants/$slug/agents/guide"
      path: "/agents/guide"
      fullPath: "/tenants/$slug/agents/guide"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsGuideRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/integrate": {
      id: "/_authed/tenants/$slug/agents/integrate"
      path: "/agents/integrate"
      fullPath: "/tenants/$slug/agents/integrate"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsIntegrateRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/multi-agent": {
      id: "/_authed/tenants/$slug/agents/multi-agent"
      path: "/agents/multi-agent"
      fullPath: "/tenants/$slug/agents/multi-agent"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsMultiAgentRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/protected-resources": {
      id: "/_authed/tenants/$slug/agents/protected-resources"
      path: "/agents/protected-resources"
      fullPath: "/tenants/$slug/agents/protected-resources"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsProtectedResourcesRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/standing-delegations": {
      id: "/_authed/tenants/$slug/agents/standing-delegations"
      path: "/agents/standing-delegations"
      fullPath: "/tenants/$slug/agents/standing-delegations"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsStandingDelegationsRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/virtual-keys": {
      id: "/_authed/tenants/$slug/agents/virtual-keys"
      path: "/agents/virtual-keys"
      fullPath: "/tenants/$slug/agents/virtual-keys"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsVirtualKeysRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/applications/": {
      id: "/_authed/tenants/$slug/applications/"
      path: "/applications"
      fullPath: "/tenants/$slug/applications/"
      preLoaderRoute: typeof AuthedTenantsSlugApplicationsIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/applications/$appId": {
      id: "/_authed/tenants/$slug/applications/$appId"
      path: "/applications/$appId"
      fullPath: "/tenants/$slug/applications/$appId"
      preLoaderRoute: typeof AuthedTenantsSlugApplicationsAppIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/audit/": {
      id: "/_authed/tenants/$slug/audit/"
      path: "/audit"
      fullPath: "/tenants/$slug/audit/"
      preLoaderRoute: typeof AuthedTenantsSlugAuditIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/authentication/": {
      id: "/_authed/tenants/$slug/authentication/"
      path: "/"
      fullPath: "/tenants/$slug/authentication/"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationRoute
    }
    "/_authed/tenants/$slug/authentication/authenticators": {
      id: "/_authed/tenants/$slug/authentication/authenticators"
      path: "/authenticators"
      fullPath: "/tenants/$slug/authentication/authenticators"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationAuthenticatorsRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationRoute
    }
    "/_authed/tenants/$slug/authentication/federation": {
      id: "/_authed/tenants/$slug/authentication/federation"
      path: "/federation"
      fullPath: "/tenants/$slug/authentication/federation"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationFederationRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationRoute
    }
    "/_authed/tenants/$slug/authentication/sign-in": {
      id: "/_authed/tenants/$slug/authentication/sign-in"
      path: "/sign-in"
      fullPath: "/tenants/$slug/authentication/sign-in"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationSignInRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationRoute
    }
    "/_authed/tenants/$slug/automation-accounts/": {
      id: "/_authed/tenants/$slug/automation-accounts/"
      path: "/automation-accounts"
      fullPath: "/tenants/$slug/automation-accounts/"
      preLoaderRoute: typeof AuthedTenantsSlugAutomationAccountsIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/automation-accounts/$id": {
      id: "/_authed/tenants/$slug/automation-accounts/$id"
      path: "/automation-accounts/$id"
      fullPath: "/tenants/$slug/automation-accounts/$id"
      preLoaderRoute: typeof AuthedTenantsSlugAutomationAccountsIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/automation-accounts/new": {
      id: "/_authed/tenants/$slug/automation-accounts/new"
      path: "/automation-accounts/new"
      fullPath: "/tenants/$slug/automation-accounts/new"
      preLoaderRoute: typeof AuthedTenantsSlugAutomationAccountsNewRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/compliance/": {
      id: "/_authed/tenants/$slug/compliance/"
      path: "/compliance"
      fullPath: "/tenants/$slug/compliance/"
      preLoaderRoute: typeof AuthedTenantsSlugComplianceIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/devices/": {
      id: "/_authed/tenants/$slug/devices/"
      path: "/devices"
      fullPath: "/tenants/$slug/devices/"
      preLoaderRoute: typeof AuthedTenantsSlugDevicesIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/directory/": {
      id: "/_authed/tenants/$slug/directory/"
      path: "/directory"
      fullPath: "/tenants/$slug/directory/"
      preLoaderRoute: typeof AuthedTenantsSlugDirectoryIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/directory/attributes": {
      id: "/_authed/tenants/$slug/directory/attributes"
      path: "/directory/attributes"
      fullPath: "/tenants/$slug/directory/attributes"
      preLoaderRoute: typeof AuthedTenantsSlugDirectoryAttributesRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/directory/authority": {
      id: "/_authed/tenants/$slug/directory/authority"
      path: "/directory/authority"
      fullPath: "/tenants/$slug/directory/authority"
      preLoaderRoute: typeof AuthedTenantsSlugDirectoryAuthorityRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/directory/matching": {
      id: "/_authed/tenants/$slug/directory/matching"
      path: "/directory/matching"
      fullPath: "/tenants/$slug/directory/matching"
      preLoaderRoute: typeof AuthedTenantsSlugDirectoryMatchingRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/directory/scim-operations": {
      id: "/_authed/tenants/$slug/directory/scim-operations"
      path: "/directory/scim-operations"
      fullPath: "/tenants/$slug/directory/scim-operations"
      preLoaderRoute: typeof AuthedTenantsSlugDirectoryScimOperationsRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/directory/scim-tokens": {
      id: "/_authed/tenants/$slug/directory/scim-tokens"
      path: "/directory/scim-tokens"
      fullPath: "/tenants/$slug/directory/scim-tokens"
      preLoaderRoute: typeof AuthedTenantsSlugDirectoryScimTokensRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/getting-started/": {
      id: "/_authed/tenants/$slug/getting-started/"
      path: "/getting-started"
      fullPath: "/tenants/$slug/getting-started/"
      preLoaderRoute: typeof AuthedTenantsSlugGettingStartedIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/groups/": {
      id: "/_authed/tenants/$slug/groups/"
      path: "/groups"
      fullPath: "/tenants/$slug/groups/"
      preLoaderRoute: typeof AuthedTenantsSlugGroupsIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/groups/$groupId": {
      id: "/_authed/tenants/$slug/groups/$groupId"
      path: "/groups/$groupId"
      fullPath: "/tenants/$slug/groups/$groupId"
      preLoaderRoute: typeof AuthedTenantsSlugGroupsGroupIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/groups/rules": {
      id: "/_authed/tenants/$slug/groups/rules"
      path: "/groups/rules"
      fullPath: "/tenants/$slug/groups/rules"
      preLoaderRoute: typeof AuthedTenantsSlugGroupsRulesRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/identity-hygiene/": {
      id: "/_authed/tenants/$slug/identity-hygiene/"
      path: "/identity-hygiene"
      fullPath: "/tenants/$slug/identity-hygiene/"
      preLoaderRoute: typeof AuthedTenantsSlugIdentityHygieneIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/locked-out-users/": {
      id: "/_authed/tenants/$slug/locked-out-users/"
      path: "/locked-out-users"
      fullPath: "/tenants/$slug/locked-out-users/"
      preLoaderRoute: typeof AuthedTenantsSlugLockedOutUsersIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/non-human-identities/": {
      id: "/_authed/tenants/$slug/non-human-identities/"
      path: "/non-human-identities"
      fullPath: "/tenants/$slug/non-human-identities/"
      preLoaderRoute: typeof AuthedTenantsSlugNonHumanIdentitiesIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/non-human-identities/overview": {
      id: "/_authed/tenants/$slug/non-human-identities/overview"
      path: "/non-human-identities/overview"
      fullPath: "/tenants/$slug/non-human-identities/overview"
      preLoaderRoute: typeof AuthedTenantsSlugNonHumanIdentitiesOverviewRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/onboarding-autotune/": {
      id: "/_authed/tenants/$slug/onboarding-autotune/"
      path: "/onboarding-autotune"
      fullPath: "/tenants/$slug/onboarding-autotune/"
      preLoaderRoute: typeof AuthedTenantsSlugOnboardingAutotuneIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/onboarding-health/": {
      id: "/_authed/tenants/$slug/onboarding-health/"
      path: "/onboarding-health"
      fullPath: "/tenants/$slug/onboarding-health/"
      preLoaderRoute: typeof AuthedTenantsSlugOnboardingHealthIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/organizations/": {
      id: "/_authed/tenants/$slug/organizations/"
      path: "/organizations"
      fullPath: "/tenants/$slug/organizations/"
      preLoaderRoute: typeof AuthedTenantsSlugOrganizationsIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/organizations/$orgId": {
      id: "/_authed/tenants/$slug/organizations/$orgId"
      path: "/organizations/$orgId"
      fullPath: "/tenants/$slug/organizations/$orgId"
      preLoaderRoute: typeof AuthedTenantsSlugOrganizationsOrgIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/organizations/new": {
      id: "/_authed/tenants/$slug/organizations/new"
      path: "/organizations/new"
      fullPath: "/tenants/$slug/organizations/new"
      preLoaderRoute: typeof AuthedTenantsSlugOrganizationsNewRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/passkey-intelligence/": {
      id: "/_authed/tenants/$slug/passkey-intelligence/"
      path: "/passkey-intelligence"
      fullPath: "/tenants/$slug/passkey-intelligence/"
      preLoaderRoute: typeof AuthedTenantsSlugPasskeyIntelligenceIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/passkeys/": {
      id: "/_authed/tenants/$slug/passkeys/"
      path: "/passkeys"
      fullPath: "/tenants/$slug/passkeys/"
      preLoaderRoute: typeof AuthedTenantsSlugPasskeysIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/provisioning/": {
      id: "/_authed/tenants/$slug/provisioning/"
      path: "/provisioning"
      fullPath: "/tenants/$slug/provisioning/"
      preLoaderRoute: typeof AuthedTenantsSlugProvisioningIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/provisioning/$connectionId": {
      id: "/_authed/tenants/$slug/provisioning/$connectionId"
      path: "/provisioning/$connectionId"
      fullPath: "/tenants/$slug/provisioning/$connectionId"
      preLoaderRoute: typeof AuthedTenantsSlugProvisioningConnectionIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/provisioning/new": {
      id: "/_authed/tenants/$slug/provisioning/new"
      path: "/provisioning/new"
      fullPath: "/tenants/$slug/provisioning/new"
      preLoaderRoute: typeof AuthedTenantsSlugProvisioningNewRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/security/workstations": {
      id: "/_authed/tenants/$slug/security/workstations"
      path: "/security/workstations"
      fullPath: "/tenants/$slug/security/workstations"
      preLoaderRoute: typeof AuthedTenantsSlugSecurityWorkstationsRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/settings/": {
      id: "/_authed/tenants/$slug/settings/"
      path: "/"
      fullPath: "/tenants/$slug/settings/"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsRoute
    }
    "/_authed/tenants/$slug/settings/automated-onboarding": {
      id: "/_authed/tenants/$slug/settings/automated-onboarding"
      path: "/automated-onboarding"
      fullPath: "/tenants/$slug/settings/automated-onboarding"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsAutomatedOnboardingRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsRoute
    }
    "/_authed/tenants/$slug/settings/branding": {
      id: "/_authed/tenants/$slug/settings/branding"
      path: "/branding"
      fullPath: "/tenants/$slug/settings/branding"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsBrandingRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsRoute
    }
    "/_authed/tenants/$slug/settings/danger-zone": {
      id: "/_authed/tenants/$slug/settings/danger-zone"
      path: "/danger-zone"
      fullPath: "/tenants/$slug/settings/danger-zone"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsDangerZoneRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsRoute
    }
    "/_authed/tenants/$slug/settings/delegation": {
      id: "/_authed/tenants/$slug/settings/delegation"
      path: "/delegation"
      fullPath: "/tenants/$slug/settings/delegation"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsDelegationRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsRoute
    }
    "/_authed/tenants/$slug/settings/identity-matching": {
      id: "/_authed/tenants/$slug/settings/identity-matching"
      path: "/identity-matching"
      fullPath: "/tenants/$slug/settings/identity-matching"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsIdentityMatchingRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsRoute
    }
    "/_authed/tenants/$slug/settings/notifications": {
      id: "/_authed/tenants/$slug/settings/notifications"
      path: "/notifications"
      fullPath: "/tenants/$slug/settings/notifications"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsNotificationsRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsRoute
    }
    "/_authed/tenants/$slug/settings/product-areas": {
      id: "/_authed/tenants/$slug/settings/product-areas"
      path: "/product-areas"
      fullPath: "/tenants/$slug/settings/product-areas"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsProductAreasRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsRoute
    }
    "/_authed/tenants/$slug/settings/provisioning": {
      id: "/_authed/tenants/$slug/settings/provisioning"
      path: "/provisioning"
      fullPath: "/tenants/$slug/settings/provisioning"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsProvisioningRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsRoute
    }
    "/_authed/tenants/$slug/settings/rp": {
      id: "/_authed/tenants/$slug/settings/rp"
      path: "/rp"
      fullPath: "/tenants/$slug/settings/rp"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsRpRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsRoute
    }
    "/_authed/tenants/$slug/users/": {
      id: "/_authed/tenants/$slug/users/"
      path: "/users"
      fullPath: "/tenants/$slug/users/"
      preLoaderRoute: typeof AuthedTenantsSlugUsersIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/users/$userId": {
      id: "/_authed/tenants/$slug/users/$userId"
      path: "/users/$userId"
      fullPath: "/tenants/$slug/users/$userId"
      preLoaderRoute: typeof AuthedTenantsSlugUsersUserIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/users/imports": {
      id: "/_authed/tenants/$slug/users/imports"
      path: "/users/imports"
      fullPath: "/tenants/$slug/users/imports"
      preLoaderRoute: typeof AuthedTenantsSlugUsersImportsRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/webhooks/": {
      id: "/_authed/tenants/$slug/webhooks/"
      path: "/webhooks"
      fullPath: "/tenants/$slug/webhooks/"
      preLoaderRoute: typeof AuthedTenantsSlugWebhooksIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/webhooks/$webhookId": {
      id: "/_authed/tenants/$slug/webhooks/$webhookId"
      path: "/webhooks/$webhookId"
      fullPath: "/tenants/$slug/webhooks/$webhookId"
      preLoaderRoute: typeof AuthedTenantsSlugWebhooksWebhookIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/webhooks/new": {
      id: "/_authed/tenants/$slug/webhooks/new"
      path: "/webhooks/new"
      fullPath: "/tenants/$slug/webhooks/new"
      preLoaderRoute: typeof AuthedTenantsSlugWebhooksNewRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/workload-issuers/": {
      id: "/_authed/tenants/$slug/workload-issuers/"
      path: "/workload-issuers"
      fullPath: "/tenants/$slug/workload-issuers/"
      preLoaderRoute: typeof AuthedTenantsSlugWorkloadIssuersIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/t/$slug/recoveries/attest/$requestId": {
      id: "/t/$slug/recoveries/attest/$requestId"
      path: "/t/$slug/recoveries/attest/$requestId"
      fullPath: "/t/$slug/recoveries/attest/$requestId"
      preLoaderRoute: typeof TSlugRecoveriesAttestRequestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/tenants/$slug/access-governance/credential-recovery/": {
      id: "/_authed/tenants/$slug/access-governance/credential-recovery/"
      path: "/access-governance/credential-recovery"
      fullPath: "/tenants/$slug/access-governance/credential-recovery/"
      preLoaderRoute: typeof AuthedTenantsSlugAccessGovernanceCredentialRecoveryIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/access-governance/credential-recovery/$requestId": {
      id: "/_authed/tenants/$slug/access-governance/credential-recovery/$requestId"
      path: "/access-governance/credential-recovery/$requestId"
      fullPath: "/tenants/$slug/access-governance/credential-recovery/$requestId"
      preLoaderRoute: typeof AuthedTenantsSlugAccessGovernanceCredentialRecoveryRequestIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/agents/$agentId/policy": {
      id: "/_authed/tenants/$slug/agents/$agentId/policy"
      path: "/policy"
      fullPath: "/tenants/$slug/agents/$agentId/policy"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsAgentIdPolicyRouteImport
      parentRoute: typeof AuthedTenantsSlugAgentsAgentIdRoute
    }
    "/_authed/tenants/$slug/agents/guide/$type": {
      id: "/_authed/tenants/$slug/agents/guide/$type"
      path: "/$type"
      fullPath: "/tenants/$slug/agents/guide/$type"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsGuideTypeRouteImport
      parentRoute: typeof AuthedTenantsSlugAgentsGuideRoute
    }
    "/_authed/tenants/$slug/agents/integrate/": {
      id: "/_authed/tenants/$slug/agents/integrate/"
      path: "/"
      fullPath: "/tenants/$slug/agents/integrate/"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsIntegrateIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugAgentsIntegrateRoute
    }
    "/_authed/tenants/$slug/agents/integrate/api": {
      id: "/_authed/tenants/$slug/agents/integrate/api"
      path: "/api"
      fullPath: "/tenants/$slug/agents/integrate/api"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsIntegrateApiRouteImport
      parentRoute: typeof AuthedTenantsSlugAgentsIntegrateRoute
    }
    "/_authed/tenants/$slug/agents/integrate/go-sdk": {
      id: "/_authed/tenants/$slug/agents/integrate/go-sdk"
      path: "/go-sdk"
      fullPath: "/tenants/$slug/agents/integrate/go-sdk"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsIntegrateGoSdkRouteImport
      parentRoute: typeof AuthedTenantsSlugAgentsIntegrateRoute
    }
    "/_authed/tenants/$slug/agents/integrate/protect": {
      id: "/_authed/tenants/$slug/agents/integrate/protect"
      path: "/protect"
      fullPath: "/tenants/$slug/agents/integrate/protect"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsIntegrateProtectRouteImport
      parentRoute: typeof AuthedTenantsSlugAgentsIntegrateRoute
    }
    "/_authed/tenants/$slug/applications/dynamic-registration/": {
      id: "/_authed/tenants/$slug/applications/dynamic-registration/"
      path: "/applications/dynamic-registration"
      fullPath: "/tenants/$slug/applications/dynamic-registration/"
      preLoaderRoute: typeof AuthedTenantsSlugApplicationsDynamicRegistrationIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/authentication/authenticators/": {
      id: "/_authed/tenants/$slug/authentication/authenticators/"
      path: "/"
      fullPath: "/tenants/$slug/authentication/authenticators/"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationAuthenticatorsIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationAuthenticatorsRoute
    }
    "/_authed/tenants/$slug/authentication/authenticators/identity-checks": {
      id: "/_authed/tenants/$slug/authentication/authenticators/identity-checks"
      path: "/identity-checks"
      fullPath: "/tenants/$slug/authentication/authenticators/identity-checks"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationAuthenticatorsIdentityChecksRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationAuthenticatorsRoute
    }
    "/_authed/tenants/$slug/authentication/authenticators/new": {
      id: "/_authed/tenants/$slug/authentication/authenticators/new"
      path: "/new"
      fullPath: "/tenants/$slug/authentication/authenticators/new"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationAuthenticatorsNewRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationAuthenticatorsRoute
    }
    "/_authed/tenants/$slug/authentication/conditional-access/": {
      id: "/_authed/tenants/$slug/authentication/conditional-access/"
      path: "/conditional-access"
      fullPath: "/tenants/$slug/authentication/conditional-access/"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationConditionalAccessIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationRoute
    }
    "/_authed/tenants/$slug/authentication/conditional-access/$policyId": {
      id: "/_authed/tenants/$slug/authentication/conditional-access/$policyId"
      path: "/conditional-access/$policyId"
      fullPath: "/tenants/$slug/authentication/conditional-access/$policyId"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationConditionalAccessPolicyIdRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationRoute
    }
    "/_authed/tenants/$slug/authentication/conditional-access/new": {
      id: "/_authed/tenants/$slug/authentication/conditional-access/new"
      path: "/conditional-access/new"
      fullPath: "/tenants/$slug/authentication/conditional-access/new"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationConditionalAccessNewRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationRoute
    }
    "/_authed/tenants/$slug/authentication/locations/new": {
      id: "/_authed/tenants/$slug/authentication/locations/new"
      path: "/locations/new"
      fullPath: "/tenants/$slug/authentication/locations/new"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationLocationsNewRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationRoute
    }
    "/_authed/tenants/$slug/authentication/sign-in/": {
      id: "/_authed/tenants/$slug/authentication/sign-in/"
      path: "/"
      fullPath: "/tenants/$slug/authentication/sign-in/"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationSignInIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationSignInRoute
    }
    "/_authed/tenants/$slug/authentication/sign-in/methods": {
      id: "/_authed/tenants/$slug/authentication/sign-in/methods"
      path: "/methods"
      fullPath: "/tenants/$slug/authentication/sign-in/methods"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationSignInMethodsRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationSignInRoute
    }
    "/_authed/tenants/$slug/authentication/sign-in/passkeys": {
      id: "/_authed/tenants/$slug/authentication/sign-in/passkeys"
      path: "/passkeys"
      fullPath: "/tenants/$slug/authentication/sign-in/passkeys"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationSignInPasskeysRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationSignInRoute
    }
    "/_authed/tenants/$slug/authentication/sign-in/phone": {
      id: "/_authed/tenants/$slug/authentication/sign-in/phone"
      path: "/phone"
      fullPath: "/tenants/$slug/authentication/sign-in/phone"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationSignInPhoneRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationSignInRoute
    }
    "/_authed/tenants/$slug/authentication/sign-in/recovery": {
      id: "/_authed/tenants/$slug/authentication/sign-in/recovery"
      path: "/recovery"
      fullPath: "/tenants/$slug/authentication/sign-in/recovery"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationSignInRecoveryRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationSignInRoute
    }
    "/_authed/tenants/$slug/authentication/sign-in/sessions": {
      id: "/_authed/tenants/$slug/authentication/sign-in/sessions"
      path: "/sessions"
      fullPath: "/tenants/$slug/authentication/sign-in/sessions"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationSignInSessionsRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationSignInRoute
    }
    "/_authed/tenants/$slug/compliance/controls/$catalogId": {
      id: "/_authed/tenants/$slug/compliance/controls/$catalogId"
      path: "/compliance/controls/$catalogId"
      fullPath: "/tenants/$slug/compliance/controls/$catalogId"
      preLoaderRoute: typeof AuthedTenantsSlugComplianceControlsCatalogIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/directory/ad-inbound/": {
      id: "/_authed/tenants/$slug/directory/ad-inbound/"
      path: "/directory/ad-inbound"
      fullPath: "/tenants/$slug/directory/ad-inbound/"
      preLoaderRoute: typeof AuthedTenantsSlugDirectoryAdInboundIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/directory/ad-inbound/$directoryId": {
      id: "/_authed/tenants/$slug/directory/ad-inbound/$directoryId"
      path: "/directory/ad-inbound/$directoryId"
      fullPath: "/tenants/$slug/directory/ad-inbound/$directoryId"
      preLoaderRoute: typeof AuthedTenantsSlugDirectoryAdInboundDirectoryIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/directory/ad-inbound/new": {
      id: "/_authed/tenants/$slug/directory/ad-inbound/new"
      path: "/directory/ad-inbound/new"
      fullPath: "/tenants/$slug/directory/ad-inbound/new"
      preLoaderRoute: typeof AuthedTenantsSlugDirectoryAdInboundNewRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/directory/ad-inbound/new-workday": {
      id: "/_authed/tenants/$slug/directory/ad-inbound/new-workday"
      path: "/directory/ad-inbound/new-workday"
      fullPath: "/tenants/$slug/directory/ad-inbound/new-workday"
      preLoaderRoute: typeof AuthedTenantsSlugDirectoryAdInboundNewWorkdayRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/posture/compliance/": {
      id: "/_authed/tenants/$slug/posture/compliance/"
      path: "/posture/compliance"
      fullPath: "/tenants/$slug/posture/compliance/"
      preLoaderRoute: typeof AuthedTenantsSlugPostureComplianceIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/security/frontline/": {
      id: "/_authed/tenants/$slug/security/frontline/"
      path: "/security/frontline"
      fullPath: "/tenants/$slug/security/frontline/"
      preLoaderRoute: typeof AuthedTenantsSlugSecurityFrontlineIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/security/frontline/badge-signin": {
      id: "/_authed/tenants/$slug/security/frontline/badge-signin"
      path: "/security/frontline/badge-signin"
      fullPath: "/tenants/$slug/security/frontline/badge-signin"
      preLoaderRoute: typeof AuthedTenantsSlugSecurityFrontlineBadgeSigninRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/security/frontline/kiosk-pass": {
      id: "/_authed/tenants/$slug/security/frontline/kiosk-pass"
      path: "/security/frontline/kiosk-pass"
      fullPath: "/tenants/$slug/security/frontline/kiosk-pass"
      preLoaderRoute: typeof AuthedTenantsSlugSecurityFrontlineKioskPassRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/security/logon-certificates/": {
      id: "/_authed/tenants/$slug/security/logon-certificates/"
      path: "/security/logon-certificates"
      fullPath: "/tenants/$slug/security/logon-certificates/"
      preLoaderRoute: typeof AuthedTenantsSlugSecurityLogonCertificatesIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/settings/product-areas/": {
      id: "/_authed/tenants/$slug/settings/product-areas/"
      path: "/"
      fullPath: "/tenants/$slug/settings/product-areas/"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsProductAreasIndexRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsProductAreasRoute
    }
    "/_authed/tenants/$slug/settings/product-areas/reconciliation": {
      id: "/_authed/tenants/$slug/settings/product-areas/reconciliation"
      path: "/reconciliation"
      fullPath: "/tenants/$slug/settings/product-areas/reconciliation"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsProductAreasReconciliationRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsProductAreasRoute
    }
    "/_authed/tenants/$slug/webhooks/$webhookId/edit": {
      id: "/_authed/tenants/$slug/webhooks/$webhookId/edit"
      path: "/edit"
      fullPath: "/tenants/$slug/webhooks/$webhookId/edit"
      preLoaderRoute: typeof AuthedTenantsSlugWebhooksWebhookIdEditRouteImport
      parentRoute: typeof AuthedTenantsSlugWebhooksWebhookIdRoute
    }
    "/_authed/tenants/$slug/agents/protected-resources/$resource/custody": {
      id: "/_authed/tenants/$slug/agents/protected-resources/$resource/custody"
      path: "/$resource/custody"
      fullPath: "/tenants/$slug/agents/protected-resources/$resource/custody"
      preLoaderRoute: typeof AuthedTenantsSlugAgentsProtectedResourcesResourceCustodyRouteImport
      parentRoute: typeof AuthedTenantsSlugAgentsProtectedResourcesRoute
    }
    "/_authed/tenants/$slug/authentication/conditional-access/app-access/$appId": {
      id: "/_authed/tenants/$slug/authentication/conditional-access/app-access/$appId"
      path: "/conditional-access/app-access/$appId"
      fullPath: "/tenants/$slug/authentication/conditional-access/app-access/$appId"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationConditionalAccessAppAccessAppIdRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationRoute
    }
    "/_authed/tenants/$slug/authentication/locations/$id/edit": {
      id: "/_authed/tenants/$slug/authentication/locations/$id/edit"
      path: "/locations/$id/edit"
      fullPath: "/tenants/$slug/authentication/locations/$id/edit"
      preLoaderRoute: typeof AuthedTenantsSlugAuthenticationLocationsIdEditRouteImport
      parentRoute: typeof AuthedTenantsSlugAuthenticationRoute
    }
    "/_authed/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion": {
      id: "/_authed/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion"
      path: "/compliance/frameworks/$frameworkId/$frameworkVersion"
      fullPath: "/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion"
      preLoaderRoute: typeof AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/posture/compliance/controls/$catalogId": {
      id: "/_authed/tenants/$slug/posture/compliance/controls/$catalogId"
      path: "/posture/compliance/controls/$catalogId"
      fullPath: "/tenants/$slug/posture/compliance/controls/$catalogId"
      preLoaderRoute: typeof AuthedTenantsSlugPostureComplianceControlsCatalogIdRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/posture/compliance/reports/$kind": {
      id: "/_authed/tenants/$slug/posture/compliance/reports/$kind"
      path: "/posture/compliance/reports/$kind"
      fullPath: "/tenants/$slug/posture/compliance/reports/$kind"
      preLoaderRoute: typeof AuthedTenantsSlugPostureComplianceReportsKindRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/security/logon-certificates/$forest/trust": {
      id: "/_authed/tenants/$slug/security/logon-certificates/$forest/trust"
      path: "/security/logon-certificates/$forest/trust"
      fullPath: "/tenants/$slug/security/logon-certificates/$forest/trust"
      preLoaderRoute: typeof AuthedTenantsSlugSecurityLogonCertificatesForestTrustRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/settings/product-areas/$area/setup": {
      id: "/_authed/tenants/$slug/settings/product-areas/$area/setup"
      path: "/$area/setup"
      fullPath: "/tenants/$slug/settings/product-areas/$area/setup"
      preLoaderRoute: typeof AuthedTenantsSlugSettingsProductAreasAreaSetupRouteImport
      parentRoute: typeof AuthedTenantsSlugSettingsProductAreasRoute
    }
    "/_authed/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion/readiness": {
      id: "/_authed/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion/readiness"
      path: "/readiness"
      fullPath: "/tenants/$slug/compliance/frameworks/$frameworkId/$frameworkVersion/readiness"
      preLoaderRoute: typeof AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionReadinessRouteImport
      parentRoute: typeof AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRoute
    }
    "/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion": {
      id: "/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion"
      path: "/posture/compliance/frameworks/$frameworkId/$frameworkVersion"
      fullPath: "/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion"
      preLoaderRoute: typeof AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteImport
      parentRoute: typeof AuthedTenantsSlugRoute
    }
    "/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion/readiness": {
      id: "/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion/readiness"
      path: "/readiness"
      fullPath: "/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion/readiness"
      preLoaderRoute: typeof AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionReadinessRouteImport
      parentRoute: typeof AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRoute
    }
  }
}

interface AuthedTenantRecordsSlugRouteChildren {
  AuthedTenantRecordsSlugAccessRoute: typeof AuthedTenantRecordsSlugAccessRoute
  AuthedTenantRecordsSlugEnrollmentIssuersRoute: typeof AuthedTenantRecordsSlugEnrollmentIssuersRoute
  AuthedTenantRecordsSlugSubscriptionRoute: typeof AuthedTenantRecordsSlugSubscriptionRoute
  AuthedTenantRecordsSlugIndexRoute: typeof AuthedTenantRecordsSlugIndexRoute
  AuthedTenantRecordsSlugAdministratorsInviteRoute: typeof AuthedTenantRecordsSlugAdministratorsInviteRoute
  AuthedTenantRecordsSlugAdministratorsIndexRoute: typeof AuthedTenantRecordsSlugAdministratorsIndexRoute
}

const AuthedTenantRecordsSlugRouteChildren: AuthedTenantRecordsSlugRouteChildren =
  {
    AuthedTenantRecordsSlugAccessRoute: AuthedTenantRecordsSlugAccessRoute,
    AuthedTenantRecordsSlugEnrollmentIssuersRoute:
      AuthedTenantRecordsSlugEnrollmentIssuersRoute,
    AuthedTenantRecordsSlugSubscriptionRoute:
      AuthedTenantRecordsSlugSubscriptionRoute,
    AuthedTenantRecordsSlugIndexRoute: AuthedTenantRecordsSlugIndexRoute,
    AuthedTenantRecordsSlugAdministratorsInviteRoute:
      AuthedTenantRecordsSlugAdministratorsInviteRoute,
    AuthedTenantRecordsSlugAdministratorsIndexRoute:
      AuthedTenantRecordsSlugAdministratorsIndexRoute,
  }

const AuthedTenantRecordsSlugRouteWithChildren =
  AuthedTenantRecordsSlugRoute._addFileChildren(
    AuthedTenantRecordsSlugRouteChildren,
  )

interface AuthedTenantsSlugAuthenticationAuthenticatorsRouteChildren {
  AuthedTenantsSlugAuthenticationAuthenticatorsIdentityChecksRoute: typeof AuthedTenantsSlugAuthenticationAuthenticatorsIdentityChecksRoute
  AuthedTenantsSlugAuthenticationAuthenticatorsNewRoute: typeof AuthedTenantsSlugAuthenticationAuthenticatorsNewRoute
  AuthedTenantsSlugAuthenticationAuthenticatorsIndexRoute: typeof AuthedTenantsSlugAuthenticationAuthenticatorsIndexRoute
}

const AuthedTenantsSlugAuthenticationAuthenticatorsRouteChildren: AuthedTenantsSlugAuthenticationAuthenticatorsRouteChildren =
  {
    AuthedTenantsSlugAuthenticationAuthenticatorsIdentityChecksRoute:
      AuthedTenantsSlugAuthenticationAuthenticatorsIdentityChecksRoute,
    AuthedTenantsSlugAuthenticationAuthenticatorsNewRoute:
      AuthedTenantsSlugAuthenticationAuthenticatorsNewRoute,
    AuthedTenantsSlugAuthenticationAuthenticatorsIndexRoute:
      AuthedTenantsSlugAuthenticationAuthenticatorsIndexRoute,
  }

const AuthedTenantsSlugAuthenticationAuthenticatorsRouteWithChildren =
  AuthedTenantsSlugAuthenticationAuthenticatorsRoute._addFileChildren(
    AuthedTenantsSlugAuthenticationAuthenticatorsRouteChildren,
  )

interface AuthedTenantsSlugAuthenticationSignInRouteChildren {
  AuthedTenantsSlugAuthenticationSignInMethodsRoute: typeof AuthedTenantsSlugAuthenticationSignInMethodsRoute
  AuthedTenantsSlugAuthenticationSignInPasskeysRoute: typeof AuthedTenantsSlugAuthenticationSignInPasskeysRoute
  AuthedTenantsSlugAuthenticationSignInPhoneRoute: typeof AuthedTenantsSlugAuthenticationSignInPhoneRoute
  AuthedTenantsSlugAuthenticationSignInRecoveryRoute: typeof AuthedTenantsSlugAuthenticationSignInRecoveryRoute
  AuthedTenantsSlugAuthenticationSignInSessionsRoute: typeof AuthedTenantsSlugAuthenticationSignInSessionsRoute
  AuthedTenantsSlugAuthenticationSignInIndexRoute: typeof AuthedTenantsSlugAuthenticationSignInIndexRoute
}

const AuthedTenantsSlugAuthenticationSignInRouteChildren: AuthedTenantsSlugAuthenticationSignInRouteChildren =
  {
    AuthedTenantsSlugAuthenticationSignInMethodsRoute:
      AuthedTenantsSlugAuthenticationSignInMethodsRoute,
    AuthedTenantsSlugAuthenticationSignInPasskeysRoute:
      AuthedTenantsSlugAuthenticationSignInPasskeysRoute,
    AuthedTenantsSlugAuthenticationSignInPhoneRoute:
      AuthedTenantsSlugAuthenticationSignInPhoneRoute,
    AuthedTenantsSlugAuthenticationSignInRecoveryRoute:
      AuthedTenantsSlugAuthenticationSignInRecoveryRoute,
    AuthedTenantsSlugAuthenticationSignInSessionsRoute:
      AuthedTenantsSlugAuthenticationSignInSessionsRoute,
    AuthedTenantsSlugAuthenticationSignInIndexRoute:
      AuthedTenantsSlugAuthenticationSignInIndexRoute,
  }

const AuthedTenantsSlugAuthenticationSignInRouteWithChildren =
  AuthedTenantsSlugAuthenticationSignInRoute._addFileChildren(
    AuthedTenantsSlugAuthenticationSignInRouteChildren,
  )

interface AuthedTenantsSlugAuthenticationRouteChildren {
  AuthedTenantsSlugAuthenticationAuthenticatorsRoute: typeof AuthedTenantsSlugAuthenticationAuthenticatorsRouteWithChildren
  AuthedTenantsSlugAuthenticationFederationRoute: typeof AuthedTenantsSlugAuthenticationFederationRoute
  AuthedTenantsSlugAuthenticationSignInRoute: typeof AuthedTenantsSlugAuthenticationSignInRouteWithChildren
  AuthedTenantsSlugAuthenticationIndexRoute: typeof AuthedTenantsSlugAuthenticationIndexRoute
  AuthedTenantsSlugAuthenticationConditionalAccessPolicyIdRoute: typeof AuthedTenantsSlugAuthenticationConditionalAccessPolicyIdRoute
  AuthedTenantsSlugAuthenticationConditionalAccessNewRoute: typeof AuthedTenantsSlugAuthenticationConditionalAccessNewRoute
  AuthedTenantsSlugAuthenticationLocationsNewRoute: typeof AuthedTenantsSlugAuthenticationLocationsNewRoute
  AuthedTenantsSlugAuthenticationConditionalAccessIndexRoute: typeof AuthedTenantsSlugAuthenticationConditionalAccessIndexRoute
  AuthedTenantsSlugAuthenticationConditionalAccessAppAccessAppIdRoute: typeof AuthedTenantsSlugAuthenticationConditionalAccessAppAccessAppIdRoute
  AuthedTenantsSlugAuthenticationLocationsIdEditRoute: typeof AuthedTenantsSlugAuthenticationLocationsIdEditRoute
}

const AuthedTenantsSlugAuthenticationRouteChildren: AuthedTenantsSlugAuthenticationRouteChildren =
  {
    AuthedTenantsSlugAuthenticationAuthenticatorsRoute:
      AuthedTenantsSlugAuthenticationAuthenticatorsRouteWithChildren,
    AuthedTenantsSlugAuthenticationFederationRoute:
      AuthedTenantsSlugAuthenticationFederationRoute,
    AuthedTenantsSlugAuthenticationSignInRoute:
      AuthedTenantsSlugAuthenticationSignInRouteWithChildren,
    AuthedTenantsSlugAuthenticationIndexRoute:
      AuthedTenantsSlugAuthenticationIndexRoute,
    AuthedTenantsSlugAuthenticationConditionalAccessPolicyIdRoute:
      AuthedTenantsSlugAuthenticationConditionalAccessPolicyIdRoute,
    AuthedTenantsSlugAuthenticationConditionalAccessNewRoute:
      AuthedTenantsSlugAuthenticationConditionalAccessNewRoute,
    AuthedTenantsSlugAuthenticationLocationsNewRoute:
      AuthedTenantsSlugAuthenticationLocationsNewRoute,
    AuthedTenantsSlugAuthenticationConditionalAccessIndexRoute:
      AuthedTenantsSlugAuthenticationConditionalAccessIndexRoute,
    AuthedTenantsSlugAuthenticationConditionalAccessAppAccessAppIdRoute:
      AuthedTenantsSlugAuthenticationConditionalAccessAppAccessAppIdRoute,
    AuthedTenantsSlugAuthenticationLocationsIdEditRoute:
      AuthedTenantsSlugAuthenticationLocationsIdEditRoute,
  }

const AuthedTenantsSlugAuthenticationRouteWithChildren =
  AuthedTenantsSlugAuthenticationRoute._addFileChildren(
    AuthedTenantsSlugAuthenticationRouteChildren,
  )

interface AuthedTenantsSlugSettingsProductAreasRouteChildren {
  AuthedTenantsSlugSettingsProductAreasReconciliationRoute: typeof AuthedTenantsSlugSettingsProductAreasReconciliationRoute
  AuthedTenantsSlugSettingsProductAreasIndexRoute: typeof AuthedTenantsSlugSettingsProductAreasIndexRoute
  AuthedTenantsSlugSettingsProductAreasAreaSetupRoute: typeof AuthedTenantsSlugSettingsProductAreasAreaSetupRoute
}

const AuthedTenantsSlugSettingsProductAreasRouteChildren: AuthedTenantsSlugSettingsProductAreasRouteChildren =
  {
    AuthedTenantsSlugSettingsProductAreasReconciliationRoute:
      AuthedTenantsSlugSettingsProductAreasReconciliationRoute,
    AuthedTenantsSlugSettingsProductAreasIndexRoute:
      AuthedTenantsSlugSettingsProductAreasIndexRoute,
    AuthedTenantsSlugSettingsProductAreasAreaSetupRoute:
      AuthedTenantsSlugSettingsProductAreasAreaSetupRoute,
  }

const AuthedTenantsSlugSettingsProductAreasRouteWithChildren =
  AuthedTenantsSlugSettingsProductAreasRoute._addFileChildren(
    AuthedTenantsSlugSettingsProductAreasRouteChildren,
  )

interface AuthedTenantsSlugSettingsRouteChildren {
  AuthedTenantsSlugSettingsAutomatedOnboardingRoute: typeof AuthedTenantsSlugSettingsAutomatedOnboardingRoute
  AuthedTenantsSlugSettingsBrandingRoute: typeof AuthedTenantsSlugSettingsBrandingRoute
  AuthedTenantsSlugSettingsDangerZoneRoute: typeof AuthedTenantsSlugSettingsDangerZoneRoute
  AuthedTenantsSlugSettingsDelegationRoute: typeof AuthedTenantsSlugSettingsDelegationRoute
  AuthedTenantsSlugSettingsIdentityMatchingRoute: typeof AuthedTenantsSlugSettingsIdentityMatchingRoute
  AuthedTenantsSlugSettingsNotificationsRoute: typeof AuthedTenantsSlugSettingsNotificationsRoute
  AuthedTenantsSlugSettingsProductAreasRoute: typeof AuthedTenantsSlugSettingsProductAreasRouteWithChildren
  AuthedTenantsSlugSettingsProvisioningRoute: typeof AuthedTenantsSlugSettingsProvisioningRoute
  AuthedTenantsSlugSettingsRpRoute: typeof AuthedTenantsSlugSettingsRpRoute
  AuthedTenantsSlugSettingsIndexRoute: typeof AuthedTenantsSlugSettingsIndexRoute
}

const AuthedTenantsSlugSettingsRouteChildren: AuthedTenantsSlugSettingsRouteChildren =
  {
    AuthedTenantsSlugSettingsAutomatedOnboardingRoute:
      AuthedTenantsSlugSettingsAutomatedOnboardingRoute,
    AuthedTenantsSlugSettingsBrandingRoute:
      AuthedTenantsSlugSettingsBrandingRoute,
    AuthedTenantsSlugSettingsDangerZoneRoute:
      AuthedTenantsSlugSettingsDangerZoneRoute,
    AuthedTenantsSlugSettingsDelegationRoute:
      AuthedTenantsSlugSettingsDelegationRoute,
    AuthedTenantsSlugSettingsIdentityMatchingRoute:
      AuthedTenantsSlugSettingsIdentityMatchingRoute,
    AuthedTenantsSlugSettingsNotificationsRoute:
      AuthedTenantsSlugSettingsNotificationsRoute,
    AuthedTenantsSlugSettingsProductAreasRoute:
      AuthedTenantsSlugSettingsProductAreasRouteWithChildren,
    AuthedTenantsSlugSettingsProvisioningRoute:
      AuthedTenantsSlugSettingsProvisioningRoute,
    AuthedTenantsSlugSettingsRpRoute: AuthedTenantsSlugSettingsRpRoute,
    AuthedTenantsSlugSettingsIndexRoute: AuthedTenantsSlugSettingsIndexRoute,
  }

const AuthedTenantsSlugSettingsRouteWithChildren =
  AuthedTenantsSlugSettingsRoute._addFileChildren(
    AuthedTenantsSlugSettingsRouteChildren,
  )

interface AuthedTenantsSlugAgentsAgentIdRouteChildren {
  AuthedTenantsSlugAgentsAgentIdPolicyRoute: typeof AuthedTenantsSlugAgentsAgentIdPolicyRoute
}

const AuthedTenantsSlugAgentsAgentIdRouteChildren: AuthedTenantsSlugAgentsAgentIdRouteChildren =
  {
    AuthedTenantsSlugAgentsAgentIdPolicyRoute:
      AuthedTenantsSlugAgentsAgentIdPolicyRoute,
  }

const AuthedTenantsSlugAgentsAgentIdRouteWithChildren =
  AuthedTenantsSlugAgentsAgentIdRoute._addFileChildren(
    AuthedTenantsSlugAgentsAgentIdRouteChildren,
  )

interface AuthedTenantsSlugAgentsGuideRouteChildren {
  AuthedTenantsSlugAgentsGuideTypeRoute: typeof AuthedTenantsSlugAgentsGuideTypeRoute
}

const AuthedTenantsSlugAgentsGuideRouteChildren: AuthedTenantsSlugAgentsGuideRouteChildren =
  {
    AuthedTenantsSlugAgentsGuideTypeRoute:
      AuthedTenantsSlugAgentsGuideTypeRoute,
  }

const AuthedTenantsSlugAgentsGuideRouteWithChildren =
  AuthedTenantsSlugAgentsGuideRoute._addFileChildren(
    AuthedTenantsSlugAgentsGuideRouteChildren,
  )

interface AuthedTenantsSlugAgentsIntegrateRouteChildren {
  AuthedTenantsSlugAgentsIntegrateApiRoute: typeof AuthedTenantsSlugAgentsIntegrateApiRoute
  AuthedTenantsSlugAgentsIntegrateGoSdkRoute: typeof AuthedTenantsSlugAgentsIntegrateGoSdkRoute
  AuthedTenantsSlugAgentsIntegrateProtectRoute: typeof AuthedTenantsSlugAgentsIntegrateProtectRoute
  AuthedTenantsSlugAgentsIntegrateIndexRoute: typeof AuthedTenantsSlugAgentsIntegrateIndexRoute
}

const AuthedTenantsSlugAgentsIntegrateRouteChildren: AuthedTenantsSlugAgentsIntegrateRouteChildren =
  {
    AuthedTenantsSlugAgentsIntegrateApiRoute:
      AuthedTenantsSlugAgentsIntegrateApiRoute,
    AuthedTenantsSlugAgentsIntegrateGoSdkRoute:
      AuthedTenantsSlugAgentsIntegrateGoSdkRoute,
    AuthedTenantsSlugAgentsIntegrateProtectRoute:
      AuthedTenantsSlugAgentsIntegrateProtectRoute,
    AuthedTenantsSlugAgentsIntegrateIndexRoute:
      AuthedTenantsSlugAgentsIntegrateIndexRoute,
  }

const AuthedTenantsSlugAgentsIntegrateRouteWithChildren =
  AuthedTenantsSlugAgentsIntegrateRoute._addFileChildren(
    AuthedTenantsSlugAgentsIntegrateRouteChildren,
  )

interface AuthedTenantsSlugAgentsProtectedResourcesRouteChildren {
  AuthedTenantsSlugAgentsProtectedResourcesResourceCustodyRoute: typeof AuthedTenantsSlugAgentsProtectedResourcesResourceCustodyRoute
}

const AuthedTenantsSlugAgentsProtectedResourcesRouteChildren: AuthedTenantsSlugAgentsProtectedResourcesRouteChildren =
  {
    AuthedTenantsSlugAgentsProtectedResourcesResourceCustodyRoute:
      AuthedTenantsSlugAgentsProtectedResourcesResourceCustodyRoute,
  }

const AuthedTenantsSlugAgentsProtectedResourcesRouteWithChildren =
  AuthedTenantsSlugAgentsProtectedResourcesRoute._addFileChildren(
    AuthedTenantsSlugAgentsProtectedResourcesRouteChildren,
  )

interface AuthedTenantsSlugWebhooksWebhookIdRouteChildren {
  AuthedTenantsSlugWebhooksWebhookIdEditRoute: typeof AuthedTenantsSlugWebhooksWebhookIdEditRoute
}

const AuthedTenantsSlugWebhooksWebhookIdRouteChildren: AuthedTenantsSlugWebhooksWebhookIdRouteChildren =
  {
    AuthedTenantsSlugWebhooksWebhookIdEditRoute:
      AuthedTenantsSlugWebhooksWebhookIdEditRoute,
  }

const AuthedTenantsSlugWebhooksWebhookIdRouteWithChildren =
  AuthedTenantsSlugWebhooksWebhookIdRoute._addFileChildren(
    AuthedTenantsSlugWebhooksWebhookIdRouteChildren,
  )

interface AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteChildren {
  AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute: typeof AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute
}

const AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteChildren: AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteChildren =
  {
    AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute:
      AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute,
  }

const AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren =
  AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRoute._addFileChildren(
    AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteChildren,
  )

interface AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteChildren {
  AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute: typeof AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute
}

const AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteChildren: AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteChildren =
  {
    AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute:
      AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionReadinessRoute,
  }

const AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren =
  AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRoute._addFileChildren(
    AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteChildren,
  )

interface AuthedTenantsSlugRouteChildren {
  AuthedTenantsSlugAccessRequestsRoute: typeof AuthedTenantsSlugAccessRequestsRoute
  AuthedTenantsSlugAuthenticationRoute: typeof AuthedTenantsSlugAuthenticationRouteWithChildren
  AuthedTenantsSlugEntitlementRoute: typeof AuthedTenantsSlugEntitlementRoute
  AuthedTenantsSlugOauthDynregRoute: typeof AuthedTenantsSlugOauthDynregRoute
  AuthedTenantsSlugSettingsRoute: typeof AuthedTenantsSlugSettingsRouteWithChildren
  AuthedTenantsSlugIndexRoute: typeof AuthedTenantsSlugIndexRoute
  AuthedTenantsSlugAccessGovernanceApprovalPoliciesRoute: typeof AuthedTenantsSlugAccessGovernanceApprovalPoliciesRoute
  AuthedTenantsSlugAccessGovernanceApproversRoute: typeof AuthedTenantsSlugAccessGovernanceApproversRoute
  AuthedTenantsSlugAccessGovernanceHistoryRoute: typeof AuthedTenantsSlugAccessGovernanceHistoryRoute
  AuthedTenantsSlugAccessGovernanceMembershipRoute: typeof AuthedTenantsSlugAccessGovernanceMembershipRoute
  AuthedTenantsSlugAccessGovernancePolicyRoute: typeof AuthedTenantsSlugAccessGovernancePolicyRoute
  AuthedTenantsSlugAccessGovernanceRecoveryRoute: typeof AuthedTenantsSlugAccessGovernanceRecoveryRoute
  AuthedTenantsSlugAdminsDelegatedRoute: typeof AuthedTenantsSlugAdminsDelegatedRoute
  AuthedTenantsSlugAdminsInviteRoute: typeof AuthedTenantsSlugAdminsInviteRoute
  AuthedTenantsSlugAgentsAgentIdRoute: typeof AuthedTenantsSlugAgentsAgentIdRouteWithChildren
  AuthedTenantsSlugAgentsActivityRoute: typeof AuthedTenantsSlugAgentsActivityRoute
  AuthedTenantsSlugAgentsApprovalAnalyticsRoute: typeof AuthedTenantsSlugAgentsApprovalAnalyticsRoute
  AuthedTenantsSlugAgentsApprovalHistoryRoute: typeof AuthedTenantsSlugAgentsApprovalHistoryRoute
  AuthedTenantsSlugAgentsApprovalThresholdsRoute: typeof AuthedTenantsSlugAgentsApprovalThresholdsRoute
  AuthedTenantsSlugAgentsBudgetRaisesRoute: typeof AuthedTenantsSlugAgentsBudgetRaisesRoute
  AuthedTenantsSlugAgentsBudgetResetAnomaliesRoute: typeof AuthedTenantsSlugAgentsBudgetResetAnomaliesRoute
  AuthedTenantsSlugAgentsDecisionReportsRoute: typeof AuthedTenantsSlugAgentsDecisionReportsRoute
  AuthedTenantsSlugAgentsDelegationGovernanceRoute: typeof AuthedTenantsSlugAgentsDelegationGovernanceRoute
  AuthedTenantsSlugAgentsEdgeRoute: typeof AuthedTenantsSlugAgentsEdgeRoute
  AuthedTenantsSlugAgentsGrantsRoute: typeof AuthedTenantsSlugAgentsGrantsRoute
  AuthedTenantsSlugAgentsGuideRoute: typeof AuthedTenantsSlugAgentsGuideRouteWithChildren
  AuthedTenantsSlugAgentsIntegrateRoute: typeof AuthedTenantsSlugAgentsIntegrateRouteWithChildren
  AuthedTenantsSlugAgentsMultiAgentRoute: typeof AuthedTenantsSlugAgentsMultiAgentRoute
  AuthedTenantsSlugAgentsProtectedResourcesRoute: typeof AuthedTenantsSlugAgentsProtectedResourcesRouteWithChildren
  AuthedTenantsSlugAgentsStandingDelegationsRoute: typeof AuthedTenantsSlugAgentsStandingDelegationsRoute
  AuthedTenantsSlugAgentsVirtualKeysRoute: typeof AuthedTenantsSlugAgentsVirtualKeysRoute
  AuthedTenantsSlugApplicationsAppIdRoute: typeof AuthedTenantsSlugApplicationsAppIdRoute
  AuthedTenantsSlugAutomationAccountsIdRoute: typeof AuthedTenantsSlugAutomationAccountsIdRoute
  AuthedTenantsSlugAutomationAccountsNewRoute: typeof AuthedTenantsSlugAutomationAccountsNewRoute
  AuthedTenantsSlugDirectoryAttributesRoute: typeof AuthedTenantsSlugDirectoryAttributesRoute
  AuthedTenantsSlugDirectoryAuthorityRoute: typeof AuthedTenantsSlugDirectoryAuthorityRoute
  AuthedTenantsSlugDirectoryMatchingRoute: typeof AuthedTenantsSlugDirectoryMatchingRoute
  AuthedTenantsSlugDirectoryScimOperationsRoute: typeof AuthedTenantsSlugDirectoryScimOperationsRoute
  AuthedTenantsSlugDirectoryScimTokensRoute: typeof AuthedTenantsSlugDirectoryScimTokensRoute
  AuthedTenantsSlugGroupsGroupIdRoute: typeof AuthedTenantsSlugGroupsGroupIdRoute
  AuthedTenantsSlugGroupsRulesRoute: typeof AuthedTenantsSlugGroupsRulesRoute
  AuthedTenantsSlugNonHumanIdentitiesOverviewRoute: typeof AuthedTenantsSlugNonHumanIdentitiesOverviewRoute
  AuthedTenantsSlugOrganizationsOrgIdRoute: typeof AuthedTenantsSlugOrganizationsOrgIdRoute
  AuthedTenantsSlugOrganizationsNewRoute: typeof AuthedTenantsSlugOrganizationsNewRoute
  AuthedTenantsSlugProvisioningConnectionIdRoute: typeof AuthedTenantsSlugProvisioningConnectionIdRoute
  AuthedTenantsSlugProvisioningNewRoute: typeof AuthedTenantsSlugProvisioningNewRoute
  AuthedTenantsSlugSecurityWorkstationsRoute: typeof AuthedTenantsSlugSecurityWorkstationsRoute
  AuthedTenantsSlugUsersUserIdRoute: typeof AuthedTenantsSlugUsersUserIdRoute
  AuthedTenantsSlugUsersImportsRoute: typeof AuthedTenantsSlugUsersImportsRoute
  AuthedTenantsSlugWebhooksWebhookIdRoute: typeof AuthedTenantsSlugWebhooksWebhookIdRouteWithChildren
  AuthedTenantsSlugWebhooksNewRoute: typeof AuthedTenantsSlugWebhooksNewRoute
  AuthedTenantsSlugAccessGovernanceIndexRoute: typeof AuthedTenantsSlugAccessGovernanceIndexRoute
  AuthedTenantsSlugAdminsIndexRoute: typeof AuthedTenantsSlugAdminsIndexRoute
  AuthedTenantsSlugAgentsIndexRoute: typeof AuthedTenantsSlugAgentsIndexRoute
  AuthedTenantsSlugApplicationsIndexRoute: typeof AuthedTenantsSlugApplicationsIndexRoute
  AuthedTenantsSlugAuditIndexRoute: typeof AuthedTenantsSlugAuditIndexRoute
  AuthedTenantsSlugAutomationAccountsIndexRoute: typeof AuthedTenantsSlugAutomationAccountsIndexRoute
  AuthedTenantsSlugComplianceIndexRoute: typeof AuthedTenantsSlugComplianceIndexRoute
  AuthedTenantsSlugDevicesIndexRoute: typeof AuthedTenantsSlugDevicesIndexRoute
  AuthedTenantsSlugDirectoryIndexRoute: typeof AuthedTenantsSlugDirectoryIndexRoute
  AuthedTenantsSlugGettingStartedIndexRoute: typeof AuthedTenantsSlugGettingStartedIndexRoute
  AuthedTenantsSlugGroupsIndexRoute: typeof AuthedTenantsSlugGroupsIndexRoute
  AuthedTenantsSlugIdentityHygieneIndexRoute: typeof AuthedTenantsSlugIdentityHygieneIndexRoute
  AuthedTenantsSlugLockedOutUsersIndexRoute: typeof AuthedTenantsSlugLockedOutUsersIndexRoute
  AuthedTenantsSlugNonHumanIdentitiesIndexRoute: typeof AuthedTenantsSlugNonHumanIdentitiesIndexRoute
  AuthedTenantsSlugOnboardingAutotuneIndexRoute: typeof AuthedTenantsSlugOnboardingAutotuneIndexRoute
  AuthedTenantsSlugOnboardingHealthIndexRoute: typeof AuthedTenantsSlugOnboardingHealthIndexRoute
  AuthedTenantsSlugOrganizationsIndexRoute: typeof AuthedTenantsSlugOrganizationsIndexRoute
  AuthedTenantsSlugPasskeyIntelligenceIndexRoute: typeof AuthedTenantsSlugPasskeyIntelligenceIndexRoute
  AuthedTenantsSlugPasskeysIndexRoute: typeof AuthedTenantsSlugPasskeysIndexRoute
  AuthedTenantsSlugProvisioningIndexRoute: typeof AuthedTenantsSlugProvisioningIndexRoute
  AuthedTenantsSlugUsersIndexRoute: typeof AuthedTenantsSlugUsersIndexRoute
  AuthedTenantsSlugWebhooksIndexRoute: typeof AuthedTenantsSlugWebhooksIndexRoute
  AuthedTenantsSlugWorkloadIssuersIndexRoute: typeof AuthedTenantsSlugWorkloadIssuersIndexRoute
  AuthedTenantsSlugAccessGovernanceCredentialRecoveryRequestIdRoute: typeof AuthedTenantsSlugAccessGovernanceCredentialRecoveryRequestIdRoute
  AuthedTenantsSlugComplianceControlsCatalogIdRoute: typeof AuthedTenantsSlugComplianceControlsCatalogIdRoute
  AuthedTenantsSlugDirectoryAdInboundDirectoryIdRoute: typeof AuthedTenantsSlugDirectoryAdInboundDirectoryIdRoute
  AuthedTenantsSlugDirectoryAdInboundNewRoute: typeof AuthedTenantsSlugDirectoryAdInboundNewRoute
  AuthedTenantsSlugDirectoryAdInboundNewWorkdayRoute: typeof AuthedTenantsSlugDirectoryAdInboundNewWorkdayRoute
  AuthedTenantsSlugSecurityFrontlineBadgeSigninRoute: typeof AuthedTenantsSlugSecurityFrontlineBadgeSigninRoute
  AuthedTenantsSlugSecurityFrontlineKioskPassRoute: typeof AuthedTenantsSlugSecurityFrontlineKioskPassRoute
  AuthedTenantsSlugAccessGovernanceCredentialRecoveryIndexRoute: typeof AuthedTenantsSlugAccessGovernanceCredentialRecoveryIndexRoute
  AuthedTenantsSlugApplicationsDynamicRegistrationIndexRoute: typeof AuthedTenantsSlugApplicationsDynamicRegistrationIndexRoute
  AuthedTenantsSlugDirectoryAdInboundIndexRoute: typeof AuthedTenantsSlugDirectoryAdInboundIndexRoute
  AuthedTenantsSlugPostureComplianceIndexRoute: typeof AuthedTenantsSlugPostureComplianceIndexRoute
  AuthedTenantsSlugSecurityFrontlineIndexRoute: typeof AuthedTenantsSlugSecurityFrontlineIndexRoute
  AuthedTenantsSlugSecurityLogonCertificatesIndexRoute: typeof AuthedTenantsSlugSecurityLogonCertificatesIndexRoute
  AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRoute: typeof AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren
  AuthedTenantsSlugPostureComplianceControlsCatalogIdRoute: typeof AuthedTenantsSlugPostureComplianceControlsCatalogIdRoute
  AuthedTenantsSlugPostureComplianceReportsKindRoute: typeof AuthedTenantsSlugPostureComplianceReportsKindRoute
  AuthedTenantsSlugSecurityLogonCertificatesForestTrustRoute: typeof AuthedTenantsSlugSecurityLogonCertificatesForestTrustRoute
  AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRoute: typeof AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren
}

const AuthedTenantsSlugRouteChildren: AuthedTenantsSlugRouteChildren = {
  AuthedTenantsSlugAccessRequestsRoute: AuthedTenantsSlugAccessRequestsRoute,
  AuthedTenantsSlugAuthenticationRoute:
    AuthedTenantsSlugAuthenticationRouteWithChildren,
  AuthedTenantsSlugEntitlementRoute: AuthedTenantsSlugEntitlementRoute,
  AuthedTenantsSlugOauthDynregRoute: AuthedTenantsSlugOauthDynregRoute,
  AuthedTenantsSlugSettingsRoute: AuthedTenantsSlugSettingsRouteWithChildren,
  AuthedTenantsSlugIndexRoute: AuthedTenantsSlugIndexRoute,
  AuthedTenantsSlugAccessGovernanceApprovalPoliciesRoute:
    AuthedTenantsSlugAccessGovernanceApprovalPoliciesRoute,
  AuthedTenantsSlugAccessGovernanceApproversRoute:
    AuthedTenantsSlugAccessGovernanceApproversRoute,
  AuthedTenantsSlugAccessGovernanceHistoryRoute:
    AuthedTenantsSlugAccessGovernanceHistoryRoute,
  AuthedTenantsSlugAccessGovernanceMembershipRoute:
    AuthedTenantsSlugAccessGovernanceMembershipRoute,
  AuthedTenantsSlugAccessGovernancePolicyRoute:
    AuthedTenantsSlugAccessGovernancePolicyRoute,
  AuthedTenantsSlugAccessGovernanceRecoveryRoute:
    AuthedTenantsSlugAccessGovernanceRecoveryRoute,
  AuthedTenantsSlugAdminsDelegatedRoute: AuthedTenantsSlugAdminsDelegatedRoute,
  AuthedTenantsSlugAdminsInviteRoute: AuthedTenantsSlugAdminsInviteRoute,
  AuthedTenantsSlugAgentsAgentIdRoute:
    AuthedTenantsSlugAgentsAgentIdRouteWithChildren,
  AuthedTenantsSlugAgentsActivityRoute: AuthedTenantsSlugAgentsActivityRoute,
  AuthedTenantsSlugAgentsApprovalAnalyticsRoute:
    AuthedTenantsSlugAgentsApprovalAnalyticsRoute,
  AuthedTenantsSlugAgentsApprovalHistoryRoute:
    AuthedTenantsSlugAgentsApprovalHistoryRoute,
  AuthedTenantsSlugAgentsApprovalThresholdsRoute:
    AuthedTenantsSlugAgentsApprovalThresholdsRoute,
  AuthedTenantsSlugAgentsBudgetRaisesRoute:
    AuthedTenantsSlugAgentsBudgetRaisesRoute,
  AuthedTenantsSlugAgentsBudgetResetAnomaliesRoute:
    AuthedTenantsSlugAgentsBudgetResetAnomaliesRoute,
  AuthedTenantsSlugAgentsDecisionReportsRoute:
    AuthedTenantsSlugAgentsDecisionReportsRoute,
  AuthedTenantsSlugAgentsDelegationGovernanceRoute:
    AuthedTenantsSlugAgentsDelegationGovernanceRoute,
  AuthedTenantsSlugAgentsEdgeRoute: AuthedTenantsSlugAgentsEdgeRoute,
  AuthedTenantsSlugAgentsGrantsRoute: AuthedTenantsSlugAgentsGrantsRoute,
  AuthedTenantsSlugAgentsGuideRoute:
    AuthedTenantsSlugAgentsGuideRouteWithChildren,
  AuthedTenantsSlugAgentsIntegrateRoute:
    AuthedTenantsSlugAgentsIntegrateRouteWithChildren,
  AuthedTenantsSlugAgentsMultiAgentRoute:
    AuthedTenantsSlugAgentsMultiAgentRoute,
  AuthedTenantsSlugAgentsProtectedResourcesRoute:
    AuthedTenantsSlugAgentsProtectedResourcesRouteWithChildren,
  AuthedTenantsSlugAgentsStandingDelegationsRoute:
    AuthedTenantsSlugAgentsStandingDelegationsRoute,
  AuthedTenantsSlugAgentsVirtualKeysRoute:
    AuthedTenantsSlugAgentsVirtualKeysRoute,
  AuthedTenantsSlugApplicationsAppIdRoute:
    AuthedTenantsSlugApplicationsAppIdRoute,
  AuthedTenantsSlugAutomationAccountsIdRoute:
    AuthedTenantsSlugAutomationAccountsIdRoute,
  AuthedTenantsSlugAutomationAccountsNewRoute:
    AuthedTenantsSlugAutomationAccountsNewRoute,
  AuthedTenantsSlugDirectoryAttributesRoute:
    AuthedTenantsSlugDirectoryAttributesRoute,
  AuthedTenantsSlugDirectoryAuthorityRoute:
    AuthedTenantsSlugDirectoryAuthorityRoute,
  AuthedTenantsSlugDirectoryMatchingRoute:
    AuthedTenantsSlugDirectoryMatchingRoute,
  AuthedTenantsSlugDirectoryScimOperationsRoute:
    AuthedTenantsSlugDirectoryScimOperationsRoute,
  AuthedTenantsSlugDirectoryScimTokensRoute:
    AuthedTenantsSlugDirectoryScimTokensRoute,
  AuthedTenantsSlugGroupsGroupIdRoute: AuthedTenantsSlugGroupsGroupIdRoute,
  AuthedTenantsSlugGroupsRulesRoute: AuthedTenantsSlugGroupsRulesRoute,
  AuthedTenantsSlugNonHumanIdentitiesOverviewRoute:
    AuthedTenantsSlugNonHumanIdentitiesOverviewRoute,
  AuthedTenantsSlugOrganizationsOrgIdRoute:
    AuthedTenantsSlugOrganizationsOrgIdRoute,
  AuthedTenantsSlugOrganizationsNewRoute:
    AuthedTenantsSlugOrganizationsNewRoute,
  AuthedTenantsSlugProvisioningConnectionIdRoute:
    AuthedTenantsSlugProvisioningConnectionIdRoute,
  AuthedTenantsSlugProvisioningNewRoute: AuthedTenantsSlugProvisioningNewRoute,
  AuthedTenantsSlugSecurityWorkstationsRoute:
    AuthedTenantsSlugSecurityWorkstationsRoute,
  AuthedTenantsSlugUsersUserIdRoute: AuthedTenantsSlugUsersUserIdRoute,
  AuthedTenantsSlugUsersImportsRoute: AuthedTenantsSlugUsersImportsRoute,
  AuthedTenantsSlugWebhooksWebhookIdRoute:
    AuthedTenantsSlugWebhooksWebhookIdRouteWithChildren,
  AuthedTenantsSlugWebhooksNewRoute: AuthedTenantsSlugWebhooksNewRoute,
  AuthedTenantsSlugAccessGovernanceIndexRoute:
    AuthedTenantsSlugAccessGovernanceIndexRoute,
  AuthedTenantsSlugAdminsIndexRoute: AuthedTenantsSlugAdminsIndexRoute,
  AuthedTenantsSlugAgentsIndexRoute: AuthedTenantsSlugAgentsIndexRoute,
  AuthedTenantsSlugApplicationsIndexRoute:
    AuthedTenantsSlugApplicationsIndexRoute,
  AuthedTenantsSlugAuditIndexRoute: AuthedTenantsSlugAuditIndexRoute,
  AuthedTenantsSlugAutomationAccountsIndexRoute:
    AuthedTenantsSlugAutomationAccountsIndexRoute,
  AuthedTenantsSlugComplianceIndexRoute: AuthedTenantsSlugComplianceIndexRoute,
  AuthedTenantsSlugDevicesIndexRoute: AuthedTenantsSlugDevicesIndexRoute,
  AuthedTenantsSlugDirectoryIndexRoute: AuthedTenantsSlugDirectoryIndexRoute,
  AuthedTenantsSlugGettingStartedIndexRoute:
    AuthedTenantsSlugGettingStartedIndexRoute,
  AuthedTenantsSlugGroupsIndexRoute: AuthedTenantsSlugGroupsIndexRoute,
  AuthedTenantsSlugIdentityHygieneIndexRoute:
    AuthedTenantsSlugIdentityHygieneIndexRoute,
  AuthedTenantsSlugLockedOutUsersIndexRoute:
    AuthedTenantsSlugLockedOutUsersIndexRoute,
  AuthedTenantsSlugNonHumanIdentitiesIndexRoute:
    AuthedTenantsSlugNonHumanIdentitiesIndexRoute,
  AuthedTenantsSlugOnboardingAutotuneIndexRoute:
    AuthedTenantsSlugOnboardingAutotuneIndexRoute,
  AuthedTenantsSlugOnboardingHealthIndexRoute:
    AuthedTenantsSlugOnboardingHealthIndexRoute,
  AuthedTenantsSlugOrganizationsIndexRoute:
    AuthedTenantsSlugOrganizationsIndexRoute,
  AuthedTenantsSlugPasskeyIntelligenceIndexRoute:
    AuthedTenantsSlugPasskeyIntelligenceIndexRoute,
  AuthedTenantsSlugPasskeysIndexRoute: AuthedTenantsSlugPasskeysIndexRoute,
  AuthedTenantsSlugProvisioningIndexRoute:
    AuthedTenantsSlugProvisioningIndexRoute,
  AuthedTenantsSlugUsersIndexRoute: AuthedTenantsSlugUsersIndexRoute,
  AuthedTenantsSlugWebhooksIndexRoute: AuthedTenantsSlugWebhooksIndexRoute,
  AuthedTenantsSlugWorkloadIssuersIndexRoute:
    AuthedTenantsSlugWorkloadIssuersIndexRoute,
  AuthedTenantsSlugAccessGovernanceCredentialRecoveryRequestIdRoute:
    AuthedTenantsSlugAccessGovernanceCredentialRecoveryRequestIdRoute,
  AuthedTenantsSlugComplianceControlsCatalogIdRoute:
    AuthedTenantsSlugComplianceControlsCatalogIdRoute,
  AuthedTenantsSlugDirectoryAdInboundDirectoryIdRoute:
    AuthedTenantsSlugDirectoryAdInboundDirectoryIdRoute,
  AuthedTenantsSlugDirectoryAdInboundNewRoute:
    AuthedTenantsSlugDirectoryAdInboundNewRoute,
  AuthedTenantsSlugDirectoryAdInboundNewWorkdayRoute:
    AuthedTenantsSlugDirectoryAdInboundNewWorkdayRoute,
  AuthedTenantsSlugSecurityFrontlineBadgeSigninRoute:
    AuthedTenantsSlugSecurityFrontlineBadgeSigninRoute,
  AuthedTenantsSlugSecurityFrontlineKioskPassRoute:
    AuthedTenantsSlugSecurityFrontlineKioskPassRoute,
  AuthedTenantsSlugAccessGovernanceCredentialRecoveryIndexRoute:
    AuthedTenantsSlugAccessGovernanceCredentialRecoveryIndexRoute,
  AuthedTenantsSlugApplicationsDynamicRegistrationIndexRoute:
    AuthedTenantsSlugApplicationsDynamicRegistrationIndexRoute,
  AuthedTenantsSlugDirectoryAdInboundIndexRoute:
    AuthedTenantsSlugDirectoryAdInboundIndexRoute,
  AuthedTenantsSlugPostureComplianceIndexRoute:
    AuthedTenantsSlugPostureComplianceIndexRoute,
  AuthedTenantsSlugSecurityFrontlineIndexRoute:
    AuthedTenantsSlugSecurityFrontlineIndexRoute,
  AuthedTenantsSlugSecurityLogonCertificatesIndexRoute:
    AuthedTenantsSlugSecurityLogonCertificatesIndexRoute,
  AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRoute:
    AuthedTenantsSlugComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren,
  AuthedTenantsSlugPostureComplianceControlsCatalogIdRoute:
    AuthedTenantsSlugPostureComplianceControlsCatalogIdRoute,
  AuthedTenantsSlugPostureComplianceReportsKindRoute:
    AuthedTenantsSlugPostureComplianceReportsKindRoute,
  AuthedTenantsSlugSecurityLogonCertificatesForestTrustRoute:
    AuthedTenantsSlugSecurityLogonCertificatesForestTrustRoute,
  AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRoute:
    AuthedTenantsSlugPostureComplianceFrameworksFrameworkIdFrameworkVersionRouteWithChildren,
}

const AuthedTenantsSlugRouteWithChildren =
  AuthedTenantsSlugRoute._addFileChildren(AuthedTenantsSlugRouteChildren)

interface AuthedRouteChildren {
  AuthedAccountHealthRoute: typeof AuthedAccountHealthRoute
  AuthedPrivateAccessRoute: typeof AuthedPrivateAccessRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAdminsInviteRoute: typeof AuthedAdminsInviteRoute
  AuthedApiKeysNewRoute: typeof AuthedApiKeysNewRoute
  AuthedAutomationAccountsIdRoute: typeof AuthedAutomationAccountsIdRoute
  AuthedAutomationAccountsNewRoute: typeof AuthedAutomationAccountsNewRoute
  AuthedManagedTeamsRoute: typeof AuthedManagedTeamsRoute
  AuthedTenantRecordsSlugRoute: typeof AuthedTenantRecordsSlugRouteWithChildren
  AuthedTenantsSlugRoute: typeof AuthedTenantsSlugRouteWithChildren
  AuthedTenantsNewRoute: typeof AuthedTenantsNewRoute
  AuthedAdminsIndexRoute: typeof AuthedAdminsIndexRoute
  AuthedApiKeysIndexRoute: typeof AuthedApiKeysIndexRoute
  AuthedAuditIndexRoute: typeof AuthedAuditIndexRoute
  AuthedAutomationAccountsIndexRoute: typeof AuthedAutomationAccountsIndexRoute
  AuthedManagedIndexRoute: typeof AuthedManagedIndexRoute
  AuthedTenantsIndexRoute: typeof AuthedTenantsIndexRoute
  AuthedManagedTenantsSlugRoute: typeof AuthedManagedTenantsSlugRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAccountHealthRoute: AuthedAccountHealthRoute,
  AuthedPrivateAccessRoute: AuthedPrivateAccessRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAdminsInviteRoute: AuthedAdminsInviteRoute,
  AuthedApiKeysNewRoute: AuthedApiKeysNewRoute,
  AuthedAutomationAccountsIdRoute: AuthedAutomationAccountsIdRoute,
  AuthedAutomationAccountsNewRoute: AuthedAutomationAccountsNewRoute,
  AuthedManagedTeamsRoute: AuthedManagedTeamsRoute,
  AuthedTenantRecordsSlugRoute: AuthedTenantRecordsSlugRouteWithChildren,
  AuthedTenantsSlugRoute: AuthedTenantsSlugRouteWithChildren,
  AuthedTenantsNewRoute: AuthedTenantsNewRoute,
  AuthedAdminsIndexRoute: AuthedAdminsIndexRoute,
  AuthedApiKeysIndexRoute: AuthedApiKeysIndexRoute,
  AuthedAuditIndexRoute: AuthedAuditIndexRoute,
  AuthedAutomationAccountsIndexRoute: AuthedAutomationAccountsIndexRoute,
  AuthedManagedIndexRoute: AuthedManagedIndexRoute,
  AuthedTenantsIndexRoute: AuthedTenantsIndexRoute,
  AuthedManagedTenantsSlugRoute: AuthedManagedTenantsSlugRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface TSlugLoginRouteChildren {
  TSlugLoginHelpRoute: typeof TSlugLoginHelpRoute
}

const TSlugLoginRouteChildren: TSlugLoginRouteChildren = {
  TSlugLoginHelpRoute: TSlugLoginHelpRoute,
}

const TSlugLoginRouteWithChildren = TSlugLoginRoute._addFileChildren(
  TSlugLoginRouteChildren,
)

interface TSlugRecoveryRouteChildren {
  TSlugRecoveryRequestRoute: typeof TSlugRecoveryRequestRoute
}

const TSlugRecoveryRouteChildren: TSlugRecoveryRouteChildren = {
  TSlugRecoveryRequestRoute: TSlugRecoveryRequestRoute,
}

const TSlugRecoveryRouteWithChildren = TSlugRecoveryRoute._addFileChildren(
  TSlugRecoveryRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  EnrollQrJitRoute: EnrollQrJitRoute,
  LoginRoute: LoginRoute,
  EnrollTokenRoute: EnrollTokenRoute,
  TSlugLoginRoute: TSlugLoginRouteWithChildren,
  TSlugRecoveryRoute: TSlugRecoveryRouteWithChildren,
  TSlugRecoveriesAttestRequestIdRoute: TSlugRecoveriesAttestRequestIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
